<template>
  <div style="text-align:left;">
        <OrdenTrackingModal
      :visible.sync="trackingOpen"
      :orden="orden"
      @cerrar="trackingOpen = false"
      @terminada="onTerminada"
    />
    <!-- <TopNav /> -->
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
    <ModalPerfilProfesional ref="modalPerfil" :categorias="categorias" />

      <div v-if="admin_datos && (admin_datos.user_type === 'property_manager' || admin_datos.user_type === 'jobbing_admin')" class="main-container">
        <div v-if="loaded" class="articulo-principal">
          <!-- Header con Título y Filtro de Fecha -->
          <div class="header-container">
            <h2>Solicitudes de Clientes</h2>
            <div class="date-filter-container">
              <label for="dateFilter" class="date-filter-label">Filtrar por fecha:</label>
              <select id="dateFilter" v-model="dateFilter" @change="fetchSolicitudes" class="date-filter-select">
                <option value="today">Hoy</option>
                <option value="last_7_days">Últimos 7 días</option>
                <option value="last_30_days">Últimos 30 días</option>
                <option value="last_2_months">Hace dos meses</option>
                <option value="last_4_months">Últimos 4 meses</option>
                <option value="last_6_months">Últimos 6 meses</option>
                <option value="last_12_months">Últimos 12 meses</option>
                <option value="all">Todos</option>
              </select>
            </div>
          </div>
        
          Puedes arrastrar la tabla hacia los lados con el cursor para ver más columnas.
           <!-- Search Bar -->
           <div style="margin-top: 10px; margin-bottom: 10px">
            <input
              type="text"
              v-model="searchQuery"
              placeholder="Buscar en comuna, título, estado, dirección o descripción..."
              style="width: 100%; padding: 8px; font-size: 16px;"
            />
          </div>
          <div class="tabs">
    <button
      :class="{'active-tab': currentTab === 'active'}"
      @click="currentTab = 'active'"
    >
      Activas
    </button>
    <button
      :class="{'active-tab': currentTab === 'accion requerida'}"
      @click="currentTab = 'accion requerida'"
    >
      Acción requerida
    </button>
    <button
      :class="{'active-tab': currentTab === 'inactive'}"
      @click="currentTab = 'inactive'"
    >
      Inactivas
    </button>
    <button
      :class="{'active-tab': currentTab === 'eliminadas'}"
      @click="currentTab = 'eliminadas'"
    >
      Eliminadas
    </button>
  </div>

  <!-- Table Container -->
  <div
    class="table-container"
    ref="tableContainer"
    @mousedown="dragStart"
    @mousemove="dragMove"
    @mouseup="dragEnd"
    @mouseleave="dragEnd"
    @touchstart="dragStart"
    @touchmove="dragMove"
    @touchend="dragEnd"
    @touchleave="dragEnd"
    @touchcancel="dragEnd"
  >
    <table class="tablex">
      <thead>
        <tr>
          <!-- Table Headers -->
          <th>ID</th>
          <th>💬</th>
          <th v-if="admin_datos.user_type === 'jobbing_admin'">Empresa</th>
          <th>Etiquedas</th>
          <th>Fecha Solicitud</th>
          <th>Título</th>
          <th>Prioridad</th>
          <th style="min-width: 200px;">Dirección</th>
          <th style="min-width: 200px;">Ubicación Llaves</th>
          <th style="min-width: 320px;">Comentarios</th>
          <th>Estado</th>
          <th>Porcentaje completado</th>
          <th>Atendido por</th>
          <th>Fecha Visita</th>
          <th>Fecha Envío Presupuesto</th>
          <th>Fecha Aprobación</th>
          <th>Fecha Inicio</th>
          <th>Fotos</th>
          <th>Videos</th>
          <th>Comprobante de Pago</th>
          <th>Factura al Cliente</th>
          <th v-if="admin_datos.user_type === 'jobbing_admin'"> <span class="nowrap">Factura del</span> Profesional</th>
          <th style="min-width: 180px;" v-if="admin_datos.user_type === 'jobbing_admin'">
            Monto a Pagar al Profesional
            <div class="custom-tooltip-wrapper">              
              <img                   
                  alt="Pendiente" 
                  class="info-svg" 
                  src="@/assets/iconos/info.svg" 
                />
                <span style="width: 200px;" class="custom-tooltip-text tooltip-down">formula: (1-comision)*(monto aprobados). Cálculo no incluye cuanto le hemos pagado.</span>
              </div>
            
          </th>
          <th style="min-width: 180px;" v-if="admin_datos.user_type === 'jobbing_admin'">
            Monto pagado al profesional
          </th>
          <th><span class="nowrap">Monto Total</span> (con IVA)</th>
          <th><span class="nowrap">Monto Pagado</span> (con IVA)</th>
          <th><span class="nowrap">Monto por Cobrar</span><div style="white-space: nowrap;"> al Cliente (con IVA)</div> </th>
          <th v-if="hasMargenCaptacion()"><span style="white-space: nowrap;">Monto por Cobrar</span> a Jobbing (con IVA)</th>
          <th v-if="hasMargenCaptacion()">Factura hacia Jobbing</th>
          <th>Fecha Calificación</th>
          <th>Calificación</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(solicitud, index) in filteredSolicitudes" >
          <tr
            :title="`Descripción: ${solicitud.descripcion != null ? solicitud.descripcion : 'No especificado'}`"
            @click="toggleDetails('details' + index, $event)"
            @contextmenu.prevent="openContextMenu($event, solicitud)"
          >
            <!-- Table Data -->
            <td>
              <router-link
                class="solicitud-detail-link"
                :to="`/SolicitudDetalleAdmin/${solicitud.id}`"
                @click.native.stop
              >
                {{ solicitud.id }}
              </router-link>
              <div v-if="solicitud.orden" class="orden-id-badge">
                Orden #{{ solicitud.orden.id }}
              </div>
            </td>
            <td>
              <span
                v-if="totalUnreadMessages(solicitud) > 0"
                class="unread-count"
              >
                {{ totalUnreadMessages(solicitud) }}
              </span>
            </td>
            <td v-if="admin_datos.user_type === 'jobbing_admin'">
              <span
                style="font-weight: 700;"
                :style="{ 'color': solicitud.empresa && solicitud.empresa.atributos.color ? solicitud.empresa.atributos.color : '#000' }"
              >
                {{ solicitud.empresa.nombre }}
              </span>
            </td>
            <td>

                <span
                  v-if="solicitud.orden && solicitud.orden.profesional && solicitud.orden.profesional.atendiendo_orden === solicitud.orden.id"
                  class="status-badge" 
                  v-on:click="showTracking(solicitud.orden)">
                  <span class="dot"></span> En atención 
                </span>
              <div class="custom-tooltip-wrapper">
                <div v-if="solicitudRequiereAccion(solicitud, 'Aprobar presupuesto')" class="badge prioridad-media">Acción requerida</div>

                <span class="custom-tooltip-text">Requiere aprobar presupuesto</span>
              </div>

              <div class="custom-tooltip-wrapper">
                <div v-if="solicitudRequiereAccion(solicitud, 'Pagar')"  class="badge prioridad-alta">Acción requerida</div>
                <span class="custom-tooltip-text">Requiere pagar</span>
              </div>
            </td>
            <td>{{ extractDate(solicitud.fecha_creado).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
            <td>{{ solicitud.titulo }}</td>
            <td>
              <span :class="['badge', mapPrioridad(solicitud).className]">
                {{ mapPrioridad(solicitud).text }}
              </span>
            </td>
            <td>
              {{ solicitud.direccion }}<span v-if="solicitud.numero_apartamento != null"> (Departamento {{ solicitud.numero_apartamento }})</span>,
              {{ solicitud.comuna_nombre }}
            </td>
            <td>
              <div v-if="solicitud.atributos && solicitud.atributos.ubicacion_llaves && solicitud.atributos.ubicacion_llaves.length > 0">
                <div v-for="ubicacion in solicitud.atributos.ubicacion_llaves" :key="ubicacion.id">
                  <div style="white-space: pre-wrap;">
                    {{ formatFecha(ubicacion.fecha) }}
                    <b>{{ ubicacion.nombre }}</b>:
                    <span v-if="ubicacion.ubicacion">{{ ubicacion.ubicacion }}</span>
                    <span style="font-style: italic;" v-else>Desconocida</span>
                    <br />
                  </div>
                </div>
              </div>
              <div style="font-style: italic;" v-else>
                Desconocida
              </div>
            </td>
            <td>
              <div v-if="solicitud.atributos.comentarios && solicitud.atributos.comentarios.length > 0">
                <button
                  style="margin-bottom: 20px;"
                  class="download-button"
                  v-if="solicitud.atributos.comentarios.length > 2"
                  @click="toggleMostrarTodos(solicitud)"
                >
                  {{ solicitud.mostrar_todos_los_comentarios ? 'Esconder historial' : 'Mostrar historial' }}
                  ({{ solicitud.atributos.comentarios.length - 2 }})
                </button>
                <div
                  v-for="(comentario, idx) in (solicitud.mostrar_todos_los_comentarios ? solicitud.atributos.comentarios : solicitud.atributos.comentarios.slice(-2))"
                  :key="idx"
                  class="comentario"
                >
                  <div style="white-space: pre-wrap;">
                    {{ formatFecha(comentario.fecha) }}
                    <b>{{ comentario.autor_nombre }}</b>: {{ comentario.comentario }}
                    <br />
                  </div>
                </div>
              </div>
              <div style="font-style: italic;" v-else> Sin comentarios </div>
            </td>
            <td><div style="font-weight: 700;" :style="{ 'color': solicitud.estado_front.color }"> {{ solicitud.estado_front.estado }} </div></td>
            <td>{{ solicitud.estado_front.porcentaje }}%</td>
            <td>
              <div
                v-if="solicitud.orden && solicitud.orden.profesional"
                class="atendido-prof"
              >
                <img
                  v-if="solicitud.orden.profesional.foto"
                  :src="solicitud.orden.profesional.foto"
                  alt="Foto del profesional"
                  class="atendido-avatar"
                />
                <img
                  v-else
                  src="@/assets/empty-user.png"
                  alt="Foto del profesional"
                  class="atendido-avatar"
                />
                <span
                  class="link-profesional profesional-clickable"
                  @click="$refs.modalPerfil.openByNombreSeo(solicitud.orden.profesional.nombre_seo)"
                >
                  {{ solicitud.orden.profesional.nombre }} {{ solicitud.orden.profesional.apellido }}
                </span>

              </div>
              <span v-else>Aun no asignada</span>
            </td>
            <td>{{ getFechaVisita(solicitud) }}</td>
            <td>{{ getFechaEnvioPresupuesto(solicitud) }}</td>
            <td><div v-html="getFechaAprobacion(solicitud)"></div></td>
            <td><div v-html="getFechaInicio(solicitud)"></div></td>
            <td>
              <div v-html="hasFotos(solicitud) ? getFotosAntes(solicitud).length + ' fotos de antes y ' + getFotosDespues(solicitud).length + ' fotos de después' : '<span style=\'white-space:nowrap;\'>No hay<span/> fotos'"></div>
            </td>
            <td>
              <div v-if="getVideo(solicitud) === 'Descargar'">
                <div v-for="archivo in getArchivosPorCategoria(solicitud, 'Video')" :key="archivo.id" style="margin-bottom: 4px;">
                  <button class="download-button" @click="handleClickArchivo($event, archivo)">Descargar (id: {{ archivo.id }})</button>
                </div>
              </div>
              <div class="yellowish" v-else>
                No tiene
              </div>
            </td>
            <td>
              <div v-if="getComprobantePago(solicitud) === 'Descargar'">
                <div v-for="archivo in getArchivosPorCategoria(solicitud, 'Comprobante de Pago')" :key="archivo.id" style="margin-bottom: 4px;">
                  <button class="download-button" @click="handleClickArchivo($event, archivo)">Descargar (id: {{ archivo.id }})</button>
                </div>
              </div>
              <div class="yellowish" v-else>
                No tiene
              </div>
            </td>
            <td>
              <div v-if="getFacturaCliente(solicitud) === 'Descargar'">
                <div v-for="archivo in getArchivosPorCategoria(solicitud, 'Factura al Cliente')" :key="archivo.id" style="margin-bottom: 4px;">
                  <button class="download-button" @click="handleClickArchivo($event, archivo)">Descargar (id: {{ archivo.id }})</button>
                </div>
              </div>
              <div class="yellowish" v-else>
                No tiene
              </div>
            </td>
            <th v-if="admin_datos.user_type === 'jobbing_admin'">
              <div v-if="hasArchivoCategoria(solicitud, 'Factura del Profesional')">
                <div v-for="archivo in getArchivosPorCategoria(solicitud, 'Factura del Profesional')" :key="archivo.id" style="margin-bottom: 4px;">
                  <button class="download-button" @click="handleClickArchivo($event, archivo)">Descargar (id: {{ archivo.id }})</button>
                </div>
              </div>
              <div class="yellowish" v-else>
                No tiene
              </div>
            </th>
            <th v-if="admin_datos.user_type === 'jobbing_admin'">
              <div v-if="solicitud.orden">
                ${{ Intl.NumberFormat('de-DE').format((1-solicitud.orden.profesional_comision)*getMontoPorPagar(solicitud))}}
              </div>

            </th>
            <th v-if="admin_datos.user_type === 'jobbing_admin'">
              <div v-if="solicitud.orden">
                {{ getMontoPagadoAlProfesional(solicitud) }}
              </div>
            </th>
            <td>{{ getMontoTotal(solicitud) }}</td>
            <td>{{ getMontoPagado(solicitud) }}</td>
            <td>{{ getMontoPorPagarString(solicitud) }}</td>
            <td v-if="hasMargenCaptacion()">${{ Intl.NumberFormat('de-DE').format(getMontoPorCobrarAJobbing(solicitud)) }}</td>
            <td v-if="hasMargenCaptacion()">
              <div v-if="getFacturaHaciaJobbing(solicitud) === 'Descargar'">
                <div v-for="archivo in getArchivosPorCategoria(solicitud, 'Factura hacia Jobbing')" :key="archivo.id" style="margin-bottom: 4px;">
                  <button class="download-button" @click="handleClickArchivo($event, archivo)">Descargar (id: {{ archivo.id }})</button>
                </div>
              </div>
              <div class="yellowish" v-else>
                No tiene
              </div>
            </td>
            <td>{{ getFechaCalificacion(solicitud) }}</td>
            <td>
              <div style="white-space: nowrap;" v-if="solicitud.orden && solicitud.orden.calificacion && solicitud.orden.calificacion.calificacion">
                <b-icon class="star" icon="star-fill" v-for="_ in solicitud.orden.calificacion.calificacion" :key="_"></b-icon>
              </div>
              <div v-else>
                Sin calificación
              </div>
            </td>
          </tr>

          <!-- Row for Details -->
          <tr :id="'details' + index" style="display: none;">
            <td :colspan="detailsColspan" style="padding: 0;">
              <div class="details-container">
                <div class="tabs details-tabs">
                  <button
                    :class="{ 'active-tab': solicitud.activeTab === 'orden' }"
                    :style="{ opacity: solicitud.orden ? 1 : 0.5 }"
                    @click="solicitud.activeTab = 'orden'"
                  >
                    Orden
                  </button>
                  <button
                    :class="{ 'active-tab': solicitud.activeTab === 'presupuestos' }"
                    @click="solicitud.activeTab = 'presupuestos'"
                  >
                    Presupuestos
                  </button>
                  <button
                    :class="{ 'active-tab': solicitud.activeTab === 'contacto' }"
                    @click="solicitud.activeTab = 'contacto'"
                  >
                    Contacto
                  </button>
                  <button
                    v-if="hasProfessionalMessages(solicitud)"
                    :class="{ 'active-tab': solicitud.activeTab === 'chats' }"
                    @click="openChatTab(solicitud)"
                  >
                    Chats
                    <span v-if="totalUnreadMessages(solicitud)" class="badge">{{ totalUnreadMessages(solicitud) }}</span>
                  </button>
                </div>
                <div class="details-body">
                <!-- Información de contacto -->
                <template v-if="solicitud.activeTab === 'contacto'">
                  <div class="sectionv">
                    <h2>Información de contacto 📋</h2>
                    <table style="min-width: 400px;">
                      <tr>
                        <td><b>Nombre</b></td>
                        <td>{{ solicitud.nombre }} {{ solicitud.apellido }}</td>
                      </tr>
                      <tr>
                        <td><b>Email</b></td>
                        <td>{{ solicitud.email }}</td>
                      </tr>
                      <tr>
                        <td><b>Teléfono</b></td>
                        <td>{{ solicitud.telefono }}</td>
                      </tr>
                    </table>
                  </div>
                </template>
                <!-- Presupuestos -->
                <template v-else-if="solicitud.activeTab === 'presupuestos'">
                  <div class="sectionv">
                    <h2>Presupuestos asociados 📄</h2>
                    <table v-if="solicitud.presupuestos && solicitud.presupuestos.length" style="min-width: 400px;">
                      <tr>
                        <th>Profesional</th>
                        <th>Calificación</th>
                        <th>Enviado</th>
                        <th>Estado</th>
                        <th>Monto Total</th>
                        <th v-if="!solicitud.orden">Acciones</th>
                      </tr>
                      <tr v-for="p in solicitud.presupuestos" :key="p.id">
                        <td>
                          <div class="presupuesto-prof">
                            <img
                              v-if="p.profesional && p.profesional.foto"
                              :src="p.profesional.foto"
                              alt="Foto del profesional"
                              class="presupuesto-avatar"
                            />
                            <div
                              class="profesional-clickable"
                              v-if="p.profesional"
                              @click="$refs.modalPerfil.openByNombreSeo(p.profesional.nombre_seo)"
                            >
                              {{ p.profesional.nombre }}
                           
                          </div>
                            <span v-else>Sin profesional</span>
                          </div>
                        </td>
                        <td>
                          <div v-if="p.profesional && p.profesional.calificacion">
                            <b-icon
                              class="star"
                              icon="star-fill"
                              v-for="n in Math.round(p.profesional.calificacion)"
                              :key="n"
                            ></b-icon>
                            <span>({{ p.profesional.calificacion.toFixed(1) }})</span>
                          </div>
                          <div v-else>Sin calificación</div>
                        </td>
                        <td>{{ p.fecha_enviado ? formatFecha(p.fecha_enviado) : '-' }}</td>
                        <td>
                          <span :class="mapPresupuestoStatus(p.estado).className">
                            {{ mapPresupuestoStatus(p.estado).text }}
                          </span>
                        </td>
                        <td>${{ Intl.NumberFormat('de-DE').format(p.monto_total) }}</td>
                        <td v-if="!solicitud.orden">
                          <button class="green-button" @click="openChatBudgetApprovalModalFromTable(solicitud, p)">Aceptar</button>
                        </td>
                      </tr>
                    </table>
                    <div v-else>No hay presupuestos disponibles.</div>
                  </div>
                </template>
                <!-- Información de la Orden -->
                <template v-else-if="solicitud.activeTab === 'orden'">
                  <div style="background-color: rgb(250, 250, 250); width: 100%; padding: 15px;">
                  <template v-if="solicitud.orden">
                    <div class="sectionv">
                      <h2>Información de la orden 📦</h2>
                      <div v-if="solicitud.orden.servicios && solicitud.orden.servicios.length">
                        <h3>Servicios agregados:</h3>
                        <table style="min-width: 400px;">
                          <thead>
                            <tr>
                              <th>Nombre</th>
                              <th>Precio (con IVA)</th>
                              <th>Estado</th>
                              <th>Fecha marcado realizado</th>
                              <th>Presupuesto</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="s in solicitud.orden.servicios"
                              :key="s.id"
                              :class="{ 'servicio-realizado-aprobado': esServicioRealizado(s) && estaAprobadoEnPresupuesto(solicitud, s) }"
                            >
                              <td>{{ s.nombre }}</td>
                              <td>${{ Intl.NumberFormat('de-DE').format(Number(s.precio) || 0) }}</td>
                              <td>
                                <div class="servicio-estado">
                                  <span
                                    :class="['status-indicator', esServicioRealizado(s) ? 'status-indicator--realizado' : 'status-indicator--pendiente']"
                                  ></span>
                                  <span>{{ esServicioRealizado(s) ? 'Realizado' : 'Pendiente' }}</span>
                                </div>
                              </td>
                              <td>
                                <span v-if="esServicioRealizado(s) && s.fecha_realizado">{{ formatFechaHora(s.fecha_realizado) }}</span>
                                <span v-else>-</span>
                              </td>
                              <td>
                                <div class="servicio-presupuesto">
                                  <span
                                    v-if="estaAprobadoEnPresupuesto(solicitud, s)"
                                    class="badge servicio-presupuesto__badge servicio-presupuesto__badge--aprobado"
                                  >
                                    Presupuesto aprobado
                                  </span>
                                  <span
                                    v-else-if="estaEnPresupuesto(solicitud, s)"
                                    class="badge servicio-presupuesto__badge servicio-presupuesto__badge--pendiente"
                                  >
                                    En presupuesto (no aprobado)
                                  </span>
                                  <span v-else class="servicio-presupuesto__sin">Sin presupuesto</span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <br />
                      </div>
                      <div v-if="solicitud.orden.pagos && solicitud.orden.pagos.length">
                        <h3>Pagos</h3>
                        <table style="min-width: 400px;">
                          <tr>
                            <th>Id</th>
                            <th>Monto</th>
                            <th>Estado</th>
                            <th>Fecha</th>
                            <th>Método</th>
                            <th>Recibido por</th>
                            <th v-if="admin_datos.user_type === 'jobbing_admin'">
                            Transferido
                            <div class="custom-tooltip-wrapper">
              <img
                  alt="Pendiente"
                  class="info-svg"
                  src="@/assets/iconos/info.svg"
                />
                <span style="width: 200px;" class="custom-tooltip-text tooltip-down">¿Se le transfirió al profesional su parte correspondiente a este pago?</span>
              </div>
                            </th>
                            <th v-if="admin_datos.user_type === 'jobbing_admin'">Acciones</th>
                          </tr>
                          <tbody>
                            <tr v-for="pago in solicitud.orden.pagos" :key="pago.id">
                              <td>{{ pago.id }}</td>
                              <td>${{ Intl.NumberFormat('de-DE').format(pago.monto) }}</td>
                              <td>
                                <div style="color: #2ECC40;" v-if="pago.estado == 1">
                                  Pagado
                                </div>
                                <div style="color: #FF4136;" v-else-if="pago.estado == 2">
                                  Devuelto
                                </div>
                                <div
                                  style="color: #FF851B;"
                                  v-else-if="pago.estado === ESTADO_PAGO_EN_REVISION"
                                >
                                  En revisión
                                </div>
                                <div style="color: #AAAAAA;" v-else-if="pago.estado == 0">
                                  No pagado
                                </div>
                                <div v-else>
                                  Desconocido
                                </div>
                              </td>
                              <td>{{ formatPagoFecha(pago.fecha_pagado) }}</td>
                              <td>{{ pago.metodo_pago }}</td>
                              <td>{{ pago.recibido_por == 'jobbing' ? 'Jobbing' : admin_datos.empresa.nombre }}</td>
                              <td v-if="admin_datos.user_type === 'jobbing_admin'">
                                <span style="color:#FF4136;" v-if="pago.transferencia_id  == null"> <b>No</b></span>
                                <span  style="color:#2ECC40;" v-else> <b>Si</b></span>
                              </td>
                              <td v-if="admin_datos.user_type === 'jobbing_admin'">
                              <button @click="eliminarPago(pago)" class="red-button">
                                Eliminar Pago <b-icon icon="trash"></b-icon>
                              </button>
                            </td>
                            </tr>

                          </tbody>
                        </table>
                        <br />
                      </div>

                      <!-- Visitas -->
                      <div v-if="solicitud.orden.visitas && solicitud.orden.visitas.length">
                        <h3>Visitas</h3>
                        <table style="min-width: 400px;">
                          <tr>
                            <th>Estado</th>
                            <th>Fecha</th>
                            <th>Hora</th>
                            <th>Servicios Realizados</th>
                          </tr>
                          <tbody>
                            <tr v-for="visita in solicitud.orden.visitas" :key="visita.id">
                              <td :style="{ 'color': visita.estado == 10 ? '#FF4136' : visita.estado == 4 ? '#2ECC40' : '' }">{{ getEstadoVisita(visita) }}</td>
                              <td>{{ extractDate(visita.fecha_).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' }) }}</td>
                              <td>{{ timeConvert(visita.desde) }} hrs</td>
                              <td>
                                <div v-if="solicitud.orden && solicitud.orden.servicios && solicitud.orden.servicios.some(x => esServicioRealizado(x) && x.visita_id == visita.id)">
                                  <div v-for="servicio in solicitud.orden.servicios.filter(x => esServicioRealizado(x) && x.visita_id == visita.id)" :key="servicio.id">
                                    <b>{{ servicio.nombre }}</b>, por ${{ Intl.NumberFormat('de-DE').format(servicio.precio) }}
                                  </div>
                                </div>
                                <div v-else>
                                  No se especifica
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <br />
                      </div>

                      <!-- Presupuestos -->
                      <div v-if="solicitud.orden.presupuestos && solicitud.orden.presupuestos.length">
        <h3>Presupuestos</h3>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Fecha Creado</th>
              <th>Tiempo Ejec.</th>
              <th><span class="nowrap">Monto presupuesto</span><br /> (con IVA)</th>
              <th><span class="nowrap">Monto presupuesto</span><br /> (sin IVA)</th>
              <th><span class="nowrap">Monto Aprobado</span><br /> (con IVA)</th>
              <th><span class="nowrap">Monto no Ejecutado</span><br /> (con IVA)</th>
              <th><b><span class="nowrap">Total a cobrar</span><br /> (con IVA)</b></th>
              <th>Estado</th>
              <th>Fecha Aprobado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="presupuesto in solicitud.orden.presupuestos" :key="presupuesto.id"
                @mouseenter="presupuesto_showTooltip($event, presupuesto)"
                @mouseleave="presupuesto_hideTooltip">
              <td>{{ presupuesto.id }}</td>
              <td>
                {{ extractDate(presupuesto.fecha_creado_iso)
                    ? extractDate(presupuesto.fecha_creado_iso).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' })
                    : 'No especifica' }}
              </td>
              <td>
                <span style="font-weight: 700;" v-if="presupuesto.tiempo_de_ejecucion">
                  {{ presupuesto.tiempo_de_ejecucion }} dia(s)
                </span>
                <span v-else>Desconocido</span>
              </td>
              <td>${{ Intl.NumberFormat('de-DE').format(presupuesto.monto_total) }}</td>
              <td>${{ Intl.NumberFormat('de-DE').format(Math.round(presupuesto.monto_total / 1.19)) }}</td>
              <td>
                ${{ Intl.NumberFormat('de-DE').format(getTotalApprovedPresupuesto(presupuesto)) }}
                ({{ presupuesto.monto_total > 0 ? Math.round((getTotalApprovedPresupuesto(presupuesto) / presupuesto.monto_total) * 100) : 0 }}%)
              </td>
              <td>${{ Intl.NumberFormat('de-DE').format(getTotalNoRealizadoPresupuesto(presupuesto)) }}</td>
              <td>
                <b>
                  ${{ Intl.NumberFormat('de-DE').format(getTotalApprovedPresupuesto(presupuesto) - getTotalNoRealizadoPresupuesto(presupuesto)) }}
                </b>
              </td>
              <td>
                <div v-html="getEstadoPresupuesto(presupuesto)"></div>
              </td>
              <td>
                <div style="color: #2ECC40; font-weight: 700;" v-if="presupuesto.fecha_aprobado_iso">
                  {{ extractDate(presupuesto.fecha_aprobado_iso)
                      ? extractDate(presupuesto.fecha_aprobado_iso).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' })
                      : 'No aprobado' }}
                </div>
                <div v-else>
                  No aprobado
                </div>
              </td>
              <td>
                <button @click="descargarPresupuesto(presupuesto)" style="margin: 0px 2px" class="download-button">
                  Descargar <b-icon icon="download"></b-icon>
                </button>
                <button
                  v-if="presupuesto.estado == 1 || presupuesto.estado == 0"
                  @click="reenviarPresupuesto(presupuesto)"
                  style="margin: 0px 2px"
                  class="download-button"
                >
                  {{ presupuesto.estado == 0 ? 'Enviar' : 'Reenviar' }}
                  <b-icon icon="arrow-counterclockwise"></b-icon>
                </button>
                <button
                  v-if="presupuesto.estado >= 1 && presupuesto.estado < 10"
                  @click="copiarLinkPresupuesto(presupuesto)"
                  style="margin: 0px 2px"
                  class="download-button"
                >
                  Copiar link <b-icon icon="clipboard"></b-icon>
                </button>
                <button
                  v-if="presupuesto.estado == 1 || presupuesto.estado == 0"
                  @click="openChatBudgetApprovalModalFromTable(solicitud, presupuesto)"
                  style="margin: 0px 2px; background-color: #2ECC40;"
                  class="download-button"
                >
                  Aprobar <b-icon icon="check-circle"></b-icon>
                </button>
                <button
                  v-if="presupuesto.estado == 1 || presupuesto.estado == 0"
                  @click="abrirModalRechazarPresupuesto(presupuesto)"
                  style="margin: 0px 2px;"
                  class="red-button"
                >
                  Rechazar <b-icon icon="x-circle"></b-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Tooltip element -->
      <div v-if="presupuesto_activeTooltip" class="tooltip-box" :style="{ top: presupuesto_tooltipY + 'px', left: presupuesto_tooltipX + 'px' }">
        <strong>Detalles:</strong>
        <div v-if="presupuesto_activeTooltip.desgloce && presupuesto_activeTooltip.desgloce.items && presupuesto_activeTooltip.desgloce.items.length">
          <ul>
            <li v-for="item in presupuesto_activeTooltip.desgloce.items" :key="item.id">
              <strong>{{ item.nombre }}</strong> - ${{ formatPrice(item.precio) }} -
              <span style="color: #2ECC40; font-weight: 700;" v-if="item.aprobado">Aprobado</span>
              <span style="color: #FF4136; font-weight: 700;" v-else>No Aprobado</span>
              <span v-if="item.no_realizado != undefined">
                - <span v-if="item.no_realizado">No Realizado</span><span v-else>Realizado</span>
              </span>
            </li>
          </ul>
        </div>
        <div v-else>
          Sin detalles.
        </div>
      </div>
</div>
                      <!-- Fotos -->
                      <div class="sectionv">
                        <h2>Fotos 📸</h2>
                        <div v-if="hasFotos(solicitud)">
                          <!-- Download Button -->
                          <div style="margin-top: 10px;">
                            <DownloadFotoOrden :ordenId="solicitud.orden.id" />
                          </div>

                          <!-- Antes Photos Section -->
                          <h3>Antes</h3>
                          <div class="fotos-container">
                            <div class="image-wrapper" v-for="foto in getFotosAntes(solicitud)" :key="foto.id">
                              <img
                                :src="obtenerURLFoto(foto)"
                                alt="Foto Antes"
                                @click="openImageModal(obtenerURLFoto(foto))"
                                class="clickable-image"
                              />
                              <div class="hover-message">
                                {{ formatDate(foto.fecha_creado) }}
                              </div>
                            </div>
                          </div>

                          <!-- Después Photos Section -->
                          <h3>Después</h3>
                          <div class="fotos-container">
                            <div class="image-wrapper" v-for="foto in getFotosDespues(solicitud)" :key="foto.id">
                              <img
                                :src="obtenerURLFoto(foto)"
                                alt="Foto Después"
                                @click="openImageModal(obtenerURLFoto(foto))"
                                class="clickable-image"
                              />
                              <div class="hover-message">
                                {{ formatDate(foto.fecha_creado) }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <p v-else style="color: red;">No hay fotos</p>
                      </div>
                     
                  </template>
                  <div class="sectionv" v-else>
                    <h2>Información de la orden 📦</h2>
                    <p style="font-style: italic;">Sin orden asignada</p>
                  </div>
                  </div>
                </template>
                <template v-else-if="solicitud.activeTab === 'chats'">
                  <div class="chat-container">
                    <div v-if="groupMessagesByProfessional(solicitud).length" class="chat-content">
                      <div class="chat-left sectionv2">
                        <div v-if="getActiveConversation(solicitud)" class="chat-header">
                          <div class="chat-header-info-wrap">
                            <img
                              v-if="getActiveConversation(solicitud).profesionalFoto"
                              :src="getActiveConversation(solicitud).profesionalFoto"
                              class="chat-header-avatar"
                              @click="openProfessionalProfile(getActiveConversation(solicitud).profesionalSeo)"
                            />
                            <div class="chat-header-info">
                              <div
                                class="chat-header-name"
                                @click="openProfessionalProfile(getActiveConversation(solicitud).profesionalSeo)"
                              >
                                {{ getActiveConversation(solicitud).profesionalName }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <p v-if="getActiveConversation(solicitud)" class="chat-profile-hint">
                          Haz clic en el encabezado o en la foto del profesional para ver su perfil.
                        </p>
                        <div class="chat-messages" :ref="'chatMessages-' + solicitud.id">
                          <div
                            v-for="(item, index) in getChatMessagesWithSeparators(solicitud)"
                            :key="item.type === 'separator' ? 'sep-' + index : item.id"
                          >
                            <div v-if="item.type === 'separator'" class="date-separator">
                              {{ item.label }}
                            </div>
                            <div
                              v-else
                              :class="['chat-message', { 'from-professional': item.fromRole === 'professional', 'unseen': item.fromRole === 'professional' && !item.visto }]"
                            >
                              <img
                                v-if="item.foto"
                                :src="item.foto"
                                class="chat-avatar"
                                :class="{ clickable: item.fromRole === 'professional' }"
                                @click="item.fromRole === 'professional' && openProfessionalProfileByMessage(solicitud, item)"
                              />
                              <div
                                v-else
                                class="chat-avatar placeholder"
                                :class="{ clickable: item.fromRole === 'professional' }"
                                @click="item.fromRole === 'professional' && openProfessionalProfileByMessage(solicitud, item)"
                              >
                                {{ getInitials(item.fromName) }}
                              </div>
                              <div
                                class="message-bubble"
                                :class="{ 'has-special-content': hasSpecialContent(item) }"
                              >
                                <div class="message-header">
                                  <span class="message-name">{{ item.fromName }}</span>
                                  <span v-if="item.fromRole === 'professional'" class="message-tag">Profesional</span>
                                </div>
                                <div
                                  v-if="item.mensaje"
                                  class="message-text"
                                  :class="{ 'message-text--neutral': hasSpecialContent(item) }"
                                >
                                  {{ item.mensaje }}
                                </div>
                                <div
                                  v-if="item.fotos && item.fotos.length"
                                  class="message-attachments"
                                >
                                  <div
                                    v-for="(foto, index) in item.fotos"
                                    :key="foto.id || index"
                                    class="message-attachment"
                                    v-if="foto.link"
                                    @click="openImageModal(foto.link)"
                                  >
                                    <img :src="foto.link" alt="Imagen adjunta" />
                                  </div>
                                </div>
                                <div v-if="hasSpecialContent(item)" class="special-message">
                                  <template v-if="item.atributos && item.atributos.orden">
                                    <div
                                      class="request-box"
                                      :style="getOrderBoxStyle(item.atributos.orden)"
                                    >
                                      <div class="title-wrapp">
                                        <img class="box-icon" :src="getOrderIcon(item.atributos.orden)" alt="" />
                                        <div class="request-title">
                                          {{ getOrderTitle(solicitud, item) }}
                                        </div>
                                      </div>
                                      <div class="request-body">
                                        <template v-if="isOrderCancelled(item.atributos.orden)">
                                          <p>
                                            El link de pago ya no está disponible. Es posible que el profesional lo haya
                                            eliminado.
                                          </p>
                                        </template>
                                        <template v-else-if="isOrderAccepted(item.atributos.orden)">
                                          <p>
                                            La visita quedó reservada
                                            <span v-if="getOrderSchedule(item.atributos.orden)">
                                              para {{ getOrderSchedule(item.atributos.orden) }}.
                                            </span>
                                          </p>
                                          <p>
                                            Hemos notificado a {{ getProfessionalDisplayName(solicitud, item) }} sobre esta
                                            actualización.
                                          </p>
                                        </template>
                                        <template v-else-if="isPaymentInPayroll(item.atributos.orden)">
                                          <p>
                                            Esta solicitud quedó aceptada en la nómina. Podrás incluirla en el próximo envío de comprobantes desde Pagos pendientes.
                                          </p>
                                          <p>
                                            Monto en nómina:
                                            <strong>{{ formatCurrency(item.atributos.orden.monto_servicios) }}</strong>.
                                          </p>
                                        </template>
                                        <template v-else>
                                          <p v-if="isPaymentLink(item.atributos.orden)">
                                            El monto solicitado es
                                            <strong>{{ formatCurrency(item.atributos.orden.monto_servicios) }}</strong>
                                            <span v-if="hasOrderServices(item.atributos.orden)"> e incluye:</span>
                                          </p>
                                          <template v-else>
                                            <p>
                                              Tu agendamiento quedará reservado
                                              <span v-if="getOrderSchedule(item.atributos.orden)">
                                                {{ getOrderSchedule(item.atributos.orden) }}.
                                              </span>
                                            </p>
                                            <p v-if="!isFreeOrder(item.atributos.orden)">
                                              El valor de la visita es
                                              <strong>{{ formatCurrency(item.atributos.orden.monto_servicios) }}</strong>.
                                            </p>
                                            <p v-else>
                                              Esta visita no tiene costo para tu cliente. Puedes confirmarla para agendarla.
                                            </p>
                                            <p v-if="!isFreeOrder(item.atributos.orden)">
                                              Recuerda que sólo los pagos efectuados mediante Jobbing quedan respaldados.
                                            </p>
                                          </template>
                                        </template>
                                        <ul
                                          v-if="hasOrderServices(item.atributos.orden)"
                                          class="request-list"
                                        >
                                          <li
                                            v-for="(service, serviceIndex) in getOrderServices(item.atributos.orden)"
                                            :key="service.id || serviceIndex"
                                          >
                                            {{ service.nombre }}
                                          </li>
                                        </ul>
                                      </div>
                                      <div
                                        class="special-actions"
                                        v-if="orderHasActions(item.atributos.orden)"
                                      >
                                        <button
                                          v-if="canAcceptFreeVisit(item.atributos.orden)"
                                          type="button"
                                          class="special-action-button"
                                          @click="openAcceptFreeVisitModal(solicitud, item)"
                                        >
                                          Aceptar visita sin costo
                                        </button>
                                        <button
                                          v-if="canManagePayment(item.atributos.orden)"
                                          type="button"
                                          class="special-action-button secondary"
                                          @click="openPayOrderModal(solicitud, item)"
                                        >
                                          Gestionar pago
                                        </button>
                                      </div>
                                    </div>
                                  </template>
                                  <template v-if="item.atributos && item.atributos.presupuesto">
                                    <div
                                      class="request-box"
                                      :style="getBudgetBoxStyle(item.atributos.presupuesto)"
                                    >
                                      <div class="title-wrapp">
                                        <img class="box-icon" :src="getBudgetIcon(item.atributos.presupuesto)" alt="" />
                                        <div class="request-title">
                                          {{ getBudgetTitle(solicitud, item) }}
                                        </div>
                                      </div>
                                      <div class="request-body">
                                        <template v-if="isBudgetPending(item.atributos.presupuesto)">
                                          <p>
                                            El presupuesto total es de
                                            <strong>{{ formatCurrency(item.atributos.presupuesto.monto_total) }}</strong>
                                            e incluye:
                                          </p>
                                        </template>
                                        <template v-else-if="isBudgetApproved(item.atributos.presupuesto)">
                                          <p>{{ getApprovedBudgetMessage(item.atributos.presupuesto) }}</p>
                                        </template>
                                        <template v-else-if="isBudgetRejected(item.atributos.presupuesto)">
                                          <p>Este presupuesto fue rechazado y el profesional ya fue notificado.</p>
                                        </template>
                                        <ul
                                          v-if="hasBudgetItems(item.atributos.presupuesto)"
                                          class="request-list"
                                        >
                                          <li
                                            v-for="(budgetItem, bIndex) in getBudgetItems(item.atributos.presupuesto)"
                                            :key="budgetItem.id || bIndex"
                                          >
                                            {{ budgetItem.nombre }}
                                            <span v-if="budgetItem.precio">
                                              por {{ formatCurrency(budgetItem.precio) }}
                                            </span>
                                          </li>
                                        </ul>
                                        <p
                                          v-if="getBudgetNotes(item.atributos.presupuesto)"
                                          class="request-notes"
                                        >
                                          <strong>Notas adicionales:</strong>
                                          {{ getBudgetNotes(item.atributos.presupuesto) }}
                                        </p>
                                      </div>
                                      <div
                                        class="special-actions"
                                        v-if="budgetHasActions(item.atributos.presupuesto)"
                                      >
                                        <button
                                          v-if="canApproveBudget(item.atributos.presupuesto)"
                                          type="button"
                                          class="special-action-button"
                                          @click="openChatBudgetApprovalModal(solicitud, item)"
                                        >
                                          Aprobar presupuesto
                                        </button>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                                <div class="message-time">{{ formatTime(item.fecha) }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="chat-input"
                          :class="{ 'drag-over': solicitud.isDraggingFiles }"
                          @dragenter.prevent="onChatDragOver(solicitud)"
                          @dragover.prevent="onChatDragOver(solicitud)"
                          @dragleave.prevent="onChatDragLeave(solicitud, $event)"
                          @drop.prevent="onChatDrop(solicitud, $event)"
                        >
                          <input
                            v-model="solicitud.newMessage"
                            class="chat-text-field"
                            placeholder="Escribe un mensaje..."
                            @keydown.enter.exact.prevent="enviarMensajeAdmin(solicitud)"
                          />
                          <input
                            class="chat-file-input"
                            type="file"
                            multiple
                            accept="image/*"
                            :ref="'chatUpload-' + solicitud.id"
                            @change="onChatFileChange(solicitud, $event)"
                          />
                          <button
                            type="button"
                            class="chat-upload-button"
                            @click="triggerChatFileInput(solicitud)"
                            title="Adjuntar imágenes"
                            aria-label="Adjuntar imágenes"
                          >
                            <b-icon icon="camera-fill"></b-icon>
                          </button>
                          <button
                            type="button"
                            class="chat-send-button"
                            @click="enviarMensajeAdmin(solicitud)"
                            :disabled="!canSendChatMessage(solicitud)"
                          >
                            Enviar
                          </button>
                        </div>
                        <div
                          v-if="solicitud.newMessageFiles && solicitud.newMessageFiles.length"
                          class="chat-attachments-preview"
                        >
                          <div
                            v-for="(attachment, index) in solicitud.newMessageFiles"
                            :key="attachment.preview + index"
                            class="chat-attachment-preview"
                          >
                            <img :src="attachment.preview" :alt="attachment.file.name" />
                            <button
                              type="button"
                              class="remove-attachment"
                              @click="removeChatAttachment(solicitud, index)"
                              title="Eliminar imagen"
                            >
                              ×
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="chat-right sectionv2">
                        <div class="professional-list">
                          <div
                            v-for="conv in groupMessagesByProfessional(solicitud)"
                            :key="conv.profesionalId"
                            :class="['professional-item', { active: solicitud.activeChat === conv.profesionalId }]"
                            @click="setActiveChat(solicitud, conv.profesionalId)"
                          >
                            <img
                              v-if="conv.profesionalFoto"
                              :src="conv.profesionalFoto"
                              class="professional-avatar"
                              :class="{ clickable: !!conv.profesionalSeo }"
                              @click.stop="openProfessionalProfile(conv.profesionalSeo)"
                            />
                            <div
                              v-else
                              class="professional-avatar placeholder"
                              :class="{ clickable: !!conv.profesionalSeo }"
                              @click.stop="openProfessionalProfile(conv.profesionalSeo)"
                            >
                              {{ getInitials(conv.profesionalName) }}
                            </div>
                            <div class="professional-name">{{ conv.profesionalName }}</div>
                            <span v-if="conv.unread" class="badge">{{ conv.unread }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <p>No hay conversaciones.</p>
                    </div>
                  </div>
                </template>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <!--  {{solicitudes}} -->
  </div>
        </div>
        <div
          v-else
          class="articulo-principal d-flex justify-content-center align-items-center"
          style="min-height: 60vh;"
        >
          <div
            class="spinner-border text-primary"
            style="width: 5rem; height: 5rem;"
            role="status"
          >
            <span class="sr-only">Cargando...</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Context Menu -->
    <div
      v-if="contextMenuVisible"
      :style="{ top: contextMenuY + 'px', left: contextMenuX + 'px' }"
      class="context-menu"
    >
      <ul>
        <li @click="abrirModalEditarSolicitud(selectedSolicitud)">Editar Solicitud</li>
        <li @click="abrirModalAgregarComentario(selectedSolicitud)">Agregar Comentario</li>
        <li @click="abrirModalSubirArchivo(selectedSolicitud, 'Comprobante de Pago')">Agregar Comprobante de Pago</li>
        <li @click="abrirModalSubirArchivo(selectedSolicitud, 'Factura al Cliente')">Agregar Factura al Cliente</li>
        <li v-if="this.admin_datos.user_type == 'jobbing_admin'" @click="abrirModalSubirArchivo(selectedSolicitud, 'Factura del Profesional')">Agregar Factura del Profesional</li>
        <li v-if="this.admin_datos.user_type == 'jobbing_admin'" @click="abrirModalAgregarPago(selectedSolicitud)">Agregar Pago</li>
        <li v-if="selectedSolicitud && selectedSolicitud.orden" @click="abrirModalEnviarPresupuesto(selectedSolicitud)">Enviar presupuesto</li>
        <li v-if="selectedSolicitud && selectedSolicitud.orden" @click="abrirModalCrearFactura(selectedSolicitud)">Agregar Datos Facturación</li>
        <li v-if="selectedSolicitud && selectedSolicitud.orden" @click="terminarSolicitud(selectedSolicitud.id)">Terminar solicitud</li>
        <li style="color: #FF4136;" @click="marcarSolicitudInactiva(selectedSolicitud.id)">Eliminar solicitud</li>
        <!-- Add more options here -->
      </ul>
    </div>

    <!-- Image Preview Modal -->
    <ImagePreviewModal 
      :imageSrc="currentModalImage" 
      :visible="isImageModalVisible" 
      @close="closeImageModal" 
    />

    <!-- Modal for Adding Comment -->
    <div v-if="modalVisible" class="modal-overlay" @click.self="cerrarModal">
      <div class="modall">
        <h3>Agregar Comentario</h3>
        <textarea v-model="nuevoComentario" placeholder="Escribe tu comentario aquí"></textarea>
        <div class="modal-buttons">
          <button @click="agregarComentario">Agregar</button>
          <button @click="cerrarModal">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Modal for Editing Solicitud -->
    <div v-if="modalEditarSolicitudVisible" class="modal-overlay" @click.self="cerrarModalEditarSolicitud">
  <div class="modall">
    <h3>Editar Solicitud</h3>
    <table class="modal-inputs">
      <tr>
        <td><label>Título:</label></td>
        <td><input type="text" v-model="editedSolicitud.titulo" /></td>
      </tr>
      <!-- New Descripción Field -->
      <tr>
        <td><label>Descripción:</label></td>
        <td><textarea v-model="editedSolicitud.descripcion"></textarea></td>
      </tr>
      <tr>
        <td><label>Nombre:</label></td>
        <td><input type="text" v-model="editedSolicitud.nombre" /></td>
      </tr>
      <tr>
        <td><label>Apellido:</label></td>
        <td><input type="text" v-model="editedSolicitud.apellido" /></td>
      </tr>
      <tr>
        <td><label>Email:</label></td>
        <td><input type="email" v-model="editedSolicitud.email" /></td>
      </tr>
      <tr>
        <td><label>Teléfono:</label></td>
        <td><input type="text" v-model="editedSolicitud.telefono" /></td>
      </tr>
      <tr>
        <td><label>Dirección:</label></td>
        <td><input type="text" v-model="editedSolicitud.direccion" /></td>
      </tr>
      <!-- Change Comuna to a Select Dropdown -->
      <tr>
        <td><label>Comuna:</label></td>
        <td>
          <select v-model="editedSolicitud.comuna_id">
            <option v-for="comuna in comunas" :value="comuna.id">{{ comuna.Nombre }}</option>
          </select>
        </td>
      </tr>
      <!-- Add other fields as needed -->
    </table>
    <div class="modal-buttons">
      <button @click="guardarCambiosSolicitud">Guardar</button>
      <button @click="cerrarModalEditarSolicitud">Cancelar</button>
    </div>
  </div>
</div>

    <!-- Modal for Uploading File -->
    <div v-if="modalSubirArchivoVisible" class="modal-overlay" @click.self="cerrarModalSubirArchivo">
      <div class="modall">
        <h3>Agregar {{ archivoTipo }}</h3>
        <input type="file" @change="onFileSelected">
        <div class="modal-buttons">
          <button @click="subirArchivo">Subir</button>
          <button @click="cerrarModalSubirArchivo">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Modal for Adding Payment -->
    <div v-if="modalAgregarPagoVisible" class="modal-overlay" @click.self="cerrarModalAgregarPago">
      <div class="modall">
        <h3>Agregar Pago</h3>
        <table class="modal-inputs">
          <tr>
            <td><label>Monto:</label></td>
            <td><input type="number" v-model="nuevoPagoMonto" /></td>
          </tr>
          <tr>
            <td><label>Fecha de Pago:</label></td>
            <td><input type="date" v-model="nuevoPagoFecha" /></td>
          </tr>
          <tr>
            <td><label>Recibido por:</label></td>
            <td>
              <select v-model="nuevoPagoRecibidoPor">
                <option value="jobbing">Jobbing</option>
                <option value="administradora">{{admin_datos.empresa && admin_datos.empresa.nombre ? admin_datos.empresa.nombre : 'Administradora'}}</option>
              </select>
            </td>
          </tr>
          <tr>
            <td><label>Comprobante de Pago (opcional):</label></td>
            <td><input type="file" @change="onPagoFileSelected" /></td>
          </tr>
        </table>
        <div class="modal-buttons">
          <button @click="agregarPago">Agregar</button>
          <button @click="cerrarModalAgregarPago">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Modal for accepting a free visit -->
    <div
      v-if="acceptVisitModal.visible"
      class="modal-overlay"
      @click.self="closeAcceptVisitModal"
    >
      <div class="modall">
        <div class="accept-visit-modal">
          <div class="accept-visit-modal__header">
            <div class="accept-visit-modal__icon">
              <img src="@/assets/iconos/appoint.svg" alt="Icono visita" />
            </div>
            <div class="accept-visit-modal__heading">
              <span class="accept-visit-modal__eyebrow">Visita sin costo</span>
              <h3 class="accept-visit-modal__title">Confirma la visita propuesta</h3>
            </div>
          </div>
          <div v-if="acceptVisitModal.message" class="accept-visit-modal__content">
            <p>
              ¿Deseas agendar la visita con
              <span class="accept-visit-modal__professional">{{ getProfessionalDisplayName(acceptVisitModal.solicitud, acceptVisitModal.message) }}</span>
              <span
                v-if="getOrderSchedule(acceptVisitModal.message.atributos && acceptVisitModal.message.atributos.orden)"
              >
                para
                <strong>{{ getOrderSchedule(acceptVisitModal.message.atributos.orden) }}</strong>
              </span>
              ?
            </p>
            <div class="accept-visit-modal__note">
              <img src="@/assets/iconos/check-circle.svg" alt="Confirmación" />
              <p>
                Al confirmar, notificaremos al profesional y tu visita quedará registrada en Jobbing.
              </p>
            </div>
          </div>
          <div class="accept-visit-modal__actions">
            <button
              class="accept-visit-modal__button accept-visit-modal__button--primary"
              @click="confirmAcceptFreeVisit"
              :disabled="acceptVisitModal.loading"
            >
              {{ acceptVisitModal.loading ? 'Procesando...' : 'Confirmar visita' }}
            </button>
            <button
              class="accept-visit-modal__button accept-visit-modal__button--secondary"
              @click="closeAcceptVisitModal"
              :disabled="acceptVisitModal.loading"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="chatBudgetModal.visible"
      class="budget-modal-overlay"
      role="presentation"
      @click="onChatBudgetOverlayClick"
    >
      <div
        ref="chatBudgetModalDialog"
        class="budget-modal-dialog"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
        @click.stop
      >
        <header class="modal-header">
          <h3>Aprobar presupuesto</h3>
          <button class="modal-close" type="button" @click="closeChatBudgetModal" :disabled="chatBudgetModal.loading">
            <span class="material-icons">close</span>
          </button>
        </header>
        <div class="modal-body">
          <p v-if="chatBudgetModal.presupuesto">
            Selecciona los ítems que deseas aprobar del presupuesto enviado por
            <strong>{{ getProfessionalDisplayName(chatBudgetModal.solicitud, chatBudgetModal.message) }}</strong>.
          </p>
          <div v-if="chatBudgetModalHasItems" class="modal-items">
            <div class="modal-items-header">
              <span>Ítems del presupuesto</span>
              <span class="modal-selection-count">
                {{ chatBudgetModalSelectedCount }} de {{ chatBudgetModal.items.length }} ítems
              </span>
            </div>
            <label class="modal-select-all">
              <input
                type="checkbox"
                :checked="chatBudgetModalAllSelected"
                @change="toggleChatBudgetSelectAll"
              />
              Seleccionar todos
            </label>
            <div class="modal-items-helper">
              Los montos seleccionados suman
              <span class="modal-selection-total">{{ formatCurrency(chatBudgetModalSelectionTotal) }}</span>
            </div>
            <div class="modal-items-list">
              <label
                v-for="modalItem in chatBudgetModal.items"
                :key="modalItem.key"
                class="modal-item"
              >
                <div class="modal-item-info">
                  <span class="modal-item-checkbox">
                    <input type="checkbox" v-model="modalItem.selected" />
                    <span class="modal-item-name">{{ modalItem.nombre }}</span>
                  </span>
                  <span class="modal-item-meta">
                    <span>Cantidad: {{ modalItem.cantidad }}</span>
                    <span class="modal-item-price">
                      Precio unitario: {{ formatCurrency(modalItem.precio) }}
                    </span>
                  </span>
                </div>
                <span class="modal-item-total">
                  {{ formatCurrency(modalItem.cantidad * modalItem.precio) }}
                </span>
              </label>
            </div>
          </div>
          <div v-else class="modal-items-empty">
            Este presupuesto no incluye ítems para seleccionar.
          </div>
          <div v-if="chatBudgetModal.error" class="modal-error">{{ chatBudgetModal.error }}</div>
        </div>
        <footer class="modal-footer">
          <button
            type="button"
            class="btn-outline"
            @click="closeChatBudgetModal"
            :disabled="chatBudgetModal.loading"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn-primary"
            @click="confirmChatBudgetApproval"
            :disabled="chatBudgetModal.loading"
          >
            {{ chatBudgetModal.loading ? 'Procesando…' : 'Aprobar presupuesto' }}
          </button>
        </footer>
      </div>
    </div>

    <!-- Modal for payment handling -->
    <div
      v-if="payOrderModal.visible"
      class="modal-overlay"
      @click.self="closePayOrderModal"
    >
      <div class="modall payment-action-modal">
        <h3>{{ payOrderModalTitle }}</h3>
        <div v-if="payOrderModal.loading" class="payment-modal-state">
          Cargando medios de pago...
        </div>
        <template v-else-if="payOrderModal.step === 'result'">
          <div class="payment-result-panel" :class="`payment-result-panel--${payOrderModal.resultStatus || 'success'}`">
            <img
              :src="payOrderResultIcon"
              alt=""
              class="payment-result-icon"
            >
            <h4>{{ payOrderResultTitle }}</h4>
            <p>{{ payOrderResultText }}</p>
          </div>
        </template>
        <template v-else-if="payOrderModal.step === 'options'">
          <p>
            Puedes pagar esta solicitud de inmediato o aceptarla para agregarla a la nómina de pagos pendientes.
          </p>
          <div class="payment-summary-box">
            <div>
              <span class="summary-label">Solicitud de pago</span>
              <strong>#{{ payOrderModalSolicitudPagoId }}</strong>
            </div>
            <div>
              <span class="summary-label">Total</span>
              <strong>{{ formatCurrency(payOrderModalTotal) }}</strong>
            </div>
          </div>
          <div v-if="payOrderModal.error" class="modal-error">{{ payOrderModal.error }}</div>
        </template>
        <template v-else>
          <p>
            Revisa el detalle y elige el medio para pagar esta solicitud ahora. Esto no la agrega a la nómina.
          </p>
          <div class="payment-summary-box">
            <div>
              <span class="summary-label">Solicitud de pago</span>
              <strong>#{{ payOrderModalSolicitudPagoId }}</strong>
            </div>
            <div>
              <span class="summary-label">Total a pagar ahora</span>
              <strong>{{ formatCurrency(payOrderModalTotal) }}</strong>
            </div>
          </div>
          <div class="payment-methods-panel" v-if="payOrderModalTotal > 0">
            <button
              type="button"
              class="payment-method-option"
              :class="{ active: payOrderModal.selectedMethod === 'transbank' }"
              :disabled="payOrderModal.processing || !payOrderModal.paymentMethods.transbank"
              @click="payOrderModal.selectedMethod = 'transbank'"
            >
              Transbank
            </button>
            <button
              v-if="payOrderModal.paymentMethods.khipu"
              type="button"
              class="payment-method-option"
              :class="{ active: payOrderModal.selectedMethod === 'khipu' }"
              :disabled="payOrderModal.processing"
              @click="payOrderModal.selectedMethod = 'khipu'"
            >
              Khipu transferencia
            </button>
            <button
              v-if="payOrderModal.paymentMethods.mercado_pago"
              type="button"
              class="payment-method-option"
              :class="{ active: payOrderModal.selectedMethod === 'mercado_pago' }"
              :disabled="payOrderModal.processing"
              @click="payOrderModal.selectedMethod = 'mercado_pago'"
            >
              Mercado Pago
            </button>
          </div>

          <div v-if="payOrderModal.error" class="modal-error">{{ payOrderModal.error }}</div>
        </template>
        <div v-if="payOrderModal.step === 'result'" class="modal-buttons payment-modal-actions">
          <button class="btn-primary" @click="closePayOrderModal">Cerrar</button>
        </div>
        <div v-else-if="payOrderModal.step === 'options'" class="modal-buttons payment-modal-actions">
          <button class="btn-secondary" @click="closePayOrderModal" :disabled="payOrderModal.processing">Cerrar</button>
          <button
            class="btn-outline"
            @click="addPaymentRequestToPayroll"
            :disabled="payOrderModal.loading || payOrderModal.processing || payOrderModalTotal <= 0"
          >
            {{ payOrderModal.processing === 'payroll' ? 'Agregando...' : 'Aceptar y agregar a nómina' }}
          </button>
          <button
            class="btn-primary"
            @click="openImmediatePaymentStep"
            :disabled="payOrderModal.loading || payOrderModal.processing || payOrderModalTotal <= 0"
          >
            Pagar ahora
          </button>
        </div>
        <div v-else class="modal-buttons payment-modal-actions">
          <button class="btn-secondary" @click="payOrderModal.step = 'options'" :disabled="payOrderModal.processing">Volver</button>
          <button class="btn-secondary" @click="closePayOrderModal" :disabled="payOrderModal.processing">Cerrar</button>
          <button
            class="btn-primary"
            @click="goToSelectedPaymentProvider"
            :disabled="payOrderModal.loading || payOrderModal.processing || payOrderModalTotal <= 0"
          >
            {{ payOrderModal.processing === 'immediate' ? 'Redirigiendo...' : 'Ir a pagar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal for Enviar Presupuesto -->
    <div v-if="modalEnviarPresupuestoVisible" class="modal-overlay" @click.self="cerrarModalEnviarPresupuesto">
      <div class="modall">
        <h3>Enviar Presupuesto</h3>
        <table class="modal-inputs">
          <tr>
            <td><label>Nombre:</label></td>
            <td><input type="text" v-model="presupuestoNombre" /></td>
          </tr>
          <tr>
            <td><label>Notas Adicionales:</label></td>
            <td><textarea v-model="presupuestoNotasAdicionales"></textarea></td>
          </tr>
          <tr>
            <td><label>Items:</label></td>
            <td>
              <div v-if="selectedSolicitud && selectedSolicitud.orden && selectedSolicitud.orden.servicios">
                <div v-for="servicio in selectedSolicitud.orden.servicios" :key="servicio.id">
                  <label>
                    <input type="checkbox" :value="servicio" v-model="presupuestoItems" :checked="true" />
                    {{ servicio.nombre }} - ${{ Intl.NumberFormat('de-DE').format(servicio.precio) }}
                  </label>
                </div>
              </div>
              <div v-else>
                No hay servicios disponibles.
              </div>
            </td>
          </tr>
        </table>
        <div class="modal-buttons">
          <button @click="vistaPreviaPresupuesto">Vista Previa</button>
          <button @click="enviarPresupuesto">Enviar</button>
          <button @click="cerrarModalEnviarPresupuesto">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Modal for rechazarPresupuesto -->
    <div v-if="modalRechazarPresupuestoVisible" class="modal-overlay" @click.self="cerrarModalRechazarPresupuesto">
  <div class="modall">
    <h3>Rechazar Presupuesto</h3>
    <table class="modal-inputs">
      <tr>
        <td><label>Comentario:</label></td>
        <td>
          <textarea v-model="modalRechazarPresupuestoComentario"></textarea>
        </td>
      </tr>
    </table>
    <div class="modal-buttons">
      <button class="red-button" @click="rechazarPresupuesto(presupuestoRechazar)">Rechazar</button>
      <button @click="cerrarModalRechazarPresupuesto">Cancelar</button>
    </div>
  </div>
</div>

    <!-- Modal para Subir Datos de Facturación -->
    <!-- Modal para Crear Factura -->
    <div v-if="modalCrearFacturaVisible" class="modal-overlay" @click.self="cerrarModalCrearFactura">
  <div class="modall">
    <h3>Crear Factura</h3>
    <table class="modal-inputs">
      <tr>
        <td><label>Nombre/Razón Social:</label></td>
        <td><input type="text" v-model="facturaNombreCliente" /></td>
      </tr>
      <tr>
        <td><label>RUT:</label></td>
        <td><input type="text" v-model="facturaRutCliente" /></td>
      </tr>
      <tr>
        <td><label>Email (opcional):</label></td>
        <td><input type="email" v-model="facturaEmailCliente" /></td>
      </tr>
    </table>

    <div class="checkbox-opcional">
      <label>
        <input 
          type="checkbox" 
          :disabled="!facturaEmailCliente.trim()" 
          v-model="enviarPorCorreo" 
        />
        Enviar factura por correo al cliente
      </label>
    </div>

    <div class="presupuestos-aprobados" v-if="selectedSolicitud && selectedSolicitud.orden && selectedSolicitud.orden.presupuestos">
      <h4>Presupuestos Aprobados</h4>
      <div 
        v-for="presupuesto in selectedSolicitud.orden.presupuestos" 
        :key="presupuesto.id"
        v-if="presupuesto.estado === 2"
      >
      <input 
                type="checkbox" 
                :checked="allItemsSelected(presupuesto)" 
                @change="toggleSelectAllItems(presupuesto)" 
              /> 
        <h5 @click="togglePresupuesto(presupuesto)" style="cursor: pointer; user-select: none; display: inline-block; margin-left: 4px;">
          
          Presupuesto #{{ presupuesto.id }} 
          <span v-if="presupuesto.desgloce && presupuesto.desgloce.items">
            (${{Intl.NumberFormat('de-DE').format(presupuesto.desgloce.items.reduce((suma, item)=> suma + item.precio, 0))}})
          </span> 
          
          <span v-if="presupuesto.expanded">[-]</span>
          <span v-else>[+]</span>
        </h5>
        
        <!-- Solo mostrar contenido si el presupuesto esta expandido -->
        <div v-if="presupuesto.expanded">

          <!-- Checkbox para seleccionar todos los ítems de este presupuesto -->
          <div>

          </div>

          <!-- Listado de ítems del presupuesto -->
          <div v-if="presupuesto.desgloce && presupuesto.desgloce.items && presupuesto.desgloce.items.length">
            <div v-for="item in presupuesto.desgloce.items" :key="item.id" style="margin-left:20px;">
              <label>
                <input 
                  type="checkbox" 
                  :value="item.id" 
                  v-model="facturaItems"
                />
                {{ item.nombre }} - ${{ Intl.NumberFormat('de-DE').format(item.precio) }}
              </label>
            </div>
          </div>
          <div v-else>
            <p>No hay ítems disponibles en este presupuesto.</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p>No hay presupuestos disponibles.</p>
    </div>

    <div class="modal-buttons">
      <button @click="subirFactura">Generar Factura</button>
      <button @click="cerrarModalCrearFactura">Cancelar</button>
    </div>
  </div>
</div>

</div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import DownloadFotoOrden from '@/components/DownloadFotoOrden.vue';
import ImagePreviewModal from '@/components/ImagePreviewModal.vue';
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';
import { markMensajesVistos } from '@/api/propertyManager';
import io from 'socket.io-client';
import ModalPerfilProfesional from '@/components/ModalPerfilProfesional.vue';
import OrdenTrackingModal from '@/components/OrdenTrackingModal.vue';
import iconAppoint from '@/assets/iconos/appoint.svg';
import iconCheckCircle from '@/assets/iconos/check-circle.svg';
import iconXCircle from '@/assets/iconos/x-circle.svg';
import iconLinkPago from '@/assets/iconos/link_pago.svg';
import iconBudget from '@/assets/iconos/budget.svg';
import notificationAudioDataUri from '@/assets/audio/bongosDataUri';

const ESTADO_PAGO_EN_REVISION = 3;
const ESTADO_ORDEN_CONFIRMADO = 2;
const ESTADO_PRESUPUESTO_ACEPTADO = 2;
const ESTADO_PRESUPUESTO_RECHAZADO = 10;

export default {
  name: 'SolicitudesCliente',
  components: {
    SideNav,
    TopNav,
    ImagePreviewModal,
    DownloadFotoOrden,
    OrdenTrackingModal,
    ModalPerfilProfesional,
  },
  data() {
    return {

      trackingOpen:false,

      presupuesto_activeTooltip: null, // holds the presupuesto for the tooltip
      presupuesto_tooltipX: 0,
      presupuesto_tooltipY: 0,

      currentTab: 'active',
      solicitudes: [],
      loaded: false,
      searchQuery: '', // Added searchQuery data property
      contextMenuVisible: false,
      contextMenuX: 0,
      contextMenuY: 0,
      selectedSolicitud: null,
      modalVisible: false,
      nuevoComentario: '',
      modalSubirArchivoVisible: false,
      modalRechazarPresupuestoVisible:false,
      modalPerfilVisible: false,
      profesionalSeleccionado: null,
      modalRechazarPresupuestoComentario:'',
      presupuestoRechazar: null,
      archivoTipo: '',
      archivoSeleccionado: null,
      modalAgregarPagoVisible: false,
      nuevoPagoMonto: null,
      nuevoPagoFecha: null,
      nuevoPagoRecibidoPor: 'jobbing',
      pagoArchivoSeleccionado: null,
      ESTADO_PAGO_EN_REVISION,
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      preventClick: false,
      modalEnviarPresupuestoVisible: false,
      presupuestoNombre: '',
      presupuestoNotasAdicionales: '',
      presupuestoItems: [],
      modalEditarSolicitudVisible: false,
      editedSolicitud: {},
      dateFilter: 'last_4_months', // Nuevo: Filtro de fecha por defecto "Hace dos meses"
      isImageModalVisible: false,    // Clearly named state for ImagePreviewModal
      currentModalImage: '',          // Holds the URL of the image to display

      //Modal datos de facturación
      modalCrearFacturaVisible: false,
      facturaNombreCliente: '',
      facturaRutCliente: '',
      facturaEmailCliente: '',
      enviarPorCorreo: false,
      facturaItems: [],

      acceptVisitModal: {
        visible: false,
        solicitud: null,
        message: null,
        loading: false
      },
      payOrderModal: {
        visible: false,
        solicitud: null,
        message: null,
        loading: false,
        processing: null,
        error: '',
        step: 'options',
        selectedMethod: 'transbank',
        paymentMethods: {
          transbank: true,
          khipu: false,
          mercado_pago: false
        },
        pricing: null,
        solicitudPago: null,
        resultStatus: null,
        resultPagoId: null
      },

      chatBudgetModal: {
        visible: false,
        solicitud: null,
        message: null,
        presupuesto: null,
        items: [],
        error: '',
        loading: false,
      },

      socket: null,
      notificationAudio: null,
      notificationAudioUrl: notificationAudioDataUri,
      deepLinkApplied: false,
      initializedSolicitudes: false,
    };
  },
  computed: {
    ...mapGetters(['admin_datos', 'comunas', 'token']),

    detailsColspan() {
      let columns = 25;
      if (this.admin_datos && this.admin_datos.user_type === 'jobbing_admin') {
        columns += 4;
      }
      if (this.hasMargenCaptacion()) {
        columns += 2;
      }
      return columns;
    },

    payOrderModalSolicitudPagoId() {
      const solicitudPago = this.getPayOrderSolicitudPago();
      return solicitudPago && solicitudPago.id ? solicitudPago.id : '';
    },

    payOrderModalTotal() {
      if (
        this.payOrderModal.pricing &&
        this.payOrderModal.pricing.total !== null &&
        this.payOrderModal.pricing.total !== undefined
      ) {
        return Number(this.payOrderModal.pricing.total) || 0;
      }
      const solicitudPago = this.getPayOrderSolicitudPago();
      if (!solicitudPago || !Array.isArray(solicitudPago.detalles)) {
        return Number(
          this.payOrderModal.message &&
          this.payOrderModal.message.atributos &&
          this.payOrderModal.message.atributos.orden
            ? this.payOrderModal.message.atributos.orden.monto_servicios
            : 0
        ) || 0;
      }
      return solicitudPago.detalles.reduce((sum, detalle) => {
        const monto = Number(detalle && detalle.monto);
        return sum + (Number.isFinite(monto) ? monto : 0);
      }, 0);
    },
    payOrderModalTitle() {
      if (this.payOrderModal.step === 'result') {
        return 'Resultado del pago';
      }
      return 'Gestionar pago';
    },

    chatBudgetModalHasItems() {
      return Array.isArray(this.chatBudgetModal.items) && this.chatBudgetModal.items.length > 0;
    },
    chatBudgetModalSelectedCount() {
      if (!this.chatBudgetModalHasItems) {
        return 0;
      }
      return this.chatBudgetModal.items.filter(item => item.selected).length;
    },
    chatBudgetModalSelectionTotal() {
      if (!this.chatBudgetModalHasItems) {
        return 0;
      }
      return this.chatBudgetModal.items
        .filter(item => item.selected)
        .reduce((total, item) => total + item.cantidad * item.precio, 0);
    },
    chatBudgetModalAllSelected() {
      if (!this.chatBudgetModalHasItems) {
        return false;
      }
      return this.chatBudgetModal.items.every(item => item.selected);
    },

    filteredSolicitudes() {

      var ret_;
      if (this.currentTab === 'active') {
        ret_ = this.solicitudes.filter(solicitud => solicitud.estado_front.estado !== 'Terminada' && solicitud.estado != 10);
      } else if (this.currentTab === 'inactive') {
        ret_ = this.solicitudes.filter(solicitud => solicitud.estado_front.estado === 'Terminada' && solicitud.estado != 10);
      }
      else if (this.currentTab === 'eliminadas') {
        ret_ = this.solicitudes.filter(solicitud => solicitud.estado == 10);
      }
      else if (this.currentTab === 'accion requerida') {
        ret_ = this.solicitudes.filter(solicitud => (this.solicitudRequiereAccion(solicitud, "Aprobar presupuesto") || this.solicitudRequiereAccion(solicitud, "Pagar")) && solicitud.estado != 10);
      }
      if (!this.searchQuery) {
        return ret_;
      }
      const query = this.searchQuery.toLowerCase();
      return ret_.filter(solicitud => {
          const comuna = solicitud.comuna_nombre ? solicitud.comuna_nombre.toLowerCase() : '';
          const titulo = solicitud.titulo ? solicitud.titulo.toLowerCase() : '';
          const estado = solicitud.estado_front && solicitud.estado_front.estado ? solicitud.estado_front.estado.toLowerCase() : '';
          const direccion = solicitud.direccion ? solicitud.direccion.toLowerCase() : '';
          const descripcion = solicitud.descripcion ? solicitud.descripcion.toLowerCase() : '';
          const empresa = solicitud.empresa && solicitud.empresa.nombre ? solicitud.empresa.nombre.toLowerCase() : '';
          const ordenId = solicitud.orden && solicitud.orden.id ? solicitud.orden.id.toString() : '';
          return (
            comuna.includes(query) ||
            titulo.includes(query) ||
            estado.includes(query) ||
            direccion.includes(query) ||
            empresa.includes(query) ||
            descripcion.includes(query) ||
            ordenId.includes(query) ||
            solicitud.id.toString().includes(query)
          );
      });
    },
  
  },
  methods: {
    hasSolicitudDeepLink() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      return Boolean(
        query.solicitud_id ||
        query.solicitudId ||
        query.pago_id ||
        query.pagoId ||
        query.payment_status ||
        query.paymentStatus
      );
    },
    prepareDeepLinkDateFilter() {
      if (this.hasSolicitudDeepLink()) {
        this.dateFilter = 'all';
      }
    },
    initializeSolicitudesAfterAuth() {
      if (this.initializedSolicitudes) return;
      if (!this.admin_datos) return;
      if (this.admin_datos.user_type !== 'property_manager' && this.admin_datos.user_type !== 'jobbing_admin') {
        this.$router.push('/');
        return;
      }
      this.initializedSolicitudes = true;
      this.prepareDeepLinkDateFilter();
      this.fetchSolicitudes();
    },
    openProfessionalProfile(seo) {
      if (!seo) {
        return;
      }
      if (this.$refs && this.$refs.modalPerfil) {
        this.$refs.modalPerfil.openByNombreSeo(seo);
      }
    },
    openProfessionalProfileByMessage(solicitud, message) {
      const seo = this.resolveProfessionalSeo(solicitud, message);
      if (seo) {
        this.openProfessionalProfile(seo);
      }
    },
    findSolicitudMessageByQuery(solicitud, query) {
      if (!solicitud) return null;
      const mensajes = [
        ...(solicitud.mensajes_profesional || solicitud.mensaje_profesional || []),
        ...(solicitud.mensajes_cliente || solicitud.mensaje_cliente || [])
      ];
      const mensajeId = query && (query.mensaje_id || query.mensajeId);
      if (mensajeId) {
        const byId = mensajes.find(msg => String(msg.id) === String(mensajeId));
        if (byId) return byId;
      }
      return mensajes
        .slice()
        .reverse()
        .find(msg => msg && msg.atributos && msg.atributos.orden) || null;
    },
    findSolicitudPaymentTargetByPagoId(pagoId) {
      if (!pagoId || !Array.isArray(this.solicitudes)) {
        return { solicitud: null, message: null };
      }
      const pagoIdStr = String(pagoId);
      for (const solicitud of this.solicitudes) {
        const orden = solicitud && solicitud.orden ? solicitud.orden : null;
        if (orden) {
          const pagos = Array.isArray(orden.pagos) ? orden.pagos : [];
          if (pagos.some(pago => String(pago.id) === pagoIdStr)) {
            return {
              solicitud,
              message: this.findSolicitudMessageByPagoId(solicitud, pagoId)
            };
          }
          const solicitudPagos = Array.isArray(orden.solicitud_pagos) ? orden.solicitud_pagos : [];
          if (solicitudPagos.some(sp => String(sp.pago_id) === pagoIdStr || (sp.pago && String(sp.pago.id) === pagoIdStr))) {
            return {
              solicitud,
              message: this.findSolicitudMessageByPagoId(solicitud, pagoId)
            };
          }
        }
        const message = this.findSolicitudMessageByPagoId(solicitud, pagoId);
        if (message) {
          return { solicitud, message };
        }
      }
      return { solicitud: null, message: null };
    },
    findSolicitudMessageByPagoId(solicitud, pagoId) {
      if (!solicitud || !pagoId) return null;
      const pagoIdStr = String(pagoId);
      const mensajes = [
        ...(solicitud.mensajes_profesional || solicitud.mensaje_profesional || []),
        ...(solicitud.mensajes_cliente || solicitud.mensaje_cliente || [])
      ];
      return mensajes.find((msg) => {
        const order = msg && msg.atributos ? msg.atributos.orden : null;
        const solicitudPago = order && order.solicitud_pago ? order.solicitud_pago : null;
        if (!solicitudPago) return false;
        return String(solicitudPago.pago_id) === pagoIdStr ||
          (solicitudPago.pago && String(solicitudPago.pago.id) === pagoIdStr);
      }) || null;
    },
    applySolicitudDeepLink() {
      if (this.deepLinkApplied) return;
      const query = this.$route && this.$route.query ? this.$route.query : {};
      const solicitudId = Number(query.solicitud_id || query.solicitudId);
      const pagoId = Number(query.pago_id || query.pagoId);
      const paymentStatus = query.payment_status || query.paymentStatus;
      if (!Array.isArray(this.solicitudes)) return;

      let solicitud = solicitudId
        ? this.solicitudes.find(item => Number(item.id) === solicitudId)
        : null;
      let targetMessage = null;
      if (solicitud) {
        targetMessage = this.findSolicitudMessageByQuery(solicitud, query);
      } else if (pagoId) {
        const pagoTarget = this.findSolicitudPaymentTargetByPagoId(pagoId);
        solicitud = pagoTarget.solicitud;
        targetMessage = pagoTarget.message;
      }

      if (!solicitud) {
        if (paymentStatus) {
          this.deepLinkApplied = true;
          this.openPaymentResultModal(null, null, paymentStatus, pagoId || null);
        }
        return;
      }
      this.deepLinkApplied = true;

      if (Number(solicitud.estado) === 10) {
        this.currentTab = 'eliminadas';
      } else if (solicitud.estado_front && solicitud.estado_front.estado === 'Terminada') {
        this.currentTab = 'inactive';
      } else {
        this.currentTab = 'active';
      }

      solicitud.activeTab = 'chats';
      const targetProfessionalId =
        targetMessage &&
        (targetMessage.profesional_id ||
          targetMessage.profesionalId ||
          (targetMessage.atributos && targetMessage.atributos.profesional_id));
      const conversations = this.groupMessagesByProfessional(solicitud);
      if (targetProfessionalId) {
        solicitud.activeChat = targetProfessionalId;
      } else if (conversations.length) {
        solicitud.activeChat = conversations[0].profesionalId;
      }

      this.$nextTick(() => {
        const index = this.filteredSolicitudes.findIndex(item => Number(item.id) === solicitudId);
        if (index >= 0) {
          const detailsRow = document.getElementById(`details${index}`);
          if (detailsRow) {
            detailsRow.style.display = 'table-row';
            const anchorRow = detailsRow.previousElementSibling || detailsRow;
            if (anchorRow && typeof anchorRow.scrollIntoView === 'function') {
              anchorRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        }
        if (
          paymentStatus
        ) {
          if (paymentStatus === 'success' && targetMessage) {
            this.markPaymentRequestPaid(solicitud, targetMessage, pagoId || null);
          }
          this.openPaymentResultModal(solicitud, targetMessage, paymentStatus, pagoId || null);
        } else if (
          query.action === 'visita' &&
          targetMessage &&
          targetMessage.atributos &&
          this.canAcceptFreeVisit(targetMessage.atributos.orden)
        ) {
          this.openAcceptFreeVisitModal(solicitud, targetMessage);
        } else if (
          query.action === 'pago' &&
          targetMessage &&
          targetMessage.atributos &&
          this.canManagePayment(targetMessage.atributos.orden)
        ) {
          this.openPayOrderModal(solicitud, targetMessage);
        }
      });
    },
    resolveProfessionalSeo(solicitud, message) {
      if (!message) {
        return '';
      }
      const atributos = message && message.atributos ? message.atributos : null;
      const directSeo = this.getFirstNonEmptyString(
        message.profesionalSeo,
        message.profesional_nombre_seo,
        atributos && atributos.profesional_nombre_seo
      );
      if (directSeo) {
        return directSeo;
      }
      const profesionalId =
        message.profesional_id ||
        message.profesionalId ||
        (atributos && atributos.profesional_id);
      if (profesionalId) {
        const conversation = this.groupMessagesByProfessional(solicitud).find(
          conv => conv.profesionalId === profesionalId
        );
        if (conversation && conversation.profesionalSeo) {
          return conversation.profesionalSeo;
        }
      }
      return '';
    },
    esServicioRealizado(servicio) {
      if (!servicio) {
        return false;
      }
      const value = servicio.realizado;
      if (value !== undefined && value !== null) {
        if (typeof value === 'string') {
          const normalized = value.trim().toLowerCase();
          if (['true', '1', 'yes', 'si', 'sí'].includes(normalized)) {
            return true;
          }
          if (['false', '0', 'no', ''].includes(normalized)) {
            return false;
          }
          if (!Number.isNaN(Date.parse(value))) {
            return true;
          }
        } else if (typeof value === 'number') {
          return value !== 0;
        } else if (typeof value === 'boolean') {
          return value;
        } else if (value) {
          return true;
        }
      }
      const completion = servicio.fecha_realizado || servicio.realizado_fecha;
      if (typeof completion === 'string' && completion.trim() !== '' && !Number.isNaN(Date.parse(completion))) {
        return true;
      }
      if (completion && typeof completion === 'object') {
        const year = completion.a ?? completion.ano ?? completion.year;
        const month = completion.m ?? completion.mes;
        const day = completion.d ?? completion.dia;
        if (year && month && day) {
          return true;
        }
      }
      return !!servicio.visita_id;
    },
    getServiciosRealizados(solicitud) {
      if (!solicitud || !solicitud.orden || !Array.isArray(solicitud.orden.servicios)) {
        return [];
      }
      return solicitud.orden.servicios.filter(servicio => this.esServicioRealizado(servicio));
    },
    getTotalServiciosRealizados(solicitud) {
      return this.getServiciosRealizados(solicitud).reduce((total, servicio) => {
        const precio = Number(servicio.precio);
        return total + (Number.isFinite(precio) ? precio : 0);
      }, 0);
    },
    findServicioEnPresupuesto(solicitud, servicio) {
      if (!solicitud || !solicitud.orden || !Array.isArray(solicitud.orden.presupuestos) || !servicio) {
        return null;
      }
      const servicioId = Number(servicio.id);
      if (!Number.isFinite(servicioId)) {
        return null;
      }
      for (const presupuesto of solicitud.orden.presupuestos) {
        if (!presupuesto || !presupuesto.desgloce || !Array.isArray(presupuesto.desgloce.items)) {
          continue;
        }
        const itemCoincidente = presupuesto.desgloce.items.find(item => {
          if (!item) {
            return false;
          }
          const itemId = Number(item.id);
          return Number.isFinite(itemId) && itemId === servicioId;
        });
        if (itemCoincidente) {
          return { presupuesto, item: itemCoincidente };
        }
      }
      return null;
    },
    estaEnPresupuesto(solicitud, servicio) {
      return this.findServicioEnPresupuesto(solicitud, servicio) !== null;
    },
    estaAprobadoEnPresupuesto(solicitud, servicio) {
      const encontrado = this.findServicioEnPresupuesto(solicitud, servicio);
      if (!encontrado) {
        return false;
      }
      const { presupuesto, item } = encontrado;
      const itemAprobado = item.aprobado === undefined ? true : item.aprobado === true;
      if (!itemAprobado) {
        return false;
      }
      const estadoPresupuesto = Number(presupuesto.estado);
      const presupuestoAprobado = estadoPresupuesto === 2;
      const presupuestoMarcadoNoAprobado = presupuesto?.approved === false || presupuesto?.aprobado === false;
      return presupuestoAprobado && !presupuestoMarcadoNoAprobado;
    },
    formatFechaHora(fechaIso) {
      if (!fechaIso) {
        return '';
      }
      const fecha = new Date(fechaIso);
      if (Number.isNaN(fecha.getTime())) {
        return 'Fecha inválida';
      }
      return fecha.toLocaleString('es-CL', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    showTracking(ordenLike){
      console.log("JOJOJOJO")
      // Normaliza lo mínimo que usa el modal
      const o = ordenLike || {}
      this.orden = {
        id: o.id || o.orden_id || o.OrdenID,
        direccion: o.direccion || o.address || '',
        prof_id: o.prof_id || (o.profesional && o.profesional.id),
        lat: o.lat ?? o.dest_lat ?? o.destino_lat ?? o?.destino?.lat,
        lon: o.lon ?? o.dest_lng ?? o.destino_lng ?? o?.destino?.lng,
        token_atencion: o.token_atencion,
        profesional: o.profesional || {
          id: o.prof_id,
          nombre: o.prof_nombre,
          apellido: o.prof_apellido,
          nombre_completo: o.prof_nombre_completo,
        },
      }
      this.trackingOpen = true
    },
    onTerminada(orden){
      this.trackingOpen = false
      // refrescar lista/estado si quieres
    },
    abrirModalProfesional(pro) {
      this.profesionalSeleccionado = pro;
      this.modalPerfilVisible = true;
    },
    cerrarModalProfesional() {
      this.modalPerfilVisible = false;
      this.profesionalSeleccionado = null;
    },

    presupuesto_showTooltip(event, presupuesto) {
      // Capture the hovered presupuesto and set tooltip position with an offset

      const scaleFactor = 0.75;

      this.presupuesto_activeTooltip = presupuesto;
      this.presupuesto_tooltipX = (event.clientX + 10)/scaleFactor;
      this.presupuesto_tooltipY = (event.clientY + 10)/scaleFactor;
    },
    presupuesto_hideTooltip() {
      this.presupuesto_activeTooltip = null;
    },
    formatPrice(value) {
      return Intl.NumberFormat('de-DE').format(value);
    },
    formatPagoFecha(fecha) {
      if (!fecha || typeof fecha !== 'object') {
        return '-';
      }
      const { y, m, d } = fecha;
      if ([y, m, d].some(v => v === undefined || v === null)) {
        return '-';
      }
      try {
        return new Date(y, m - 1, d).toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        });
      } catch (error) {
        console.error('Error formateando fecha de pago:', error);
        return '-';
      }
    },
    calculateTotal() {
      let total = 0;
      if (this.selectedSolicitud && this.selectedSolicitud.orden && this.selectedSolicitud.orden.presupuestos) {
        this.selectedSolicitud.orden.presupuestos.forEach(presupuesto => {
          if (presupuesto.desgloce && presupuesto.desgloce.items) {
            presupuesto.desgloce.items.forEach(item => {
              if (this.facturaItems.includes(item.id)) {
                total += item.precio;
              }
            });
          }
        });
      }
      return total;
    },
    async subirFactura() {
      // Validate inputs
      if (!this.facturaNombreCliente.trim() || !this.facturaRutCliente.trim()) {
        alert('Nombre/Razón Social y RUT son obligatorios.');
        return;
      }

      if (!this.facturaItems.length) {
        alert('Debe seleccionar al menos un ítem para generar la factura.');
        return;
      }

      const total = this.calculateTotal();

      const payload = {
        item_ids: this.facturaItems,
        nombre_razon_social: this.facturaNombreCliente.trim(),
        rut: this.facturaRutCliente.trim(),
        email: this.facturaEmailCliente.trim(),
        enviar_por_email: this.enviarPorCorreo,
        total: total
      };

      try {
        const response = await axios.post(window.hostname + 'api/property_manager/crear_factura', payload);
        if (response.status === 200) {
          alert('Factura creada exitosamente. ID: ' + response.data.factura_id);
          this.cerrarModalCrearFactura();
          // Clear the form and selections
          this.facturaNombreCliente = '';
          this.facturaRutCliente = '';
          this.facturaEmailCliente = '';
          this.enviarPorCorreo = false;
          this.facturaItems = [];
        } else {
          alert('Error al crear la factura. Código de estado: ' + response.status);
        }
      } catch (error) {
        console.error(error);
        alert('Ocurrió un error al crear la factura.');
      }
      this.fetchSolicitudes(false);
    },

   errorMsg(msg){
    this.$notify({
          group: 'foo',
          title: '¡Error!',
          text: msg,
          type:'error'
          });  
   },
   solicitudRequiereAccion(solicitud, accion){

      if(accion == "Aprobar presupuesto"){
        return solicitud.estado_front && solicitud.estado_front.estado == "Pendiente aprobar presupuesto"
      }
      if(accion == "Pagar"){
        return this.getMontoPorPagar(solicitud) > 0
      }
    
      return false
    },
    abrirModalCrearFactura(solicitud_) {
      if(solicitud_ && solicitud_.orden && solicitud_.orden.presupuestos && solicitud_.orden.presupuestos.some((pres_) => pres_.estado == 2))
      {
        this.modalCrearFacturaVisible = true;
        this.contextMenuVisible = false;
        // Limpiar campos al abrir el modal
        this.facturaNombreCliente = '';
        this.facturaRutCliente = '';
        this.facturaEmailCliente = '';
        this.enviarPorCorreo = false;
      }
      else{
        this.errorMsg('No hay presupuestos aprobados en esta solicitud')
      }
    },

    cerrarModalCrearFactura() {
      this.modalCrearFacturaVisible = false;
      this.facturaNombreCliente = '';
      this.facturaRutCliente = '';
      this.facturaEmailCliente = '';
      this.enviarPorCorreo = false;
    },
    togglePresupuesto(presupuesto) {
    presupuesto.expanded = !presupuesto.expanded;
    this.$forceUpdate();

  },
  allItemsSelected(presupuesto) {
    if (!presupuesto.desgloce || !presupuesto.desgloce.items || presupuesto.desgloce.items.length === 0) return false;
    const itemIds = presupuesto.desgloce.items.map(item => item.id);
    return itemIds.every(id => this.facturaItems.includes(id));
  },

  toggleSelectAllItems(presupuesto) {
    if (!presupuesto.desgloce || !presupuesto.desgloce.items || presupuesto.desgloce.items.length === 0) return;

    const itemIds = presupuesto.desgloce.items.map(item => item.id);
    const todosSeleccionados = itemIds.every(id => this.facturaItems.includes(id));

    if (todosSeleccionados) {
      // Si todos estaban seleccionados, removemos sus IDs
      this.facturaItems = this.facturaItems.filter(id => !itemIds.includes(id));
    } else {
      // Si no todos están seleccionados, agregamos los faltantes
      itemIds.forEach(id => {
        if (!this.facturaItems.includes(id)) {
          this.facturaItems.push(id);
        }
      });
    }
  },
  toggleCollapsePresupuesto(presupuestoId) {
    this.$set(this.collapsedPresupuestos, presupuestoId, !this.collapsedPresupuestos[presupuestoId]);
  },

    toggleMostrarTodos(solicitud) {
      if(!solicitud.mostrar_todos_los_comentarios)
        solicitud.mostrar_todos_los_comentarios = true;
      else
        solicitud.mostrar_todos_los_comentarios = false;
      this.$forceUpdate();
    },
    mapPrioridad(solicitud) {
      const prioridades = {
        alta: { className: 'prioridad-alta', text: 'Alta' },
        media: { className: 'prioridad-media', text: 'Media' },
        baja: { className: 'prioridad-baja', text: 'Baja' },
        desconocida: { className: 'prioridad-desconocida', text: 'Desconocida' },
      };

      let prioridad = solicitud.prioridad || (solicitud.atributos && solicitud.atributos.prioridad) || 'media';
      prioridad = String(prioridad).trim().toLowerCase();
      if (!(prioridad in prioridades)) {
        prioridad = 'media';
      }

      return prioridades[prioridad];
    },
    getDetallePresupuesto(presupuesto){
      let detalle_ = 'Detalle del presupuesto: \n';
      if(presupuesto.desgloce && presupuesto.desgloce.items){
        for(var item of presupuesto.desgloce.items)
        {
          detalle_ += item.nombre+': $'+Intl.NumberFormat('de-DE').format(item.precio)+'\n'
        }
      }
      return detalle_;
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return this.extractDate(dateStr).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' });
    },
    openImageModal(imageSrc) {
      this.currentModalImage = imageSrc;
      this.isImageModalVisible = true;
    },
    closeImageModal() {
      this.isImageModalVisible = false;
      this.currentModalImage = '';
    },
      abrirModalEditarSolicitud(solicitud) {
      this.contextMenuVisible = false;
      this.modalEditarSolicitudVisible = true;
      // Create a deep copy to avoid mutating the original object before saving
      this.editedSolicitud = JSON.parse(JSON.stringify(solicitud));
      // Ensure comuna_id is set
      this.editedSolicitud.comuna_id = solicitud.comuna_id;
    },

    cerrarModalEditarSolicitud() {
      this.modalEditarSolicitudVisible = false;
      this.editedSolicitud = {};
    },

    getEstadoPresupuesto(presupuesto) {
      if (!presupuesto || presupuesto.estado == null) {
        return '<span style="color:#FF4136;">Desconocido</span>';
      }

      if (presupuesto.estado === 0) {
        return '<span style="color:#AAAAAA;">Pendiente</span>';
      }else if (presupuesto.estado === 1) {
        return '<span style="color:#FFDC00;">Enviado</span>';
      } else if (presupuesto.estado > 1 && presupuesto.estado < 10) {
        return '<span style="color:#2ECC40;">Aprobado</span>';
      } else if (presupuesto.estado >= 10) {
        return '<span style="color:#FF4136;">Rechazado</span>';
      }

      // Fallback if no condition matches
      return '<span style="color:#FF4136;">Desconocido</span>';
    },

    guardarCambiosSolicitud() {
    // Validate inputs if necessary
      axios
        .post(window.hostname + 'api/property_manager/editar_solicitud', {
          ...this.editedSolicitud,
          comuna_id: this.editedSolicitud.comuna_id, // Ensure comuna_id is sent
        })
        .then(() => {
          alert('Solicitud actualizada exitosamente.');
          this.cerrarModalEditarSolicitud();
          this.fetchSolicitudes(false); // Refresh data
        })
        .catch((e) => {
          console.log('Error al actualizar solicitud:', e);
          alert('Hubo un error al actualizar la solicitud.');
        });
    },

    timeConvert(n) {
      var num = n;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return (rhours < 10 ? '0':'')+rhours + ":"+ (rminutes < 10 ? '0':'') + rminutes + "";
    },
    getMontoPorCobrarAJobbing(solicitud){
      if (!solicitud || !solicitud.orden || !solicitud.orden.pagos || !this.admin_datos || !this.admin_datos.empresa) {
      return 0; // Return 0 if any required data is missing
    }

    // Get the margen_captacion value
    const margenCaptacion = this.admin_datos.empresa.margen_captacion;

    // Calculate the total sum
    const total = solicitud.orden.pagos
      .filter(pago => pago.estado === 1 && pago.recibido_por == 'jobbing' && pago.transferencia_empresa_administracion_id === null)
      .reduce((sum, pago) => sum + (pago.monto * margenCaptacion), 0);

    return total;
    },
    onPagoFileSelected(event) {
      this.pagoArchivoSeleccionado = event.target.files[0];
    },
    hasMargenCaptacion() {
      return this.admin_datos.empresa && this.admin_datos.empresa.margen_captacion != 0
    },
    extractDate(isoString) {
      try {
        const datePart = isoString.split("T")[0];
        const [year, month, day] = datePart.split("-").map(Number);
        return new Date(year, month - 1, day); // Ensure local timezone isn't applied
      } catch (e) {
        return null;
      }
    },
    getFechaCalificacion(solicitud){
      if(solicitud.orden && solicitud.orden.calificacion && solicitud.orden.calificacion.fecha_creado){
        const fecha_creado = solicitud.orden.calificacion.fecha_creado
        return new Date(fecha_creado.a, fecha_creado.m, fecha_creado.d).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' })
      }
      return 'Sin caclificación'
    }, 
    getEstadoVisita(visita) {
      const estados = {
        0: 'Pendiente',
        1: 'Agendada',
        2: 'Confirmada',
        3: 'En proceso',
        4: 'Terminada',
        10: 'Anulada por retraso'
      }
      return estados[visita.estado];
    },
    async fetchSolicitudes(load = true) {
  if (load) {
    this.loaded = false;
  }

  const params = {};
  const today = new Date();
  let startDate = null;

  // Determine the startDate based on the dateFilter
  switch (this.dateFilter) {
    case 'today':
      startDate = new Date();
      break;
    case 'last_7_days':
      startDate = new Date();
      startDate.setDate(today.getDate() - 7);
      break;
    case 'last_30_days':
      startDate = new Date();
      startDate.setDate(today.getDate() - 30);
      break;
    case 'last_2_months':
      startDate = new Date();
      startDate.setMonth(today.getMonth() - 2);
      break;
    case 'last_4_months':
      startDate = new Date();
      startDate.setMonth(today.getMonth() - 4);
      break;
    case 'last_6_months':
      startDate = new Date();
      startDate.setMonth(today.getMonth() - 6);
      break;
    case 'last_12_months':
      startDate = new Date();
      startDate.setMonth(today.getMonth() - 12);
      break;
    case 'since_beginning':
      // No startDate set to fetch all solicitudes from the beginning
      break;
    case 'all':
    default:
      // No startDate set to fetch all solicitudes up to the current date
      break;
  }


    if (startDate && this.dateFilter !== 'since_beginning') {
      params.start_date = startDate.toISOString().split('T')[0];
    }
    params.end_date = today.toISOString().split('T')[0];

    try {
      const response = await axios.get(`${window.hostname}api/property_manager/get_solicitudes`, { params });

      // Sort by latest_activity, newest first
      const sorted = response.data.solicitudes.sort((a, b) => {
        const dateA = a.latest_activity ? new Date(a.latest_activity) : new Date(0);
        const dateB = b.latest_activity ? new Date(b.latest_activity) : new Date(0);
        return dateB - dateA; // descending order
      });
      if (Array.isArray(this.solicitudes)) {
        this.solicitudes.forEach(solicitud => {
          if (Array.isArray(solicitud.newMessageFiles)) {
            solicitud.newMessageFiles.forEach(attachment => {
              if (attachment && attachment.preview) {
                URL.revokeObjectURL(attachment.preview);
              }
            });
          }
        });
      }
      this.solicitudes = sorted.map(s => {
        const mensajesProfesional = (s.mensajes_profesional || s.mensaje_profesional || []).map(m => ({
          ...m,
          fotos: m.fotos || []
        }));
        const mensajesCliente = (s.mensajes_cliente || s.mensaje_cliente || []).map(m => ({
          ...m,
          fotos: m.fotos || []
        }));

        return {
          ...s,
          mensajes_profesional: mensajesProfesional,
          mensajes_cliente: mensajesCliente,
          activeTab: s.orden ? 'orden' : 'contacto',
          activeChat: null,
          newMessage: '',
          newMessageFiles: [],
          isDraggingFiles: false
        };
      });
      this.$nextTick(() => {
        this.applySolicitudDeepLink();
      });
    } catch (error) {
      console.error('Error al cargar solicitudes:', error);
    } finally {
      this.loaded = true;
    }
  },

    toggleDetails(id, event) {
      if (this.preventClick) {
        this.preventClick = false;
        return;
      }

      const ignoredClasses = ['download-button'];
      if (ignoredClasses.some(className => event.target.classList.contains(className))) {
        return;
      }

      const detailsRow = document.getElementById(id);
      if (detailsRow.style.display === 'table-row') {
        detailsRow.style.display = 'none';
      } else {
        detailsRow.style.display = 'table-row';
      }
    },
    hasProfessionalMessages(solicitud) {
      const proMsgs =
        solicitud.mensajes_profesional || solicitud.mensaje_profesional || [];
      return Array.isArray(proMsgs) && proMsgs.length > 0;
    },
    getFirstNonEmptyString(...values) {
      for (const value of values) {
        if (typeof value === 'string') {
          const trimmed = value.trim();
          if (trimmed) {
            return trimmed;
          }
        }
      }
      return '';
    },
    normalizeSenderType(mensaje) {
      if (!mensaje || typeof mensaje !== 'object') return '';
      const raw = mensaje.sender_type;
      if (typeof raw === 'string') return raw;
      if (raw && typeof raw === 'object') {
        if (typeof raw.value === 'string') return raw.value;
        if (typeof raw.name === 'string') return raw.name;
      }
      return raw != null ? String(raw) : '';
    },
    parseMessageAttributes(mensaje) {
      if (!mensaje || typeof mensaje !== 'object') return {};
      const raw = mensaje.atributos;
      if (!raw) return {};
      if (typeof raw === 'string') {
        try {
          return JSON.parse(raw);
        } catch (e) {
          return {};
        }
      }
      if (typeof raw === 'object') {
        return raw;
      }
      return {};
    },
    resolveAdminPropertyName(mensaje) {
      if (!mensaje || typeof mensaje !== 'object') {
        return 'Administrador de Propiedad';
      }
      const explicit = this.getFirstNonEmptyString(
        mensaje.administrador_nombre,
        mensaje.admin_nombre,
        mensaje.sender_name
      );
      if (explicit) {
        return explicit;
      }
      const atributos = this.parseMessageAttributes(mensaje);
      const attrName = this.getFirstNonEmptyString(
        atributos.administrador_nombre,
        atributos.admin_nombre,
        atributos.nombre
      );
      if (attrName) {
        return attrName;
      }
      const senderId =
        mensaje.sender_id ||
        mensaje.administrador_propiedad_id ||
        mensaje.usuario_id;
      if (senderId !== undefined && senderId !== null) {
        return `Administrador ${senderId}`;
      }
      return 'Administrador de Propiedad';
    },
    resolveClientName(mensaje, solicitud) {
      const explicit = this.getFirstNonEmptyString(
        mensaje && mensaje.nombre,
        mensaje && mensaje.usuario_nombre,
        mensaje && mensaje.sender_name
      );
      if (explicit) {
        return explicit;
      }
      const atributos = this.parseMessageAttributes(mensaje || {});
      const attrName = this.getFirstNonEmptyString(
        atributos.usuario_nombre,
        atributos.nombre
      );
      if (attrName) {
        return attrName;
      }
      const parts = [];
      if (solicitud && solicitud.nombre) {
        parts.push(String(solicitud.nombre).trim());
      }
      if (solicitud && solicitud.apellido) {
        parts.push(String(solicitud.apellido).trim());
      }
      const fullName = parts.filter(Boolean).join(' ');
      if (fullName) {
        return fullName;
      }
      return 'Cliente';
    },
    resolveSenderName(mensaje, solicitud) {
      if (!mensaje || typeof mensaje !== 'object') {
        return this.resolveClientName(null, solicitud);
      }
      const senderType = this.normalizeSenderType(mensaje);
      if (senderType === 'profesional') {
        const explicit = this.getFirstNonEmptyString(
          mensaje.profesional_nombre,
          mensaje.sender_name
        );
        if (explicit) {
          return explicit;
        }
        const atributos = this.parseMessageAttributes(mensaje);
        const attrName = this.getFirstNonEmptyString(
          atributos.profesional_nombre,
          atributos.nombre
        );
        if (attrName) {
          return attrName;
        }
        return 'Profesional';
      }
      if (senderType === 'admin_propiedad') {
        return this.resolveAdminPropertyName(mensaje);
      }
      if (senderType === 'administrador' || senderType === 'jobbing_admin') {
        const adminName = this.getFirstNonEmptyString(
          mensaje.administrador_nombre,
          mensaje.admin_nombre,
          mensaje.sender_name
        );
        return adminName || 'Administrador Jobbing';
      }
      return this.resolveClientName(mensaje, solicitud);
    },
    groupMessagesByProfessional(solicitud) {
      const groups = {};
      const proMsgs =
        solicitud.mensajes_profesional || solicitud.mensaje_profesional || [];
      proMsgs.forEach(m => {
        const pid = m.profesional_id;
        let atributos;
        try {
          atributos =
            typeof m.atributos === 'string' ? JSON.parse(m.atributos) : m.atributos;
        } catch (e) {
          atributos = {};
        }
        const profesionalSeo = this.getFirstNonEmptyString(
          m.profesional_nombre_seo,
          atributos && atributos.profesional_nombre_seo
        );
        if (!groups[pid]) {
          groups[pid] = {
            profesionalId: pid,
            profesionalName: m.profesional_nombre || `Profesional ${pid}`,
            profesionalFoto: m.profesional_foto || '',
            profesionalSeo: profesionalSeo || '',
            messages: [],
            unread: 0
          };
        } else {
          if (m.profesional_nombre) groups[pid].profesionalName = m.profesional_nombre;
          if (m.profesional_foto) groups[pid].profesionalFoto = m.profesional_foto;
          if (profesionalSeo) groups[pid].profesionalSeo = profesionalSeo;
        }
        const msgObj = {
          ...m,
          atributos,
          fromName: this.resolveSenderName(m, solicitud),
          fromRole: 'professional',
          foto: m.profesional_foto,
          visto: m.visto,
          fotos: Array.isArray(m.fotos) ? m.fotos : [],
          profesionalSeo: profesionalSeo || ''
        };
        if (!m.visto) groups[pid].unread += 1;
        groups[pid].messages.push(msgObj);
      });
      const cliMsgs =
        solicitud.mensajes_cliente || solicitud.mensaje_cliente || [];
      cliMsgs.forEach(m => {
        const pid = m.profesional_id;
        let atributos;
        try {
          atributos =
            typeof m.atributos === 'string' ? JSON.parse(m.atributos) : m.atributos;
        } catch (e) {
          atributos = {};
        }
        const profesionalSeo = this.getFirstNonEmptyString(
          m.profesional_nombre_seo,
          atributos && atributos.profesional_nombre_seo
        );
        if (!groups[pid]) {
          groups[pid] = {
            profesionalId: pid,
            profesionalName: m.profesional_nombre || `Profesional ${pid}`,
            profesionalFoto: m.profesional_foto || '',
            profesionalSeo: profesionalSeo || '',
            messages: [],
            unread: 0
          };
        } else {
          if (m.profesional_nombre) groups[pid].profesionalName = m.profesional_nombre;
          if (m.profesional_foto) groups[pid].profesionalFoto = m.profesional_foto;
          if (profesionalSeo) groups[pid].profesionalSeo = profesionalSeo;
        }
        const senderType = this.normalizeSenderType(m);
        const fromRole = senderType === 'admin_propiedad' ? 'admin' : 'client';
        groups[pid].messages.push({
          ...m,
          atributos,
          fromName: this.resolveSenderName(m, solicitud),
          fromRole,
          fotos: Array.isArray(m.fotos) ? m.fotos : [],
          profesionalSeo: profesionalSeo || ''
        });
      });
      return Object.values(groups).map(g => {
        g.messages.sort((a, b) => {
          const dateA = this.parseChatTimestamp(a.fecha);
          const dateB = this.parseChatTimestamp(b.fecha);
          if (!dateA && !dateB) return 0;
          if (!dateA) return -1;
          if (!dateB) return 1;
          return dateA - dateB;
        });
        return g;
      });
    },
    getActiveConversation(solicitud) {
      const convs = this.groupMessagesByProfessional(solicitud);
      if (!convs.length) return null;
      if (!solicitud.activeChat) {
        solicitud.activeChat = convs[0].profesionalId;
        this.markConversationAsSeen(solicitud, solicitud.activeChat);
      }
      return convs.find(c => c.profesionalId === solicitud.activeChat) || null;
    },
    getChatMessages(solicitud) {
      const convs = this.groupMessagesByProfessional(solicitud);
      if (!convs.length) return [];
      if (!solicitud.activeChat) {
        solicitud.activeChat = convs[0].profesionalId;
        this.markConversationAsSeen(solicitud, solicitud.activeChat);
      }
      const conv = convs.find(c => c.profesionalId === solicitud.activeChat);
      return conv ? conv.messages : [];
    },
    getChatMessagesWithSeparators(solicitud) {
      const messages = this.getChatMessages(solicitud);
      const result = [];
      let lastLabel = null;
      messages.forEach(m => {
        const label = this.formatChatDate(m.fecha);
        if (label !== lastLabel) {
          result.push({ type: 'separator', label });
          lastLabel = label;
        }
        result.push({ ...m, type: 'message' });
      });
      return result;
    },
    parseChatTimestamp(fecha) {
      if (!fecha) {
        return null;
      }
      if (fecha instanceof Date) {
        return fecha;
      }
      if (typeof fecha === 'number') {
        return new Date(fecha);
      }

      if (typeof fecha === 'string') {
        const trimmed = fecha.trim();
        if (!trimmed) {
          return null;
        }

        if (/Z$|[+-]\d{2}:?\d{2}$/.test(trimmed)) {
          const dateWithZone = new Date(trimmed);
          return Number.isNaN(dateWithZone.getTime()) ? null : dateWithZone;
        }

        const normalized = trimmed.replace('T', ' ').replace(/\.\d+$/, '');
        const parts = normalized.split(/[- :]/).map(part => Number(part));
        if (parts.length >= 3) {
          const [year, month, day, hour = 0, minute = 0, second = 0] = parts;
          if ([year, month, day, hour, minute, second].every(value => Number.isFinite(value))) {
            const localDate = new Date(year, month - 1, day, hour, minute, second);
            return Number.isNaN(localDate.getTime()) ? null : localDate;
          }
        }
      }

      const fallback = new Date(fecha);
      return Number.isNaN(fallback.getTime()) ? null : fallback;
    },
    formatChatDate(fecha) {
      if (typeof fecha === 'string') {
        const trimmed = fecha.trim();
        if (!trimmed) {
          return '';
        }

        const normalized = trimmed.replace('T', ' ');
        const [datePart] = normalized.split(' ');

        if (datePart && /^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
          const [year, month, day] = datePart.split('-').map(Number);
          if ([year, month, day].every(value => Number.isFinite(value))) {
            const today = new Date();
            const todayKey = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
            const yesterday = new Date();
            yesterday.setDate(today.getDate() - 1);
            const yesterdayKey = `${yesterday.getFullYear()}-${String(yesterday.getMonth() + 1).padStart(2, '0')}-${String(yesterday.getDate()).padStart(2, '0')}`;

            if (datePart === todayKey) {
              return 'Hoy';
            }
            if (datePart === yesterdayKey) {
              return 'Ayer';
            }

            const displayDate = new Date(year, month - 1, day);
            if (!Number.isNaN(displayDate.getTime())) {
              return displayDate.toLocaleDateString('es-ES', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              });
            }
          }
          return datePart;
        }

        return trimmed;
      }

      const d = this.parseChatTimestamp(fecha);
      if (!d) return typeof fecha === 'string' ? fecha : '';
      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      if (d.toDateString() === today.toDateString()) return 'Hoy';
      if (d.toDateString() === yesterday.toDateString()) return 'Ayer';
      return d.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    },
    formatTime(fecha) {
      if (typeof fecha === 'string') {
        const trimmed = fecha.trim();
        if (!trimmed) {
          return '';
        }

        const match = trimmed.match(/(\d{1,2}:\d{2})(?::\d{2})?/);
        if (match) {
          return match[1];
        }

        return trimmed;
      }

      const date = this.parseChatTimestamp(fecha);
      if (!date) return '';
      return date.toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    formatCurrency(amount) {
      const value = Number(amount);
      if (!Number.isFinite(value)) {
        return '$0';
      }
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0
      }).format(value);
    },
    hasSpecialContent(item) {
      if (!item || !item.atributos) return false;
      const attrs = item.atributos;
      return Boolean(attrs.orden || attrs.presupuesto);
    },
    getProfessionalDisplayName(solicitud, message) {
      if (message && message.profesional_nombre) {
        return message.profesional_nombre;
      }
      const profesionalId =
        (message && (message.profesional_id || message.profesionalId)) ||
        (solicitud && solicitud.orden && solicitud.orden.profesional_id);
      if (profesionalId) {
        return this.getProfessionalName(solicitud, profesionalId);
      }
      if (message && message.fromName) {
        return message.fromName;
      }
      return 'El profesional';
    },
    getOrderSchedule(order) {
      if (!order) return '';
      const dateText = this.formatOrderDate(order.fecha);
      const desde = this.formatOrderTime(order.desde);
      const hasta = this.formatOrderTime(order.hasta);
      const parts = [];
      if (dateText) {
        parts.push(`el día ${dateText}`);
      }
      if (desde && hasta) {
        parts.push(`entre las ${desde} y las ${hasta} hrs`);
      } else if (desde) {
        parts.push(`a las ${desde} hrs`);
      }
      return parts.join(' ');
    },
    formatOrderDate(value) {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    formatOrderTime(value) {
      if (value === null || value === undefined) return '';
      const numeric = Number(value);
      if (!Number.isFinite(numeric)) return '';
      return this.timeConvert(numeric);
    },
    isPaymentLink(order) {
      if (!order) return false;
      return Number(order.solo_link_de_pago) === 1;
    },
    isPaymentInPayroll(order) {
      if (!order || !order.solicitud_pago) return false;
      const solicitudPago = order.solicitud_pago;
      return Boolean(solicitudPago.en_nomina) ||
        (
          solicitudPago.pago &&
          solicitudPago.pago.metodo_pago === 'nomina administrador' &&
          Number(solicitudPago.pago.estado) !== 1
        );
    },
    isFreeOrder(order) {
      if (!order) return false;
      if (this.isPaymentLink(order)) return false;
      const monto = Number(order.monto_servicios);
      if (Number.isFinite(monto)) {
        return monto === 0;
      }
      const solicitudPago = order.solicitud_pago || {};
      if (Array.isArray(solicitudPago.detalles) && solicitudPago.detalles.length) {
        const total = solicitudPago.detalles.reduce((sum, det) => {
          const val = Number(det && det.monto);
          return sum + (Number.isFinite(val) ? val : 0);
        }, 0);
        return total === 0;
      }
      return false;
    },
    getOrderStatus(order) {
      if (!order) return 'unknown';
      const pago = order.solicitud_pago || {};
      const estado = Number(pago.estado);
      const pagoEstado = pago.pago ? Number(pago.pago.estado) : null;
      if (estado === -1) return 'cancelled';
      if (estado === 1 || pagoEstado === 1) return 'accepted';
      if (this.isPaymentInPayroll(order)) return 'payroll';
      if (order.pagado === 1 || order.pagado === true || order.pagado === '1') {
        return 'accepted';
      }
      return 'pending';
    },
    isOrderAccepted(order) {
      return this.getOrderStatus(order) === 'accepted';
    },
    isOrderCancelled(order) {
      return this.getOrderStatus(order) === 'cancelled';
    },
    getOrderBoxStyle(order) {
      const status = this.getOrderStatus(order);
      if (status === 'accepted') {
        return {
          '--request-border-color': 'rgba(34, 197, 94, 0.45)',
          '--request-bg-color': 'rgba(34, 197, 94, 0.12)'
        };
      }
      if (status === 'cancelled') {
        return {
          '--request-border-color': 'rgba(239, 68, 68, 0.45)',
          '--request-bg-color': 'rgba(239, 68, 68, 0.12)'
        };
      }
      if (status === 'payroll') {
        return {
          '--request-border-color': 'rgba(245, 158, 11, 0.55)',
          '--request-bg-color': 'rgba(245, 158, 11, 0.14)'
        };
      }
      return {
        '--request-border-color': 'rgba(37, 99, 235, 0.45)',
        '--request-bg-color': 'rgba(196, 212, 226, 0.35)'
      };
    },
    getOrderIcon(order) {
      if (this.isOrderAccepted(order)) {
        return iconCheckCircle;
      }
      if (this.isOrderCancelled(order)) {
        return iconXCircle;
      }
      if (this.isPaymentInPayroll(order)) {
        return iconLinkPago;
      }
      if (this.isPaymentLink(order)) {
        return iconLinkPago;
      }
      return iconAppoint;
    },
    getOrderTitle(solicitud, message) {
      const order = message && message.atributos ? message.atributos.orden : null;
      const professionalName = this.getProfessionalDisplayName(solicitud, message);
      if (!order) return professionalName;
      if (this.isOrderCancelled(order)) {
        return this.isPaymentLink(order)
          ? '¡El link de pago ya no está disponible!'
          : '¡La visita ya no está disponible!';
      }
      if (this.isOrderAccepted(order)) {
        return this.isPaymentLink(order)
          ? '¡La solicitud ha sido pagada!'
          : '¡La visita ya está agendada!';
      }
      if (this.isPaymentInPayroll(order)) {
        return '¡La solicitud fue agregada a pagos pendientes!';
      }
      if (this.isPaymentLink(order)) {
        return `¡${professionalName} ha enviado un link de pago!`;
      }
      if (this.isFreeOrder(order)) {
        return `¡${professionalName} propuso una visita sin costo!`;
      }
      return `¡${professionalName} propuso una visita de inspección!`;
    },
    hasOrderServices(order) {
      return Boolean(order && Array.isArray(order.servicios) && order.servicios.length);
    },
    getOrderServices(order) {
      if (!order || !Array.isArray(order.servicios)) return [];
      return order.servicios;
    },
    orderHasActions(order) {
      if (!order || this.getOrderStatus(order) !== 'pending') return false;
      return this.canAcceptFreeVisit(order) || this.canManagePayment(order);
    },
    canAcceptFreeVisit(order) {
      if (!order) return false;
      const solicitudPago = order.solicitud_pago || {};
      return (
        this.getOrderStatus(order) === 'pending' &&
        this.isFreeOrder(order) &&
        Boolean(solicitudPago.id)
      );
    },
    canManagePayment(order) {
      if (!order) return false;
      const solicitudPago = order.solicitud_pago || {};
      if (!solicitudPago.id) return false;
      if (this.getOrderStatus(order) !== 'pending') return false;
      if (this.isPaymentInPayroll(order)) return false;
      return !this.isFreeOrder(order);
    },
    openAcceptFreeVisitModal(solicitud, message) {
      const order = message && message.atributos ? message.atributos.orden : null;
      if (!order) return;
      if (!this.canAcceptFreeVisit(order)) {
        alert('Esta visita no se puede aceptar desde aquí.');
        return;
      }
      this.acceptVisitModal.visible = true;
      this.acceptVisitModal.solicitud = solicitud;
      this.acceptVisitModal.message = message;
      this.acceptVisitModal.loading = false;
    },
    closeAcceptVisitModal() {
      this.acceptVisitModal.visible = false;
      this.acceptVisitModal.solicitud = null;
      this.acceptVisitModal.message = null;
      this.acceptVisitModal.loading = false;
    },
    async confirmAcceptFreeVisit() {
      if (!this.acceptVisitModal.message || !this.acceptVisitModal.solicitud) return;
      const order = this.acceptVisitModal.message.atributos
        ? this.acceptVisitModal.message.atributos.orden
        : null;
      const solicitudPagoId = order && order.solicitud_pago && order.solicitud_pago.id;
      if (!solicitudPagoId) {
        alert('No se encontró la solicitud de pago asociada a esta visita.');
        return;
      }
      this.acceptVisitModal.loading = true;
      try {
        const response = await axios.post(
          `${window.hostname}api/property_manager/aceptar_visita_gratis`,
          {
            solicitud_pago_id: solicitudPagoId
          }
        );
        const message =
          (response && response.data && response.data.message) ||
          'Visita aceptada exitosamente.';
        alert(message);
        this.updateOrderMessageState(
          this.acceptVisitModal.solicitud.id,
          this.acceptVisitModal.message.id
        );
        this.closeAcceptVisitModal();
      } catch (error) {
        console.error('Error al aceptar visita gratis:', error);
        const err =
          (error && error.response && error.response.data && error.response.data.error) ||
          'No fue posible aceptar la visita. Inténtalo más tarde.';
        alert(err);
      } finally {
        this.acceptVisitModal.loading = false;
      }
    },
    updateOrderMessageState(solicitudId, mensajeId) {
      const solicitud = this.solicitudes.find(s => s.id === solicitudId);
      if (!solicitud) return;
      const lists = [
        solicitud.mensajes_profesional || solicitud.mensaje_profesional || [],
        solicitud.mensajes_cliente || solicitud.mensaje_cliente || []
      ];
      lists.forEach(list => {
        list.forEach(msg => {
          if (msg.id === mensajeId) {
            let attrs;
            if (typeof msg.atributos === 'string') {
              try {
                attrs = JSON.parse(msg.atributos);
              } catch (e) {
                attrs = {};
              }
            } else {
              attrs = msg.atributos || {};
            }
            if (!attrs.orden) attrs.orden = {};
            attrs.orden.pagado = 1;
            if (!attrs.orden.solicitud_pago) attrs.orden.solicitud_pago = {};
            attrs.orden.solicitud_pago.estado = 1;
            msg.atributos = attrs;
          }
        });
      });
      if (solicitud.orden) {
        solicitud.orden.pagado = 1;
        if (!solicitud.orden.solicitud_pago) {
          solicitud.orden.solicitud_pago = {};
        }
        solicitud.orden.solicitud_pago.estado = 1;
        if (
          solicitud.orden.estado === null ||
          solicitud.orden.estado === undefined ||
          solicitud.orden.estado === 0
        ) {
          solicitud.orden.estado = ESTADO_ORDEN_CONFIRMADO;
        }
      }
      solicitud.mensajes_profesional = [...(solicitud.mensajes_profesional || [])];
      solicitud.mensajes_cliente = [...(solicitud.mensajes_cliente || [])];
    },
    getPayOrderSolicitudPago() {
      if (this.payOrderModal.solicitudPago) {
        return this.payOrderModal.solicitudPago;
      }
      const order =
        this.payOrderModal.message && this.payOrderModal.message.atributos
          ? this.payOrderModal.message.atributos.orden
          : null;
      return order && order.solicitud_pago ? order.solicitud_pago : null;
    },
    isSolicitudPagoPaid(solicitudPago) {
      if (!solicitudPago) return false;
      return Number(solicitudPago.estado) === 1 ||
        Boolean(solicitudPago.pago && Number(solicitudPago.pago.estado) === 1);
    },
    isSolicitudPagoInPayroll(solicitudPago) {
      if (!solicitudPago) return false;
      return Boolean(solicitudPago.en_nomina) ||
        Boolean(
          solicitudPago.pago &&
          solicitudPago.pago.metodo_pago === 'nomina administrador' &&
          Number(solicitudPago.pago.estado) !== 1
        );
    },
    normalizePaymentResultStatus(status) {
      const value = String(status || 'success').toLowerCase();
      if (['failure', 'failed', 'cancelled', 'canceled', 'cancel', 'error', 'rejected'].includes(value)) {
        return 'cancelled';
      }
      if (['verifying', 'pending', 'processing', 'in_review', 'review'].includes(value)) {
        return 'verifying';
      }
      return 'success';
    },
    openPaymentResultModal(solicitud, message, status = 'success', pagoId = null) {
      const normalizedStatus = this.normalizePaymentResultStatus(status);
      this.payOrderModal.visible = true;
      this.payOrderModal.solicitud = solicitud;
      this.payOrderModal.message = message;
      this.payOrderModal.loading = false;
      this.payOrderModal.processing = null;
      this.payOrderModal.error = '';
      this.payOrderModal.step = 'result';
      this.payOrderModal.resultStatus = normalizedStatus || 'success';
      this.payOrderModal.resultPagoId = pagoId;
    },
    mergeSolicitudPagoIntoMessage(message, solicitudPagoPayload) {
      if (!message || !message.atributos || !solicitudPagoPayload) return;
      if (!message.atributos.orden) message.atributos.orden = {};
      if (!message.atributos.orden.solicitud_pago) message.atributos.orden.solicitud_pago = {};
      message.atributos.orden.solicitud_pago = {
        ...message.atributos.orden.solicitud_pago,
        ...solicitudPagoPayload
      };
      if (this.isSolicitudPagoPaid(message.atributos.orden.solicitud_pago)) {
        message.atributos.orden.pagado = 1;
      }
    },
    markPaymentRequestPaid(solicitud, message, pagoId = null) {
      const payload = {
        estado: 1,
        en_nomina: false
      };
      if (pagoId) {
        payload.pago_id = pagoId;
        payload.pago = {
          id: pagoId,
          estado: 1
        };
      }
      this.mergeSolicitudPagoIntoMessage(message, payload);
      if (solicitud && solicitud.orden) {
        solicitud.orden.pagado = 1;
        const solicitudPagos = Array.isArray(solicitud.orden.solicitud_pagos)
          ? solicitud.orden.solicitud_pagos
          : [];
        solicitudPagos.forEach((sp) => {
          if (!pagoId || String(sp.pago_id) === String(pagoId) || (sp.pago && String(sp.pago.id) === String(pagoId))) {
            sp.estado = 1;
            sp.en_nomina = false;
            sp.pago_id = pagoId || sp.pago_id;
            sp.pago = {
              ...(sp.pago || {}),
              id: pagoId || sp.pago_id,
              estado: 1
            };
          }
        });
        if (message && message.atributos && message.atributos.orden && message.atributos.orden.solicitud_pago) {
          solicitud.orden.solicitud_pago = {
            ...(solicitud.orden.solicitud_pago || {}),
            ...message.atributos.orden.solicitud_pago
          };
        }
      }
      if (solicitud) {
        solicitud.mensajes_profesional = [...(solicitud.mensajes_profesional || [])];
        solicitud.mensajes_cliente = [...(solicitud.mensajes_cliente || [])];
      }
    },
    paymentPayloadForPayOrder() {
      const solicitudPago = this.getPayOrderSolicitudPago();
      return {
        solicitud_id: solicitudPago ? solicitudPago.id : null,
        token: solicitudPago ? solicitudPago.uuid : null,
        parametros: {}
      };
    },
    redirectPost(url, data) {
      const form = document.createElement('form');
      document.body.appendChild(form);
      form.method = 'post';
      form.action = url;
      Object.keys(data || {}).forEach((name) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = data[name];
        form.appendChild(input);
      });
      form.submit();
    },
    async openPayOrderModal(solicitud, message) {
      const order = message && message.atributos ? message.atributos.orden : null;
      if (!order || !order.solicitud_pago || !order.solicitud_pago.id) {
        alert('No se encontró una solicitud de pago asociada a este mensaje.');
        return;
      }
      if (!this.canManagePayment(order)) {
        if (this.isSolicitudPagoPaid(order.solicitud_pago)) {
          this.openPaymentResultModal(solicitud, message, 'success', order.solicitud_pago.pago_id || null);
        } else {
          alert('Esta solicitud de pago ya no está disponible.');
        }
        return;
      }
      if (!order.solicitud_pago.uuid) {
        alert('La solicitud de pago no tiene token para iniciar un pago inmediato.');
        return;
      }
      this.payOrderModal.visible = true;
      this.payOrderModal.solicitud = solicitud;
      this.payOrderModal.message = message;
      this.payOrderModal.loading = true;
      this.payOrderModal.processing = null;
      this.payOrderModal.error = '';
      this.payOrderModal.step = 'options';
      this.payOrderModal.selectedMethod = 'transbank';
      this.payOrderModal.paymentMethods = {
        transbank: true,
        khipu: false,
        mercado_pago: false
      };
      this.payOrderModal.pricing = null;
      this.payOrderModal.solicitudPago = order.solicitud_pago;

      try {
        const response = await axios.post(
          `${window.hostname}api/initialize_pagar_solicitud`,
          this.paymentPayloadForPayOrder()
        );
        this.payOrderModal.solicitudPago = response.data && response.data.solicitud
          ? response.data.solicitud
          : order.solicitud_pago;
        this.mergeSolicitudPagoIntoMessage(message, this.payOrderModal.solicitudPago);
        if (this.isSolicitudPagoPaid(this.payOrderModal.solicitudPago)) {
          this.markPaymentRequestPaid(
            solicitud,
            message,
            this.payOrderModal.solicitudPago.pago_id || (
              this.payOrderModal.solicitudPago.pago ? this.payOrderModal.solicitudPago.pago.id : null
            )
          );
          this.openPaymentResultModal(
            solicitud,
            message,
            'success',
            this.payOrderModal.solicitudPago.pago_id || (
              this.payOrderModal.solicitudPago.pago ? this.payOrderModal.solicitudPago.pago.id : null
            )
          );
          return;
        }
        if (this.isSolicitudPagoInPayroll(this.payOrderModal.solicitudPago)) {
          this.markPaymentRequestInPayroll(solicitud, message, this.payOrderModal.solicitudPago);
          this.payOrderModal.error = 'Esta solicitud ya fue agregada a pagos pendientes.';
          return;
        }
        this.payOrderModal.pricing = response.data ? response.data.pricing : null;
        this.payOrderModal.paymentMethods = response.data && response.data.payment_methods
          ? response.data.payment_methods
          : this.payOrderModal.paymentMethods;
        if (!this.payOrderModal.paymentMethods[this.payOrderModal.selectedMethod]) {
          if (this.payOrderModal.paymentMethods.khipu) {
            this.payOrderModal.selectedMethod = 'khipu';
          } else if (this.payOrderModal.paymentMethods.mercado_pago) {
            this.payOrderModal.selectedMethod = 'mercado_pago';
          } else {
            this.payOrderModal.selectedMethod = 'transbank';
          }
        }
      } catch (error) {
        console.error('Error cargando medios de pago:', error);
        this.payOrderModal.error = 'No fue posible cargar los medios de pago.';
      } finally {
        this.payOrderModal.loading = false;
      }
    },
    closePayOrderModal() {
      if (this.payOrderModal.processing) {
        return;
      }
      this.payOrderModal.visible = false;
      this.payOrderModal.solicitud = null;
      this.payOrderModal.message = null;
      this.payOrderModal.loading = false;
      this.payOrderModal.processing = null;
      this.payOrderModal.error = '';
      this.payOrderModal.step = 'options';
      this.payOrderModal.pricing = null;
      this.payOrderModal.solicitudPago = null;
      this.payOrderModal.resultStatus = null;
      this.payOrderModal.resultPagoId = null;
    },
    openImmediatePaymentStep() {
      if (this.payOrderModal.loading || this.payOrderModal.processing || this.payOrderModalTotal <= 0) {
        return;
      }
      this.payOrderModal.error = '';
      this.payOrderModal.step = 'payment';
    },
    async goToSelectedPaymentProvider() {
      const payload = this.paymentPayloadForPayOrder();
      if (!payload.solicitud_id || !payload.token || this.payOrderModal.processing) {
        return;
      }
      const method = this.payOrderModal.selectedMethod || 'transbank';
      if (!this.payOrderModal.paymentMethods[method]) {
        this.payOrderModal.error = 'El medio de pago seleccionado no está disponible para esta solicitud.';
        return;
      }

      const endpoints = {
        transbank: 'api/property_manager/pagar_solicitud_transbank',
        mercado_pago: 'api/property_manager/pagar_solicitud_mercado_pago',
        khipu: 'api/property_manager/pagar_solicitud_khipu'
      };

      this.payOrderModal.processing = 'immediate';
      this.payOrderModal.error = '';
      try {
        const response = await axios.post(`${window.hostname}${endpoints[method]}`, payload);
        if (method === 'transbank') {
          this.redirectPost(response.data.url, { token_ws: response.data.token });
          return;
        }
        window.location.href = response.data.url;
      } catch (error) {
        console.error('Error iniciando pago:', error);
        this.payOrderModal.error =
          (error && error.response && error.response.data && error.response.data.error) ||
          'No fue posible iniciar el pago.';
        this.payOrderModal.processing = null;
      }
    },
    async addPaymentRequestToPayroll() {
      const solicitudPago = this.getPayOrderSolicitudPago();
      if (!solicitudPago || !solicitudPago.id || this.payOrderModal.processing) {
        return;
      }

      this.payOrderModal.processing = 'payroll';
      this.payOrderModal.error = '';
      try {
        const response = await axios.post(
          `${window.hostname}api/property_manager/solicitud_pago/agregar_nomina`,
          { solicitud_pago_id: solicitudPago.id }
        );
        const responseSolicitudPago =
          response && response.data ? response.data.solicitud_pago : null;
        this.markPaymentRequestInPayroll(
          this.payOrderModal.solicitud,
          this.payOrderModal.message,
          responseSolicitudPago
        );
        alert(
          (response && response.data && response.data.message) ||
          'Solicitud agregada a pagos pendientes.'
        );
        this.payOrderModal.processing = null;
        this.closePayOrderModal();
      } catch (error) {
        console.error('Error agregando solicitud a nómina:', error);
        this.payOrderModal.error =
          (error && error.response && error.response.data && error.response.data.error) ||
          'No fue posible agregar la solicitud a pagos pendientes.';
      } finally {
        this.payOrderModal.processing = null;
      }
    },
    markPaymentRequestInPayroll(solicitud, message, solicitudPagoPayload) {
      const payload = solicitudPagoPayload || {};
      const setAttrs = (attrs) => {
        if (!attrs.orden) attrs.orden = {};
        if (!attrs.orden.solicitud_pago) attrs.orden.solicitud_pago = {};
        attrs.orden.solicitud_pago.en_nomina = true;
        attrs.orden.solicitud_pago.estado = payload.estado !== undefined
          ? payload.estado
          : 0;
        if (payload.pago_id) {
          attrs.orden.solicitud_pago.pago_id = payload.pago_id;
        }
      };

      if (message && message.atributos) {
        setAttrs(message.atributos);
      }

      if (solicitud && solicitud.orden) {
        if (!solicitud.orden.solicitud_pago) {
          solicitud.orden.solicitud_pago = {};
        }
        solicitud.orden.solicitud_pago.en_nomina = true;
        solicitud.orden.solicitud_pago.estado = payload.estado !== undefined
          ? payload.estado
          : 0;
        if (payload.pago_id) {
          solicitud.orden.solicitud_pago.pago_id = payload.pago_id;
        }
      }

      if (solicitud) {
        solicitud.mensajes_profesional = [...(solicitud.mensajes_profesional || [])];
        solicitud.mensajes_cliente = [...(solicitud.mensajes_cliente || [])];
      }
    },
    getBudgetStatus(budget) {
      if (!budget) return 'unknown';

      const aprobadoValue = Number(budget.aprobado);
      if (!Number.isNaN(aprobadoValue)) {
        if (aprobadoValue === 1) return 'approved';
        if (aprobadoValue === -1) return 'rejected';
      }

      const estadoValue = Number(budget.estado);
      if (!Number.isNaN(estadoValue)) {
        if (estadoValue === ESTADO_PRESUPUESTO_ACEPTADO) {
          return 'approved';
        }
        if (estadoValue === ESTADO_PRESUPUESTO_RECHAZADO) {
          return 'rejected';
        }
      }

      if (budget.fecha_aprobado_iso || budget.fecha_aprobado) {
        return 'approved';
      }

      return 'pending';
    },
    isBudgetPending(budget) {
      return this.getBudgetStatus(budget) === 'pending';
    },
    isBudgetApproved(budget) {
      return this.getBudgetStatus(budget) === 'approved';
    },
    isBudgetRejected(budget) {
      return this.getBudgetStatus(budget) === 'rejected';
    },
    getBudgetApprovalDate(budget) {
      if (!budget) {
        return '';
      }
      const approvalIso = budget.fecha_aprobado_iso || budget.fecha_aprobado;
      if (!approvalIso) {
        return '';
      }
      const approvalDate = this.extractDate(approvalIso);
      if (!approvalDate) {
        return '';
      }
      return approvalDate.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    getApprovedBudgetMessage(budget) {
      const approvalDate = this.getBudgetApprovalDate(budget);
      if (approvalDate) {
        return `Ya aprobaste este presupuesto el ${approvalDate}. El profesional fue notificado.`;
      }
      return 'Ya aprobaste este presupuesto. El profesional fue notificado.';
    },
    getBudgetBoxStyle(budget) {
      if (this.isBudgetApproved(budget)) {
        return {
          '--request-border-color': 'rgba(34, 197, 94, 0.45)',
          '--request-bg-color': 'rgba(34, 197, 94, 0.12)'
        };
      }
      if (this.isBudgetRejected(budget)) {
        return {
          '--request-border-color': 'rgba(239, 68, 68, 0.45)',
          '--request-bg-color': 'rgba(239, 68, 68, 0.12)'
        };
      }
      return {
        '--request-border-color': 'rgba(37, 99, 235, 0.45)',
        '--request-bg-color': 'rgba(196, 212, 226, 0.35)'
      };
    },
    getBudgetIcon(budget) {
      if (this.isBudgetApproved(budget)) {
        return iconCheckCircle;
      }
      if (this.isBudgetRejected(budget)) {
        return iconXCircle;
      }
      return iconBudget;
    },
    getBudgetTitle(solicitud, message) {
      const budget = message && message.atributos ? message.atributos.presupuesto : null;
      const professionalName = this.getProfessionalDisplayName(solicitud, message);
      if (!budget) return 'Presupuesto';
      if (this.isBudgetApproved(budget)) {
        return '¡El presupuesto ha sido aprobado!';
      }
      if (this.isBudgetRejected(budget)) {
        return '¡El presupuesto ha sido rechazado!';
      }
      return `¡${professionalName} ha enviado un presupuesto de trabajo!`;
    },
    hasBudgetItems(budget) {
      return Boolean(
        budget &&
        budget.desgloce &&
        Array.isArray(budget.desgloce.items) &&
        budget.desgloce.items.length
      );
    },
    getBudgetItems(budget) {
      if (!budget || !budget.desgloce || !Array.isArray(budget.desgloce.items)) {
        return [];
      }
      return budget.desgloce.items;
    },
    getBudgetNotes(budget) {
      if (!budget || !budget.desgloce) return '';
      const notes = budget.desgloce.notas_adicionales;
      return typeof notes === 'string' ? notes.trim() : '';
    },
    budgetHasActions(budget) {
      return this.canApproveBudget(budget);
    },
    canApproveBudget(budget) {
      return Boolean(budget) && this.isBudgetPending(budget);
    },
    normalizeBudgetId(id) {
      if (id === undefined || id === null) {
        return null;
      }
      const normalized = String(id).trim();
      return normalized || null;
    },
    mergeBudgetDesgloce(primary, fallback) {
      const normalizedPrimary = primary && typeof primary === 'object' ? { ...primary } : {};
      const normalizedFallback = fallback && typeof fallback === 'object' ? { ...fallback } : {};
      const merged = {
        ...normalizedFallback,
        ...normalizedPrimary,
      };
      merged.items = Array.isArray(normalizedPrimary.items)
        ? normalizedPrimary.items
        : Array.isArray(normalizedFallback.items)
          ? normalizedFallback.items
          : [];
      return merged;
    },
    findBudgetMessageForPresupuesto(solicitud, presupuesto) {
      if (!solicitud || !presupuesto) {
        return null;
      }
      const presupuestoId = this.normalizeBudgetId(presupuesto.id);
      if (!presupuestoId) {
        return null;
      }
      const messageSources = [];
      if (Array.isArray(solicitud.mensajes_profesional)) {
        messageSources.push(...solicitud.mensajes_profesional);
      }
      if (Array.isArray(solicitud.mensajes_cliente)) {
        messageSources.push(...solicitud.mensajes_cliente);
      }
      for (const mensaje of messageSources) {
        const atributos = this.parseMessageAttributes(mensaje);
        if (!atributos || !atributos.presupuesto) {
          continue;
        }
        const budget = atributos.presupuesto;
        const budgetId = this.normalizeBudgetId(budget.id);
        if (budgetId && budgetId === presupuestoId) {
          const mergedBudget = {
            ...presupuesto,
            ...budget,
          };
          mergedBudget.desgloce = this.mergeBudgetDesgloce(budget.desgloce, presupuesto.desgloce);
          return {
            ...mensaje,
            atributos: {
              ...atributos,
              presupuesto: mergedBudget,
            },
          };
        }
      }
      return null;
    },
    openChatBudgetApprovalModalFromTable(solicitud, presupuesto) {
      if (!presupuesto) {
        return;
      }
      const message = this.findBudgetMessageForPresupuesto(solicitud, presupuesto);
      if (message) {
        this.openChatBudgetApprovalModal(solicitud, message);
        return;
      }
      const fallbackBudget = {
        ...presupuesto,
      };
      fallbackBudget.desgloce = this.mergeBudgetDesgloce(
        presupuesto && presupuesto.desgloce,
        null,
      );
      this.openChatBudgetApprovalModal(solicitud, {
        atributos: {
          presupuesto: fallbackBudget,
        },
      });
      if (!this.chatBudgetModalHasItems) {
        this.chatBudgetModal.error = 'No se encontraron los ítems del presupuesto. Revisa la conversación para ver el detalle.';
      }
    },
    openChatBudgetApprovalModal(solicitud, message) {
      if (!message || !message.atributos || !message.atributos.presupuesto) {
        return;
      }
      const budget = message.atributos.presupuesto;
      const items = Array.isArray(budget?.desgloce?.items) ? budget.desgloce.items : [];
      this.chatBudgetModal.visible = true;
      this.chatBudgetModal.solicitud = solicitud;
      this.chatBudgetModal.message = message;
      this.chatBudgetModal.presupuesto = budget;
      this.chatBudgetModal.error = '';
      this.chatBudgetModal.loading = false;
      this.chatBudgetModal.items = items.map((item, index) => {
        const cantidadValue = Number(item?.cantidad);
        const precioValue = Number(item?.precio);
        return {
          key: `${budget.id || 'budget'}-${item?.id ?? index}`,
          id: item?.id,
          nombre: item?.nombre || 'Ítem sin nombre',
          cantidad: Number.isFinite(cantidadValue) && cantidadValue > 0 ? cantidadValue : 1,
          precio: Number.isFinite(precioValue) ? precioValue : 0,
          selected: true,
        };
      });
      this.$nextTick(() => {
        const dialog = this.$refs.chatBudgetModalDialog;
        if (dialog && typeof dialog.focus === 'function') {
          dialog.focus();
        }
      });
    },
    onChatBudgetOverlayClick(event) {
      if (event && event.target === event.currentTarget) {
        this.closeChatBudgetModal();
      }
    },
    closeChatBudgetModal(force = false) {
      if (this.chatBudgetModal.loading && !force) {
        return;
      }
      this.chatBudgetModal.visible = false;
      this.chatBudgetModal.solicitud = null;
      this.chatBudgetModal.message = null;
      this.chatBudgetModal.presupuesto = null;
      this.chatBudgetModal.items = [];
      this.chatBudgetModal.error = '';
    },
    toggleChatBudgetSelectAll(event) {
      if (!this.chatBudgetModalHasItems) {
        return;
      }
      const shouldSelectAll = event && event.target ? event.target.checked : !this.chatBudgetModalAllSelected;
      this.chatBudgetModal.items = this.chatBudgetModal.items.map(item => ({
        ...item,
        selected: shouldSelectAll,
      }));
    },
    resolveMessageId(message) {
      if (!message || typeof message !== 'object') {
        return null;
      }
      const candidateKeys = [
        'id',
        'mensaje_id',
        'mensajeId',
        'id_mensaje',
        'mensaje_profesional_id',
      ];
      for (const key of candidateKeys) {
        const value = message[key];
        if (value !== undefined && value !== null && value !== '') {
          const numeric = Number(value);
          return Number.isNaN(numeric) ? value : numeric;
        }
      }
      return null;
    },
    async confirmChatBudgetApproval() {
      if (!this.chatBudgetModal.presupuesto || this.chatBudgetModal.loading) {
        return;
      }
      if (!this.chatBudgetModalHasItems) {
        this.chatBudgetModal.error = 'Este presupuesto no tiene ítems disponibles para aprobar.';
        return;
      }
      const selectedItems = this.chatBudgetModal.items
        .filter(item => item.selected)
        .map(item => item.id)
        .filter(id => id !== undefined && id !== null);
      if (!selectedItems.length) {
        this.chatBudgetModal.error = 'Selecciona al menos un ítem para aprobar.';
        return;
      }
      this.chatBudgetModal.error = '';
      this.chatBudgetModal.loading = true;
      try {
        const mensajeId = this.resolveMessageId(this.chatBudgetModal.message);
        const payload = {
          presupuesto_id: this.chatBudgetModal.presupuesto.id,
          selected_items: selectedItems,
        };
        if (mensajeId !== null) {
          payload.mensaje_id = mensajeId;
        }
        await axios.post(`${window.hostname}api/property_manager/aprobar_presupuesto`, payload);

        const nowIso = new Date().toISOString();
        const approvedIds = new Set(selectedItems);

        if (this.chatBudgetModal.presupuesto) {
          this.chatBudgetModal.presupuesto.aprobado = 1;
          this.chatBudgetModal.presupuesto.estado = ESTADO_PRESUPUESTO_ACEPTADO;
          this.chatBudgetModal.presupuesto.fecha_aprobado_iso = nowIso;
          if (
            this.chatBudgetModal.presupuesto.desgloce &&
            Array.isArray(this.chatBudgetModal.presupuesto.desgloce.items)
          ) {
            this.chatBudgetModal.presupuesto.desgloce.items = this.chatBudgetModal.presupuesto.desgloce.items.map(item => ({
              ...item,
              aprobado: item && item.id !== undefined ? approvedIds.has(item.id) : item?.aprobado,
            }));
          }
        }
        if (
          this.chatBudgetModal.message &&
          this.chatBudgetModal.message.atributos &&
          this.chatBudgetModal.message.atributos.presupuesto
        ) {
          const presupuestoMensaje = this.chatBudgetModal.message.atributos.presupuesto;
          presupuestoMensaje.aprobado = 1;
          presupuestoMensaje.estado = ESTADO_PRESUPUESTO_ACEPTADO;
          presupuestoMensaje.fecha_aprobado_iso = nowIso;
          if (
            presupuestoMensaje.desgloce &&
            Array.isArray(presupuestoMensaje.desgloce.items)
          ) {
            presupuestoMensaje.desgloce.items = presupuestoMensaje.desgloce.items.map(item => ({
              ...item,
              aprobado: item && item.id !== undefined ? approvedIds.has(item.id) : item?.aprobado,
            }));
          }
        }
        this.$notify?.({
          group: 'foo',
          title: 'Presupuesto aprobado',
          text: 'El presupuesto se aprobó correctamente.',
          type: 'success',
        });
        this.closeChatBudgetModal(true);
        await this.fetchSolicitudes(false);
      } catch (error) {
        console.error('Error approving budget from chat:', error);
        const backendError = error?.response?.data?.error;
        if (backendError) {
          this.chatBudgetModal.error = backendError;
        } else {
          this.chatBudgetModal.error = 'No se pudo aprobar el presupuesto. Intente nuevamente.';
        }
      } finally {
        this.chatBudgetModal.loading = false;
      }
    },
    getInitials(nombre) {
      const safeName =
        typeof nombre === 'string'
          ? nombre.trim()
          : nombre !== undefined && nombre !== null
          ? String(nombre).trim()
          : '';
      if (!safeName) {
        return '??';
      }
      return safeName
        .split(/\s+/)
        .map(n => n[0])
        .join('')
        .substring(0, 2)
        .toUpperCase();
    },
    totalUnreadMessages(solicitud) {
      const proMsgs = solicitud.mensajes_profesional || solicitud.mensaje_profesional || [];
      return proMsgs.filter(m => !m.visto).length;
    },
    openChatTab(solicitud) {
      solicitud.activeTab = 'chats';
      const convs = this.groupMessagesByProfessional(solicitud);
      if (convs.length) {
        if (!solicitud.activeChat) solicitud.activeChat = convs[0].profesionalId;
        this.markConversationAsSeen(solicitud, solicitud.activeChat);
      }
      this.scrollToBottom(solicitud);
    },
    setActiveChat(solicitud, pid) {
      solicitud.activeChat = pid;
      this.markConversationAsSeen(solicitud, pid);
    },
    async markConversationAsSeen(solicitud, pid) {
      const convs = this.groupMessagesByProfessional(solicitud);
      const conv = convs.find(c => c.profesionalId === pid);
      if (!conv) return;
      const unseen = conv.messages.filter(m => m.fromRole === 'professional' && !m.visto).map(m => m.id);
      if (!unseen.length) return;
      try {
        await markMensajesVistos(unseen);
        (solicitud.mensajes_profesional || solicitud.mensaje_profesional || []).forEach(m => {
          if (unseen.includes(m.id)) m.visto = true;
        });
      } catch (error) {
        console.error('Error al marcar mensajes vistos:', error);
      }
    },
    getProfessionalName(solicitud, pid) {
      const convs = this.groupMessagesByProfessional(solicitud);
      const conv = convs.find(c => c.profesionalId === pid);
      return conv ? conv.profesionalName : 'Profesional';
    },
    getProfessionalPhoto(solicitud, pid) {
      const convs = this.groupMessagesByProfessional(solicitud);
      const conv = convs.find(c => c.profesionalId === pid);
      return conv ? conv.profesionalFoto : '';
    },
    scrollToBottom(solicitud) {
      this.$nextTick(() => {
        const ref = this.$refs['chatMessages-' + solicitud.id];
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },
    async enviarMensajeAdmin(solicitud) {
      if (!solicitud || !solicitud.activeChat) return;
      const mensaje = (solicitud.newMessage || '').trim();
      const hasAttachments = Array.isArray(solicitud.newMessageFiles) && solicitud.newMessageFiles.length > 0;
      if (!mensaje && !hasAttachments) return;

      const formData = new FormData();
      formData.append('solicitud_id', solicitud.id);
      formData.append('profesional_id', solicitud.activeChat);
      formData.append('mensaje', mensaje);

      if (hasAttachments) {
        solicitud.newMessageFiles.forEach((attachment, index) => {
          if (!attachment || !attachment.file) return;
          const fileName = attachment.file.name || `imagen-${index + 1}`;
          formData.append('imagenes', attachment.file, fileName);
        });
      }

      try {
        const response = await axios.post(
          `${window.hostname}api/property_manager/enviar_mensaje`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        );
        const responseMsg = response.data.mensaje || {};
        const newMsg = {
          ...responseMsg,
          fromName: 'Administrador',
          fromRole: 'admin',
          foto: this.admin_datos.foto,
          profesional_id: solicitud.activeChat,
          visto: true,
          atributos: responseMsg.atributos || {},
          fotos: responseMsg.fotos || []
        };
        const activeProfessionalId = newMsg.profesional_id || solicitud.activeChat;
        newMsg.profesional_nombre = this.getProfessionalName(solicitud, activeProfessionalId);
        newMsg.profesional_foto = this.getProfessionalPhoto(solicitud, activeProfessionalId);
        if (!Array.isArray(solicitud.mensajes_cliente)) {
          this.$set(solicitud, 'mensajes_cliente', []);
        }
        solicitud.mensajes_cliente.push(newMsg);
        solicitud.newMessage = '';
        this.clearChatAttachments(solicitud);
        this.scrollToBottom(solicitud);
      } catch (error) {
        console.error('Error al enviar mensaje:', error);
        const errorMessage =
          (error && error.response && error.response.data && error.response.data.error) ||
          'Ocurrió un error al enviar el mensaje.';
        if (this.$notify) {
          this.$notify({
            group: 'foo',
            title: 'Error',
            text: errorMessage,
            type: 'error'
          });
        }
      }
    },
    canSendChatMessage(solicitud) {
      if (!solicitud || !solicitud.activeChat) return false;
      const mensaje = (solicitud.newMessage || '').trim();
      const attachments = Array.isArray(solicitud.newMessageFiles) ? solicitud.newMessageFiles.length : 0;
      return Boolean(mensaje) || attachments > 0;
    },
    getChatFileInput(solicitud) {
      const ref = this.$refs['chatUpload-' + solicitud.id];
      if (Array.isArray(ref)) {
        return ref[0];
      }
      return ref || null;
    },
    triggerChatFileInput(solicitud) {
      const input = this.getChatFileInput(solicitud);
      if (input) input.click();
    },
    onChatFileChange(solicitud, event) {
      const files = event && event.target ? event.target.files : null;
      this.addChatFiles(solicitud, files);
      this.resetChatFileInput(solicitud);
    },
    addChatFiles(solicitud, files) {
      if (!files || !files.length) return;
      this.ensureChatDraftCollections(solicitud);
      const acceptedExtensions = ['png', 'jpg', 'jpeg', 'gif', 'webp'];
      const added = [];
      let rejected = 0;
      Array.from(files).forEach(file => {
        if (!file) return;
        const typeOk = file.type && file.type.startsWith('image/');
        const extension = (file.name || '').split('.').pop().toLowerCase();
        if (typeOk || acceptedExtensions.includes(extension)) {
          const preview = URL.createObjectURL(file);
          added.push({ file, preview });
        } else {
          rejected += 1;
        }
      });
      if (added.length) {
        solicitud.newMessageFiles.push(...added);
      }
      if (rejected && this.$notify) {
        this.$notify({
          group: 'foo',
          title: 'Formato no soportado',
          text: 'Solo puedes adjuntar imágenes en el chat.',
          type: 'warning'
        });
      }
    },
    removeChatAttachment(solicitud, index) {
      if (!Array.isArray(solicitud.newMessageFiles)) return;
      if (index < 0 || index >= solicitud.newMessageFiles.length) return;
      const [removed] = solicitud.newMessageFiles.splice(index, 1);
      if (removed && removed.preview) {
        URL.revokeObjectURL(removed.preview);
      }
      this.resetChatFileInput(solicitud);
    },
    clearChatAttachments(solicitud) {
      if (Array.isArray(solicitud.newMessageFiles)) {
        solicitud.newMessageFiles.forEach(attachment => {
          if (attachment && attachment.preview) {
            URL.revokeObjectURL(attachment.preview);
          }
        });
        solicitud.newMessageFiles = [];
      }
      solicitud.isDraggingFiles = false;
      this.resetChatFileInput(solicitud);
    },
    resetChatFileInput(solicitud) {
      const input = this.getChatFileInput(solicitud);
      if (input) {
        input.value = '';
      }
    },
    onChatDragOver(solicitud) {
      if (!solicitud) return;
      this.ensureChatDraftCollections(solicitud);
      solicitud.isDraggingFiles = true;
    },
    onChatDragLeave(solicitud, event) {
      if (!solicitud) return;
      if (event && event.currentTarget && event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) {
        return;
      }
      solicitud.isDraggingFiles = false;
    },
    onChatDrop(solicitud, event) {
      if (!solicitud) return;
      const files = event && event.dataTransfer ? event.dataTransfer.files : null;
      solicitud.isDraggingFiles = false;
      this.addChatFiles(solicitud, files);
    },
    ensureChatDraftCollections(solicitud) {
      if (!Array.isArray(solicitud.newMessageFiles)) {
        this.$set(solicitud, 'newMessageFiles', []);
      }
      if (typeof solicitud.isDraggingFiles !== 'boolean') {
        this.$set(solicitud, 'isDraggingFiles', false);
      }
    },
    obtenerURLFoto(foto) {
      return foto['link'];
    },
    getFechaVisita(solicitud) {
      if (solicitud.orden && solicitud.orden.visitas && solicitud.orden.visitas.filter(visita => ![10, 0].includes(visita.estado)).length > 0) {
        return this.extractDate(solicitud.orden.visitas[0].fecha_).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' });
      }
      return 'No hay visita';
    },
    getFechaEnvioPresupuesto(solicitud) {
      if (solicitud.orden && solicitud.orden.presupuestos && solicitud.orden.presupuestos.length > 0) {
        return this.extractDate(solicitud.orden.presupuestos[0].fecha_creado_iso).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' });
      }
      return 'No se ha enviado';
    },
    getMontoTotal(solicitud) {
      if (solicitud.orden && solicitud.orden.presupuestos && solicitud.orden.presupuestos.length > 0) {
        const total = this.getTotalPresupuestosAprobados(solicitud);

        if (total <= 0) {
          return 'No hay presupuestos aprobados aún.';
        }

        return '$' + Intl.NumberFormat('de-DE').format(total);
      }

      return 'No hay presupuesto subidos';
    },
    getTotalPresupuestosAprobados(solicitud) {
      if (!solicitud || !solicitud.orden || !Array.isArray(solicitud.orden.presupuestos)) {
        return 0;
      }

      return solicitud.orden.presupuestos
        .filter((presupuesto) => presupuesto.estado > 1 && presupuesto.estado < 10)
        .reduce((sum, presupuesto) => {
          const montoPresupuesto = Number(this.getTotalApprovedPresupuesto(presupuesto)) || 0;
          return sum + montoPresupuesto;
        }, 0);
    },
    getMontoPagado(solicitud) {
      if (solicitud.orden && solicitud.orden.pagos && solicitud.orden.pagos.length > 0) {
        const totalPagado = solicitud.orden.pagos
          .filter(item => item.estado === 1) // Filter pagos with estado == 1
          .reduce((total, item) => total + (item.monto || 0), 0);
          
        return totalPagado > 0 ? '$' + Intl.NumberFormat('de-DE').format(totalPagado) : 'No hay pagos hechos';
      }
      return 'No hay pagos hechos';
    },
    getMontoPagadoNumero(solicitud) {
      if (solicitud.orden && solicitud.orden.pagos && solicitud.orden.pagos.length > 0) {
        const totalPagado = solicitud.orden.pagos
          .filter(item => item.estado === 1) // Filter pagos with estado == 1
          .reduce((total, item) => total + (item.monto || 0), 0);

        return totalPagado > 0 ? totalPagado : 0;
      }
      return 0;
    },

    payOrderResultIcon() {
      if (this.payOrderModal.resultStatus === 'cancelled') {
        return iconXCircle;
      }
      if (this.payOrderModal.resultStatus === 'verifying') {
        return iconLinkPago;
      }
      return iconCheckCircle;
    },

    payOrderResultTitle() {
      if (this.payOrderModal.resultStatus === 'cancelled') {
        return 'Pago no completado';
      }
      if (this.payOrderModal.resultStatus === 'verifying') {
        return 'Estamos verificando el pago';
      }
      return 'Pago realizado con éxito';
    },

    payOrderResultText() {
      if (this.payOrderModal.resultStatus === 'cancelled') {
        return 'No se confirmó el pago. Puedes volver a intentarlo desde la solicitud si sigue pendiente.';
      }
      if (this.payOrderModal.resultStatus === 'verifying') {
        return 'La transacción quedó en verificación. En unos segundos se actualizará el estado de la solicitud.';
      }
      return 'La solicitud quedó marcada como pagada y el link ya no estará disponible para nuevos pagos.';
    },


    getTotalItemsPresupuesto(presupuesto) {
      if (!presupuesto || typeof presupuesto !== 'object') {
        console.warn('Invalid presupuesto object provided.');
        return 0;
      }

      if (
        !presupuesto.desgloce ||
        !Array.isArray(presupuesto.desgloce.items) ||
        presupuesto.desgloce.items.length === 0
      ) {
        console.warn('Presupuesto has no items to sum.');
        return 0;
      }

      return presupuesto.desgloce.items.reduce((sum, item) => {
        const precio = typeof item.precio === 'number' ? item.precio : parseFloat(item.precio);
        return sum + (isNaN(precio) ? 0 : precio);
      }, 0);
    },


    getTotalApprovedPresupuesto(presupuesto) {
      // Define the approved estado range
      const ESTADO_MIN = 2; // estado > 1
      const ESTADO_MAX = 9; // estado < 10

      // Check if the presupuesto is in an approved estado
      if (!presupuesto || typeof presupuesto !== 'object') {
        console.warn('Invalid presupuesto object provided.');
        return '0';
      }

      if (!(presupuesto.estado > ESTADO_MIN - 1 && presupuesto.estado < ESTADO_MAX + 1)) {
        // Estado not in approved range
        return '0';
      }

      // Ensure desgloce and items exist
      if (
        !presupuesto.desgloce ||
        !Array.isArray(presupuesto.desgloce.items) ||
        presupuesto.desgloce.items.length === 0
      ) {
        console.warn('Presupuesto has no items to sum.');
        return '0';
      }

      // Sum the precio of approved items
      const total = presupuesto.desgloce.items.reduce((sum, item) => {
        if (item.aprobado === true || item.aprobado === undefined) {
          // Ensure precio is a number
          const precio = typeof item.precio === 'number' ? item.precio : parseFloat(item.precio) || 0;
          return sum + precio;
        }
        return sum;
      }, 0);

      // Format the total amount (e.g., "1.234,56")
      return total;
    },

    getTotalNoRealizadoPresupuesto(presupuesto) {
      // Define the approved estado range
      const ESTADO_MIN = 2; // estado > 1
      const ESTADO_MAX = 9; // estado < 10

      // Check if the presupuesto is in an approved estado
      if (!presupuesto || typeof presupuesto !== 'object') {
        console.warn('Invalid presupuesto object provided.');
        return '0';
      }

      if (!(presupuesto.estado > ESTADO_MIN - 1 && presupuesto.estado < ESTADO_MAX + 1)) {
        // Estado not in approved range
        return '0';
      }

      // Ensure desgloce and items exist
      if (
        !presupuesto.desgloce ||
        !Array.isArray(presupuesto.desgloce.items) ||
        presupuesto.desgloce.items.length === 0
      ) {
        console.warn('Presupuesto has no items to sum.');
        return '0';
      }

      // Sum the precio of approved items
      const total = presupuesto.desgloce.items.reduce((sum, item) => {
        if ((item.aprobado === true || item.aprobado === undefined) && item.no_realizado) {
          // Ensure precio is a number
          const precio = typeof item.precio === 'number' ? item.precio : parseFloat(item.precio) || 0;
          return sum + precio;
        }
        return sum;
      }, 0);

      // Format the total amount (e.g., "1.234,56")
      return total;
    },

    getMontoPorPagar(solicitud){
      if (!solicitud || !solicitud.orden) {
        return 0;
      }
      const totalAprobado = this.getTotalPresupuestosAprobados(solicitud);
      const totalPagado = this.getMontoPagadoNumero(solicitud);
      if (totalAprobado <= 0) {
        return 0;
      }
      if (totalPagado >= totalAprobado * 0.9) {
        return 0;
      }
      const montoPorPagar = totalAprobado - totalPagado;
      return montoPorPagar > 0 ? montoPorPagar : 0;
    },

    getMontoPagadoAlProfesional(solicitud) {
      if (!solicitud || !solicitud.orden) {
        return 'No hay orden';
      }
      const monto = Number(solicitud.orden.monto_pagado_al_profesional || 0);
      return monto > 0 ? '$' + Intl.NumberFormat('de-DE').format(monto) : 'No hay pagos';
    },

    getMontoPorPagarString(solicitud) {
      const montoPorPagar = this.getMontoPorPagar(solicitud);
      const totalAprobado = this.getTotalPresupuestosAprobados(solicitud);

      if (totalAprobado <= 0) {
        return 'No hay presupuestos aprobados';
      }

      if (montoPorPagar <= 0) {
        return 'No hay pagos pendientes';
      }

      return '$' + Intl.NumberFormat('de-DE').format(montoPorPagar);
    },
    getFechaAprobacion(solicitud) {
      if (solicitud.orden && solicitud.orden.presupuestos && solicitud.orden.presupuestos.length > 0) {
        // Sort presupuestos by fecha_aprobado_iso in descending order (latest first)
        const sortedPresupuestos = solicitud.orden.presupuestos
          .filter(p => p.fecha_aprobado_iso) // Filter out presupuestos without fecha_aprobado_iso
          .sort((a, b) => new Date(b.fecha_aprobado_iso) - new Date(a.fecha_aprobado_iso));

        const presupuesto = sortedPresupuestos.length > 0 ? sortedPresupuestos[0] : null;

        if (presupuesto) {
          return '<span style="color:#2ECC40;">' +
            this.extractDate(presupuesto.fecha_aprobado_iso).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' }) +
            '</span>';
        }
        return '<span style="color:#FFDC00;">No aprobado</span>';
      }
      return '<span style="color:#FF4136;">No enviado</span>';
    },
    getFechaInicio(solicitud) {
      if (solicitud.orden && solicitud.orden.presupuestos && solicitud.orden.presupuestos.find(presupuesto => presupuesto.estado === 2)) {
        var fecha_aprobado = this.extractDate(solicitud.orden.presupuestos.find(presupuesto => presupuesto.estado === 2).fecha_aprobado_iso)
        fecha_aprobado.setDate(fecha_aprobado.getDate() + 1);
        return fecha_aprobado.toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' });
      }
      return '<span style="white-space:nowrap;">No hay fecha</span> de inicio';
    },

    formatFecha(fecha) {
      const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
      return new Date(fecha).toLocaleDateString('es-ES', options);
    },
    mapPresupuestoStatus(estado) {
      switch (estado) {
        case 2:
          return { text: 'Aceptado', className: 'status-aceptado' };
        case 10:
          return { text: 'Rechazado', className: 'status-rechazado' };
        case 1:
          return { text: 'Enviado', className: '' };
        case 0:
          return { text: 'Pendiente', className: '' };
        default:
          return { text: '', className: '' };
      }
    },
    hasFotos(solicitud) {
      return solicitud.orden && solicitud.orden.fotos && solicitud.orden.fotos.length > 0;
    },
    getFotosAntes(solicitud) {
      if (this.hasFotos(solicitud)) {
        return solicitud.orden.fotos.filter((foto) => foto.tipo === 1);
      }
      return [];
    },
    getFotosDespues(solicitud) {
      if (this.hasFotos(solicitud)) {
        return solicitud.orden.fotos.filter((foto) => foto.tipo === 2);
      }
      return [];
    },
    normalizeCategoria(categoria) {
      return typeof categoria === 'string' ? categoria.trim().toLowerCase() : '';
    },
    getArchivosPorCategoria(solicitud, categoria) {
      if (!solicitud || !solicitud.orden || !Array.isArray(solicitud.orden.archivos)) {
        return [];
      }

      const targetCategoria = this.normalizeCategoria(categoria);
      return solicitud.orden.archivos.filter(
        (archivo) => this.normalizeCategoria(archivo.categoria) === targetCategoria
      );
    },
    hasArchivoCategoria(solicitud, categoria) {
      return this.getArchivosPorCategoria(solicitud, categoria).length > 0;
    },
    getComprobantePago(solicitud) {
      if (this.hasArchivoCategoria(solicitud, 'Comprobante de Pago')) {
        return 'Descargar';
      }
      return 'No tiene';
    },
    getFacturaHaciaJobbing(solicitud) {
      if (this.hasArchivoCategoria(solicitud, 'Factura hacia Jobbing')) {
        return 'Descargar';
      }
      return 'No tiene';
    },
    getFacturaCliente(solicitud) {
      if (this.hasArchivoCategoria(solicitud, 'Factura al Cliente')) {
        return 'Descargar';
      }
      return 'No tiene';
    },
    getVideo(solicitud) {
      if (this.hasArchivoCategoria(solicitud, 'Video')) {
        return 'Descargar';
      }
      return 'No tiene';
    },
    descargarArchivo(solicitud, categoria) {
      if (solicitud.orden && solicitud.orden.archivos) {
        const archivo = this.getArchivosPorCategoria(solicitud, categoria)[0];
        if (archivo) {
          const url = `${window.hostname}api/property_manager/descargar_archivo/${archivo.id}`;
          window.open(url, '_blank');
        }
      }
      },
      descargarArchivoPorID(archivo) {
        if (archivo) {
          const url = `${window.hostname}api/property_manager/descargar_archivo/${archivo.id}`;
          axios.get(url)
        .then(response => {
          const presignedUrl = response.data.url;
          window.open(presignedUrl, '_blank');
        })
        .catch(error => {
          console.error('Error al obtener la URL de descarga:', error);
          alert('No se pudo descargar el archivo. Por favor, inténtalo de nuevo.');
        });
        }
      
    },
    handleClickArchivo(event, archivo) {
    if (event.ctrlKey && this.admin_datos.user_type === 'jobbing_admin') {
      if (confirm(`¿Seguro que quieres eliminar el archivo ${archivo.id}?`)) {
        this.eliminarArchivo(archivo.id);
      }
    } else {
      this.descargarArchivoPorID(archivo);
    }
  },
  async eliminarArchivo(id) {
      try {
        await axios.delete(`${window.hostname}api/property_manager/eliminar_archivo/${id}`);
        
        // Refresh the solicitudes without triggering the loading state
        await this.fetchSolicitudes(false);
        // Force Vue to re-render the component to reflect changes
        this.$forceUpdate();
        
        // Schedule the alert after the refresh
        setTimeout(() => {
          alert(`Archivo ${id} eliminado exitosamente.`);
        }, 0);
      } catch (error) {
        console.error('Error al eliminar el archivo:', error);
        
        // Refresh UI even on error
        await this.fetchSolicitudes(false);
        this.$forceUpdate();
        
        setTimeout(() => {
          alert('No se pudo eliminar el archivo.');
        }, 0);
      }
    },
    // New Methods for Context Menu and Modal
    openContextMenu(event, solicitud) {
    const scaleFactor = 0.75; // Replace with your zoom/scale level
    this.contextMenuVisible = true;

    // Adjust coordinates based on the scale factor
    this.contextMenuX = event.clientX / scaleFactor;
    this.contextMenuY = event.clientY / scaleFactor;

    this.selectedSolicitud = solicitud;
  },
    abrirModalAgregarComentario(solicitud) {
      this.contextMenuVisible = false;
      this.modalVisible = true;
      this.nuevoComentario = '';
    },
    cerrarModal() {
      this.modalVisible = false;
    },
    agregarComentario() {
      if (this.nuevoComentario.trim() === '') {
        alert('El comentario no puede estar vacío.');
        return;
      }
      // Assuming there's an API endpoint to add a comment to a solicitud
      axios
        .post(window.hostname + 'api/property_manager/agregar_comentario', {
          solicitud_id: this.selectedSolicitud.id,
          comentario: this.nuevoComentario,
        })
        .then(() => {
          alert('Comentario agregado exitosamente.');
          this.cerrarModal();
          this.fetchSolicitudes(false); // Refresh data
        })
        .catch((e) => {
          console.log('Error al agregar comentario:', e);
          alert('Hubo un error al agregar el comentario.');
        });
    },
    abrirModalSubirArchivo(solicitud, tipo) {
      this.contextMenuVisible = false;
      this.selectedSolicitud = solicitud;
      this.archivoTipo = tipo;
      this.archivoSeleccionado = null;
      this.modalSubirArchivoVisible = true;
    },
    cerrarModalSubirArchivo() {
      this.modalSubirArchivoVisible = false;
      this.archivoSeleccionado = null;
    },
    onFileSelected(event) {
      this.archivoSeleccionado = event.target.files[0];
    },
    subirArchivo() {
      if (!this.archivoSeleccionado) {
        alert('Por favor, selecciona un archivo.');
        return;
      }

      const formData = new FormData();

      // Create the JSON document
      const jsonDocument = {
        nombre: this.archivoSeleccionado.name,
        solicitud_id: this.selectedSolicitud.id,
        categoria: this.archivoTipo,
      };

      // Convert JSON document to a Blob
      const jsonBlob = new Blob([JSON.stringify(jsonDocument)], { type: 'application/json' });

      // Append 'document' and 'file' to FormData
      formData.append('document', jsonBlob, 'document.json');
      formData.append('file', this.archivoSeleccionado);

      axios
        .post(window.hostname + 'api/property_manager/subir_archivo', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          alert('Archivo subido exitosamente.');
          this.cerrarModalSubirArchivo();
          this.fetchSolicitudes(false); // Refresh data
        })
        .catch((e) => {
          console.log('Error al subir archivo:', e);
          alert('Hubo un error al subir el archivo.');
        });
    },
        abrirModalAgregarPago(solicitud) {
          this.contextMenuVisible = false;
          this.selectedSolicitud = solicitud;
          this.modalAgregarPagoVisible = true;
          this.nuevoPagoMonto = null;
          this.nuevoPagoFecha = null;
          this.nuevoPagoDescripcion = '';
        },


      async marcarSolicitudInactiva(solicitudId) {
      // Solicitar confirmación antes de continuar
      if (!confirm("¿Estás seguro de que deseas marcar esta solicitud como eliminada?")) {
        return; // Salir si el usuario cancela
      }

      try {
        // Enviar la solicitud POST con solicitud_id en el cuerpo de la solicitud
        const response = await axios.post(window.hostname + '/api/property_manager/marcar_solicitud_inactiva', {
          solicitud_id: solicitudId
        });

        // Manejar respuesta exitosa
        if (response.status === 200) {
          this.fetchSolicitudes(false); 
          alert("La solicitud ha sido marcada como eliminada.");
        }
      } catch (error) {
        // Manejar errores
        if (error.response && error.response.status === 401) {
          alert("No estás autorizado para marcar esta solicitud como eliminada.");
        } else if (error.response && error.response.status === 400) {
          alert("Solicitud inválida. Por favor verifica el ID de la solicitud.");
        } else {
          alert("Ocurrió un error al procesar tu solicitud.");
        }
      }
    },
    async terminarSolicitud(solicitudId) {
      // Solicitar confirmación antes de continuar
      if (!confirm("¿Estás seguro de que deseas terminar esta solicitud?")) {
        return; // Salir si el usuario cancela
      }

      try {
        // Enviar la solicitud POST con solicitud_id en el cuerpo de la solicitud
        const response = await axios.post(window.hostname + '/api/property_manager/terminar_solicitud', {
          solicitud_id: solicitudId
        });

        // Manejar respuesta exitosa
        if (response.status === 200) {
          this.fetchSolicitudes(false); 
          alert("La solicitud ha sido terminada.");
        }
      } catch (error) {
        // Manejar errores
        if (error.response && error.response.status === 401) {
          alert("No estás autorizado para terminar esta solicitud.");
        } else if (error.response && error.response.status === 400) {
          alert("Solicitud inválida. Por favor verifica el ID de la solicitud.");
        } else {
          alert("Ocurrió un error al procesar tu solicitud.");
        }
      }
    },
    cerrarModalAgregarPago() {
      this.modalAgregarPagoVisible = false;
    },
    agregarPago() {
      // Validate the input
      if (!this.nuevoPagoMonto || !this.nuevoPagoFecha || !this.nuevoPagoRecibidoPor) {
        alert('Por favor, completa todos los campos requeridos.');
        return;
      }

      const formData = new FormData();

      // Create the JSON document
      const pagoData = {
        solicitud_id: this.selectedSolicitud.id,
        monto: this.nuevoPagoMonto,
        fecha_pago: this.nuevoPagoFecha,
        recibido_por: this.nuevoPagoRecibidoPor,
      };

      // Convert JSON document to a Blob
      const jsonBlob = new Blob([JSON.stringify(pagoData)], { type: 'application/json' });

      // Append 'document' and optional 'comprobante_pago' to FormData
      formData.append('document', jsonBlob, 'document.json');

      if (this.pagoArchivoSeleccionado) {
        formData.append('comprobante_pago', this.pagoArchivoSeleccionado);
      }

      // Send the data to the server
      axios
        .post(window.hostname + 'api/property_manager/agregar_pago', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          alert('Pago agregado exitosamente.');
          this.cerrarModalAgregarPago();
          this.fetchSolicitudes(false); // Refresh data
        })
        .catch((e) => {
          console.log('Error al agregar pago:', e);
          alert('Hubo un error al agregar el pago.');
        });
    },
    abrirModalRechazarPresupuesto(presupuesto) {
      this.presupuestoRechazar = presupuesto ? { ...presupuesto } : null;
      this.modalRechazarPresupuestoComentario = '';
      this.modalRechazarPresupuestoVisible = true;
    },

    abrirModalEnviarPresupuesto(solicitud) {
      this.contextMenuVisible = false;
      this.selectedSolicitud = solicitud;

      if (!solicitud.orden) {
        alert('No se puede enviar presupuesto porque la solicitud no tiene una orden asociada.');
        return;
      }

      if (solicitud.orden.presupuestos && solicitud.orden.presupuestos.length > 0) {
        // Ask the user if they really want to send that "presupuesto".
        if (confirm('Ya existe un presupuesto. ¿Deseas enviar uno nuevo?')) {
          this.preparePresupuestoModal();
        } 
      } else {
        // No existing presupuesto, proceed to create a new one
        this.preparePresupuestoModal();
      }
    },
    eliminarPago(pago) {

      if (confirm('¿Seguro que deseas eliminar este pago?')) {
        axios.post(window.hostname + 'api/superadmin/eliminar_pago', {pago_id:pago.id})
        .then(() => {
          alert('Pago eliminado exitosamente.');
          this.cerrarModalEnviarPresupuesto();
          this.fetchSolicitudes(false); // Refresh data
        })
        .catch((e) => {
          alert('Hubo un error al eliminar el pago.');
        });
      } 
    },

    preparePresupuestoModal() {
      this.modalEnviarPresupuestoVisible = true;
      this.presupuestoNombre = '';
      this.presupuestoNotasAdicionales = '';
      this.presupuestoItems = [];
      if (this.selectedSolicitud && this.selectedSolicitud.orden && this.selectedSolicitud.orden.servicios) {
        this.presupuestoItems = [...this.selectedSolicitud.orden.servicios];
      }
    },
    cerrarModalEnviarPresupuesto() {
      this.modalEnviarPresupuestoVisible = false;
      this.presupuestoNombre = '';
      this.presupuestoNotasAdicionales = '';
      this.presupuestoItems = [];
    },
    async vistaPreviaPresupuesto ()  {
      if (!this.presupuestoNombre.trim()) {
        alert('Por favor, ingrese un nombre para el presupuesto.');
        return;
      }
      if (this.presupuestoItems.length === 0) {
        alert('Por favor, seleccione al menos un item.');
        return;
      }

      const presupuestoData = {
        orden_id: this.selectedSolicitud.orden.id,
        nombre: this.presupuestoNombre,
        notas_adicionales: this.presupuestoNotasAdicionales,
        items: this.presupuestoItems,
      };
      try {
        const response = await axios.post(window.hostname+'api/property_manager/vista_previa_presupuesto', presupuestoData, {
          responseType: 'blob'
        });



        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'cotizacion.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error downloading the PDF', error);
      }
    },
    async descargarPresupuesto (presupuesto)  {


      const presupuestoData = {
        presupuesto_id: presupuesto.id,
        orden_id: presupuesto.orden_id,
        nombre: presupuesto.nombre,
        notas_adicionales: presupuesto.desgloce.notas_adicionales,
        items: presupuesto.desgloce.items,
      };
      try {
        const response = await axios.post(window.hostname+'api/property_manager/descargar_presupuesto', presupuestoData, {
          responseType: 'blob'
        });



        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'cotizacion.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error downloading the PDF', error);
      }
    },
    enviarPresupuesto() {
      if (!this.presupuestoNombre.trim()) {
        alert('Por favor, ingrese un nombre para el presupuesto.');
        return;
      }
      if (this.presupuestoItems.length === 0) {
        alert('Por favor, seleccione al menos un item.');
        return;
      }

      const presupuestoData = {
        orden_id: this.selectedSolicitud.orden.id,
        nombre: this.presupuestoNombre,
        notas_adicionales: this.presupuestoNotasAdicionales,
        items: this.presupuestoItems,
      };
      

      axios.post(window.hostname + 'api/property_manager/crear_y_enviar_presupuesto', presupuestoData)
        .then(() => {
          alert('Presupuesto enviado exitosamente.');
          this.cerrarModalEnviarPresupuesto();
          this.fetchSolicitudes(false); // Refresh data
        })
        .catch((e) => {
          console.log('Error al enviar presupuesto:', e);
          alert('Hubo un error al enviar el presupuesto.');
        });
    },
    copiarLinkPresupuesto(presupuesto) {
    axios.post(window.hostname + 'api/property_manager/obtener_link_presupuesto', { presupuesto_id: presupuesto.id })
      .then((response) => {
        const link = response.data.link; // Assuming 'link' is returned in response
        navigator.clipboard.writeText(link)
          .then(() => {
            alert('Link copiado.');
          })
          .catch((err) => {
            console.log('Error copiando link:', err);
            alert('Error copiando link.');
          });
      })
      .catch((error) => {
        console.log('Error fetching link:', error);
        alert('There was an error fetching the link.');
      });
  },
    reenviarPresupuesto(presupuesto) {
      axios.post(window.hostname + 'api/property_manager/reenviar_presupuesto', {presupuesto_id:presupuesto.id})
        .then(() => {
          alert('Presupuesto enviado exitosamente.');
          this.cerrarModalEnviarPresupuesto();
          this.fetchSolicitudes(false); // Refresh data
        })
        .catch((e) => {
          console.log('Error al enviar presupuesto:', e);
          alert('Hubo un error al enviar el presupuesto.');
        });
    },
    rechazarPresupuesto(presupuesto) {
      if (!presupuesto) {
        return;
      }
      axios.post(window.hostname + 'api/property_manager/rechazar_presupuesto', {
        presupuesto_id: presupuesto.id,
        comment: this.modalRechazarPresupuestoComentario // Optional comment from modal
      })
      .then(() => {
        alert('Presupuesto rechazado exitosamente.');
        this.cerrarModalRechazarPresupuesto();
        this.fetchSolicitudes(false); // Refresh data
      })
      .catch((e) => {
        console.log('Error al rechazar presupuesto:', e);
        alert('Hubo un error al rechazar el presupuesto.');
      });
    },
    cerrarModalRechazarPresupuesto() {
      this.modalRechazarPresupuestoVisible = false;
      this.modalRechazarPresupuestoComentario = '';
      this.presupuestoRechazar = null;
    },


    // Event handler for closing the context menu
    handleWindowClick(event) {
      const ignoredClasses = ['context-menu'];
      if (!ignoredClasses.some(className => event.target.classList.contains(className))) {
        this.contextMenuVisible = false;
      }

      if (!this.$el.contains(event.target)) {
        this.contextMenuVisible = false;
      }
    },
    dragStart(event) {
      this.isDragging = true;
      this.preventClick = false;
      this.$refs.tableContainer.classList.add('active');
      if (event.type === 'touchstart') {
        this.startX = event.touches[0].pageX - this.$refs.tableContainer.offsetLeft;
      } else {
        this.startX = event.pageX - this.$refs.tableContainer.offsetLeft;
      }
      this.scrollLeft = this.$refs.tableContainer.scrollLeft;
    },
    dragMove(event) {
      if (!this.isDragging) return;
      event.preventDefault();
      let x;
      if (event.type === 'touchmove') {
        x = event.touches[0].pageX - this.$refs.tableContainer.offsetLeft;
      } else {
        x = event.pageX - this.$refs.tableContainer.offsetLeft;
      }
      const deltaX = x - this.startX;
      if (Math.abs(deltaX) > 5) {
        this.preventClick = true;
      }
      const walk = deltaX * 1;
      this.$refs.tableContainer.scrollLeft = this.scrollLeft - walk;
    },
    dragEnd() {
      this.isDragging = false;
      this.$refs.tableContainer.classList.remove('active');
    },
    playSound() {
      if (!this.notificationAudio) {
        this.notificationAudio = new Audio(this.notificationAudioUrl);
        this.notificationAudio.preload = 'auto';
      }

      this.notificationAudio.currentTime = 0;
      const playback = this.notificationAudio.play();
      if (playback && typeof playback.catch === 'function') {
        playback.catch(() => {});
      }
    },
  },
  watch: {
    admin_datos: {
      immediate: true,
      handler() {
        this.initializeSolicitudesAfterAuth();
      }
    }
  },
  mounted() {
    if (this.admin_datos && this.admin_datos.user_type === 'property_manager') {
      this.socket = io(window.socket, {
        extraHeaders: {
          token: this.token,
          tipo: 'administrador_propiedad',
          usuario: JSON.stringify(this.admin_datos),
        },
      });
        this.socket.on('solicitud_actualizada', async (payload) => {
          const data = typeof payload === 'string' ? JSON.parse(payload) : payload;
          await this.fetchSolicitudes(false);
          const nombre = data && data.de ? data.de : 'Un profesional';
          const mensaje = data && data.mensaje ? data.mensaje : 'respondió a la solicitud';
          this.$notify({
            group: 'foo',
            title: 'Solicitud actualizada',
            text: `${nombre} ${mensaje}`,
            type: 'success'
          });
          this.playSound();
        });
    }
  },
  created() {
    this.initializeSolicitudesAfterAuth();
    window.addEventListener('click', this.handleWindowClick);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleWindowClick);
    if (this.socket) {
      this.socket.disconnect();
    }
    if (Array.isArray(this.solicitudes)) {
      this.solicitudes.forEach(solicitud => {
        if (Array.isArray(solicitud.newMessageFiles)) {
          solicitud.newMessageFiles.forEach(attachment => {
            if (attachment && attachment.preview) {
              URL.revokeObjectURL(attachment.preview);
            }
          });
        }
      });
    }
  },
};
</script>

<style scoped>
.presupuesto-prof {
  display: flex;
  align-items: center;
}

.presupuesto-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px;
}

.atendido-prof {
  display: flex;
  align-items: center;
}

.atendido-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px;
}

.link-profesional {
  color: #007bff;
  cursor: pointer;
  
/*   text-decoration: underline; */
}

.status-aceptado {
  color: #2ECC40;
}

.status-rechazado {
  color: #FF4136;
}

.tooltip-box {
  position: fixed;
  max-width: 320px;
  background-color: #fff;
  color: #333;
  border: 1px solid #ccc;
  padding: 12px 14px;
  border-radius: 8px;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  line-height: 1.4;
  pointer-events: none; /* Optional: prevents tooltip from interfering with cursor */
  transition: opacity 0.2s ease-in-out;
}

.tooltip-box ul {
  padding-left: 18px;
  margin: 0;
}

.tooltip-box li {
  margin-bottom: 8px;
}

.tooltip-box strong {
  color: #111;
}

.info-svg{

  height: 25px;
  width: 25px;
}
.custom-tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.custom-tooltip-text {
  visibility: hidden;
  font-size: 14px;
  background-color: rgb(40, 40, 40);
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px 10px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
  white-space: pre-wrap;

  /* Default: upward */
  bottom: 110%;
}

.custom-tooltip-text::after {
  content: '';
  position: absolute;
  top: 100%; /* Arrow below the tooltip */
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: rgb(40, 40, 40) transparent transparent transparent;
}

/* Optional: downward direction */
.custom-tooltip-text.tooltip-down {
  top: 110%;
  bottom: auto;
}

.custom-tooltip-text.tooltip-down::after {
  top: auto;
  bottom: 100%;
  border-color: transparent transparent rgb(40, 40, 40) transparent;
}

.custom-tooltip-wrapper:hover .custom-tooltip-text {
  visibility: visible;
  opacity: 1;
}
.servicio-estado {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #AAAAAA;
  display: inline-block;
}

.status-indicator--realizado {
  background-color: #2ECC40;
}

.status-indicator--pendiente {
  background-color: #FF4136;
}

.servicio-realizado-aprobado {
  background-color: rgba(46, 204, 64, 0.08);
}
.servicio-presupuesto {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.servicio-presupuesto__badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
}

.servicio-presupuesto__badge--aprobado {
  color: #2ECC40;
  background: rgba(46, 204, 64, 0.15);
}

.servicio-presupuesto__badge--pendiente {
  color: #0074D9;
  background: rgba(0, 116, 217, 0.15);
}

.servicio-presupuesto__sin {
  font-size: 12px;
  color: #555;
}
.tabs {
  display: flex;

}

.tabs button {
  padding: 10px 20px;
  border: none;
  background-color: #f1f1f1;
  cursor: pointer;
  margin-right: 5px;
  transition: background-color 0.3s;
}

.tabs button.active-tab {
  background-color: #007BFF;
  color: white;
}

.tabs button:hover {
  background-color: #ddd;
}
.nowrap{
  white-space:nowrap;
}

.chat-container {
  display: flex;
  gap: 10px;
  width: calc(133.3333vw - 320px);
  max-width: calc(133.3333vw - 320px);
  margin-left: 0;
  margin-right: auto;
  justify-content: flex-start;
}
.chat-content {
  display: flex;
  width: 100%;
  gap: 10px;
}
.chat-left {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  /* border: 1px solid #ddd; */
  padding: 8px;
  border-radius: 8px;
  background: #fff;
}
.chat-header-info-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.chat-header-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  cursor: pointer;
}
.chat-header-name {
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
}
.chat-right {
  width: 240px;
}
.professional-list {
  /* border: 1px solid #ddd; */
  border-radius: 8px;
  background: #fff;
  /* padding: 2px; */
  height: 100%;
  overflow-y: auto;
}
.professional-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
}
.professional-item.active {
  background: #e6f7ff;
}
.professional-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.professional-avatar.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FF4136;
  color: #fff;
  font-size: 16px;
}
.badge {
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 12px;
  margin-left: 4px;
  display: inline-block;
}
.badge.prioridad-alta {
  color: #FF4136;
  background: rgba(255, 65, 54, 0.15);
}
.badge.prioridad-media {
  color: #B8860B;
  background: rgba(255, 220, 0, 0.2);
}
.badge.prioridad-baja {
  color: #0074D9;
  background: rgba(0, 116, 217, 0.15);
}
.badge.prioridad-desconocida {
  color: #555;
  background: rgba(170, 170, 170, 0.2);
}
.badge.en-atencion {
  color: #2ECC40;
  background: rgba(46, 204, 64, 0.15);
}
.unread-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #FF4136;
  color: #fff;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  font-size: 12px;
  line-height: 20px;
}
.chat-messages {
  flex: 1;
  min-height: 500px;
  max-height: 500px;
  overflow-y: auto;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  padding: 10px;
  background: #fafafa;
}
.chat-profile-hint {
  font-size: 12px;
  color: #4b5563;
  margin: -4px 0 12px 0;
}

.chat-message {
  display: flex;
  margin-bottom: 8px;
}
.chat-message.from-professional {
  flex-direction: row-reverse;
  text-align: right;
}
.chat-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 10px;
}
.chat-message.from-professional .chat-avatar {
  margin-right: 0;
  margin-left: 10px;
}
.chat-avatar.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FF4136;
  color: #fff;
  font-size: 15px;
}
.chat-avatar.clickable,
.professional-avatar.clickable {
  cursor: pointer;
}
.chat-avatar.clickable:hover,
.professional-avatar.clickable:hover {
  opacity: 0.85;
}
.chat-message.unseen .message-bubble {
  background: #e6f7ff;
}
.message-bubble {
  max-width: 80%;
  background: #e5e5ea;
  padding: 6px 10px;
  border-radius: 12px;
}
.chat-message.from-professional .message-bubble {
  background: #007BFF;
  color: #fff;
}
.message-header {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 2px;
}
.message-name {
  font-weight: 600;
}
.message-tag {
  background: #e1effe;
  color: #007BFF;
  padding: 0 4px;
  border-radius: 8px;
  font-size: 10px;
}
.message-text {
  margin-bottom: 2px;
  white-space: pre-line;
  word-break: break-word;
}
.message-time {
  font-size: 11px;
  color: #555;
}
.chat-message.from-professional .message-time {
  color: #e5e5e5;
}
.presupuesto-box {
  margin-top: 6px;
  padding: 6px;
  border: 2px solid rgb(255, 140, 0);
  background-color: #fff4e5;
  border-radius: 4px;
  color: #000;
  font-size: 12px;
}
.chat-input {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border: 1px solid #dcdcdc;
  border-radius: 32px;
  background-color: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  min-height: 52px;
}
.chat-input.drag-over {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}
.chat-input .chat-upload-button {
  background: transparent;
  border: none;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}
.chat-input .chat-upload-button:hover {
  background-color: rgba(37, 99, 235, 0.08);
}
.chat-input .chat-upload-button .b-icon {
  font-size: 20px;
  color: #2563eb;
}
.chat-file-input {
  display: none;
}
.chat-input .chat-text-field {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  padding: 10px 0;
  font-size: 15px;
  color: #333;
}
.chat-input .chat-text-field::placeholder {
  color: #9ca3af;
}
.chat-send-button {
  background: #007bff;
  border: none;
  color: #fff;
  padding: 8px 18px;
  border-radius: 24px;
  cursor: pointer;
  transition: background 0.3s ease;
}
.chat-send-button:disabled {
  background: #ccc;
  cursor: not-allowed;
}
.chat-send-button:not(:disabled):hover {
  background: #0056b3;
}
.chat-attachments-preview {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.chat-attachment-preview {
  position: relative;
  width: 68px;
  height: 68px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.chat-attachment-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.chat-attachment-preview .remove-attachment {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  padding: 0;
}
.modal-helper-text {
  font-size: 14px;
  color: #4b5563;
  margin-top: 6px;
}
.message-bubble.has-special-content {
  background: transparent;
  padding: 0;
}
.chat-message.from-professional .message-bubble.has-special-content {
  background: transparent;
  color: #1f2937;
}
.chat-message.from-professional .message-bubble.has-special-content .message-header,
.chat-message.from-professional .message-bubble.has-special-content .message-text,
.chat-message.from-professional .message-bubble.has-special-content .message-time {
  color: #1f2937;
}
.chat-message.from-professional .message-bubble.has-special-content .message-tag {
  background: rgba(37, 99, 235, 0.12);
  color: #2563eb;
}
.message-text--neutral {
  color: #1f2937 !important;
}
.special-message {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.request-box {
  --request-border-color: rgba(37, 99, 235, 0.45);
  --request-bg-color: rgba(196, 212, 226, 0.35);
  position: relative;
  width: 100%;
  padding: 20px 24px;
  border-radius: 18px;
  background: linear-gradient(135deg, var(--request-bg-color), rgba(255, 255, 255, 0.96));
  border: 1px solid var(--request-border-color);
  box-shadow: 0 28px 60px -42px rgba(15, 23, 42, 0.5);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.request-box::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 6px;
  background: var(--request-border-color);
  opacity: 0.9;
}
.title-wrapp {
  display: flex;
  align-items: center;
  gap: 12px;
}
.request-title {
  font-weight: 700;
  font-size: 18px;
  color: #1f2937;
  line-height: 1.4;
  margin: 0;
}
.box-icon {
  flex-shrink: 0;
  width: 54px;
  height: 54px;
  padding: 12px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 20px 45px -32px rgba(15, 23, 42, 0.35);
  object-fit: contain;
}
.request-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  color: #1f2937;
  line-height: 1.6;
}
.request-body p {
  margin: 0;
}
.request-list {
  margin: 4px 0 0 16px;
  padding: 0 0 0 12px;
  color: #1f2937;
}
.request-list li {
  margin-bottom: 4px;
}
.request-notes {
  font-style: italic;
  color: #4b5563;
}
.special-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.special-action-button {
  background: #2563eb;
  border: none;
  color: #fff;
  padding: 8px 18px;
  border-radius: 9999px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
}
.special-action-button:hover {
  background: #1d4ed8;
}
.special-action-button.secondary {
  background: #fff;
  color: #2563eb;
  border: 1px solid rgba(37, 99, 235, 0.45);
}
.special-action-button.secondary:hover {
  background: rgba(37, 99, 235, 0.1);
}
.special-action-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.message-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.message-attachment {
  width: 120px;
  height: 90px;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.message-attachment img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.date-separator {
  text-align: center;
  margin: 10px 0;
  font-size: 12px;
  color: #888;
}
  /* Estilo para el contenedor de encabezado */
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
}

/* Estilo para el contenedor del filtro de fecha */
.date-filter-container {
  display: flex;
  align-items: center;
  justify-content: center;

}

/* Estilo para la etiqueta del filtro de fecha */
.date-filter-label {
  margin-right: 5px;
  font-weight: bold;
  margin-top: 8px;
}

/* Estilo para el selector de fecha */
.date-filter-select {
  padding: 5px;
  font-size: 14px;
}


.star{
  cursor: pointer;
  margin-right:4px;
  height:18px;
  width: 18px;
  color:#DAA520;
}

.sectionv{
/*   background-color: rgb(250,250,250); */
  background-color: white;
  border-radius: 15px;
  padding: 10px 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
  max-width: calc(133.33333vw - 300px);
}
.sectionv2{
/*   background-color: rgb(250,250,250); */
  background-color: white;
  border-radius: 15px;
  padding: 10px 20px;
/*   margin-bottom: 20px; */
}

h2{
  font-weight: 700;
  font-size: 25px;

}
h3{
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 15px;
}

.yellowish {
 color:#FFDC00;
 font-weight: 700;
}
.table-container.active {
  cursor: grabbing;
}



.tablex {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  margin-top:0px;
}

.tablex th,
.tablex td {
  padding: 12px 15px;
  text-align: left;
}

.tablex thead th {
  background-color: rgb(250, 250, 250);
  position: sticky;
  top: 0;      /* o top:60px si la TopNav solapa */
  z-index: 5;
}

.tablex tbody tr {
  border-bottom: 1px solid #ddd;
}
 
.tablex tbody tr:hover {
  /* background-color: #f9f9f9; */
}

.details-container {
  padding: 0;
  /* background-color: #f9f9f9; */
}

.details-body {

}

.details-tabs {
  margin-bottom: 0px;
  background-color: rgb(250, 250, 250);
}

.details-container h3 {
  margin-top: 0;
}

.fotos-container {
  display: flex;
  flex-wrap: wrap;
}

.fotos-container img {
  width: 150px;
  height: auto;
  margin: 5px;
  border: 1px solid #ccc;
}

.column-right {
  background-color: rgb(242, 247, 251);
  /* padding-top: 80px; */   /* ya compensas tu TopNav fixed */
  padding-left: 260px; /* ancho del SideNav */
  width: 100%;
  height: calc(100vh / .75);      /* ← ocupa todo el alto visible */
  display: flex;       /* ← flex contenedor vertical */
  flex-direction: column;
}

.main-container {
  background-color: #fff;
  margin-top: 10px;
  padding: 20px;
  padding-bottom: 0px;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;  /* ← puede estirarse */
  min-height: 0;   /* ← evita que el contenido “empuje” */
}
.articulo-principal {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

@media (max-width: 800px) {
  .column-right {
    padding-left: 0px;
  }
}
/* Context Menu Styles */
.context-menu {
  position: fixed;
  background-color: white;
  border: 1px solid #ccc;
  z-index: 1000;
  font-size: 14px;
  width: 200px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
}

.context-menu ul {
  list-style: none;
  margin: 0;
  padding: 5px 0;
}

.context-menu ul li {
  padding: 8px 12px;
  cursor: pointer;
}

.context-menu ul li:hover {
  background-color: #f4f4f4;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  z-index: 1100; /* Increased z-index to ensure it's above other elements */
  display: flex;
  align-items: center;
  justify-content: center;
}

.modall {
  background-color: white;
  padding: 20px;
  width: 600px;
  max-width: 90%;
  border-radius: 5px;
  z-index: 11001;
}

.modall h3 {
  margin-top: 0;
}

.modall textarea {
  width: 100%;
  height: 100px;
  margin-top: 10px;
}

.modal-buttons {
  margin-top: 15px;
  text-align: right;
}

.modal-buttons button {
  padding: 8px 12px;
  margin-left: 10px;
}

.payment-action-modal {
  max-width: 520px;
}

.payment-modal-state {
  padding: 18px 0;
  color: #4b5563;
}

.payment-result-panel {
  text-align: center;
  padding: 18px 10px 8px;
  color: #1f2937;
}

.payment-result-icon {
  width: 54px;
  height: 54px;
  margin-bottom: 12px;
}

.payment-result-panel h4 {
  margin: 0 0 8px;
  font-size: 20px;
  color: #111827;
}

.payment-result-panel p {
  margin: 0 auto;
  max-width: 390px;
  line-height: 1.5;
  color: #4b5563;
}

.payment-result-panel--cancelled h4 {
  color: #b91c1c;
}

.payment-result-panel--verifying h4 {
  color: #1d4ed8;
}

.payment-summary-box {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 16px;
  border: 1px solid #d8e2ef;
  border-radius: 8px;
  background: #f7fbff;
  margin: 16px 0;
}

.payment-summary-box > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.summary-label {
  color: #5f6b7a;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.payment-methods-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 14px 0;
}

.payment-method-option {
  border: 1px solid #d0d7e2;
  background: #ffffff;
  border-radius: 8px;
  padding: 12px 14px;
  text-align: left;
  font-weight: 700;
  color: #1f2a3d;
  cursor: pointer;
}

.payment-method-option.active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
}

.payment-method-option:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.payment-modal-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.payment-modal-actions button {
  margin-left: 0;
}

.payment-modal-actions .btn-secondary {
  background: #e5edf6;
  color: #1e3a8a;
  border: none;
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}

.payment-modal-actions .btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.accept-visit-modal {
  background: linear-gradient(135deg, rgba(20, 134, 231, 0.1) 0%, #ffffff 55%);
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 18px 32px rgba(20, 134, 231, 0.12);
  color: #1e2a4a;
}

.accept-visit-modal__header {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 20px;
}

.accept-visit-modal__icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: rgba(20, 134, 231, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.accept-visit-modal__icon img {
  width: 32px;
  height: 32px;
}

.accept-visit-modal__heading {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.accept-visit-modal__eyebrow {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #1486e7;
}

.accept-visit-modal__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #0e1d3a;
}

.accept-visit-modal__content p {
  margin: 0 0 16px;
  line-height: 1.5;
}

.accept-visit-modal__professional {
  color: #1486e7;
  font-weight: 600;
}

.accept-visit-modal__note {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(20, 134, 231, 0.08);
  color: #0e1d3a;
}

.accept-visit-modal__note img {
  width: 20px;
  height: 20px;
  margin-top: 2px;
}

.accept-visit-modal__actions {
  margin-top: 26px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
}

.accept-visit-modal__button {
  border-radius: 999px;
  font-weight: 600;
  padding: 10px 22px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  border: none;
  cursor: pointer;
}

.accept-visit-modal__button--primary {
  background: #1486e7;
  color: #ffffff;
  box-shadow: 0 10px 20px rgba(20, 134, 231, 0.25);
}

.accept-visit-modal__button--primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(20, 134, 231, 0.28);
}

.accept-visit-modal__button--secondary {
  background: transparent;
  border: 1px solid rgba(20, 134, 231, 0.25);
  color: #0e1d3a;
}

.accept-visit-modal__button--secondary:hover:not(:disabled) {
  background: rgba(20, 134, 231, 0.08);
}

.accept-visit-modal__button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

/* Ensure context menu is above other elements */
.table-container {
  cursor: grab;
  overflow-x: auto;
  overflow-y: auto;   /* scroll vertical interno */
  flex: 1 1 auto;     /* ← ocupa el resto del alto */
  min-height: 0;      /* ← imprescindible para flexbox */
  height: calc(100vh / .75 - 170px);
}
.download-button {
  background-color: #007bff; /* Green background */
  color: white; /* White text */
  border: none; /* Remove border */
  padding: 8px 16px; /* Button padding */
  font-size: 14px; /* Font size */
  cursor: pointer; /* Pointer on hover */
  border-radius: 4px; /* Rounded corners */
  text-decoration: none; /* Remove underline for link buttons */
  display: inline-block;
  white-space: nowrap;
}
.red-button {
  background-color: #FF4136; /* Green background */
  color: white; /* White text */
  border: none; /* Remove border */
  padding: 8px 16px; /* Button padding */
  font-size: 14px; /* Font size */
  cursor: pointer; /* Pointer on hover */
  border-radius: 4px; /* Rounded corners */
  text-decoration: none; /* Remove underline for link buttons */
  display: inline-block;
  white-space: nowrap;
}
.red-button:hover{
  background-color: #ff7871;
}

.download-button:hover {
  background-color: #3589e4; /* Darker green on hover */
}

.orden-id-badge {
  display: inline-block;
  margin-top: 4px;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: #eef2f7;
  color: #5f6b7a;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
}

.solicitud-detail-link {
  color: #2563eb;
  font-weight: 800;
  text-decoration: none;
}

.solicitud-detail-link:hover {
  text-decoration: underline;
}

.green-button {
  background-color: #2ECC40;
  color: white;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  text-decoration: none;
  display: inline-block;
  white-space: nowrap;
}

.green-button:hover {
  background-color: #57e269;
}

.fotos-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.image-wrapper {
  position: relative;
  display: inline-block;
}

.image-wrapper img {
  width: 150px;
  height: auto;
  margin: 5px;
  border: 1px solid #ccc;
}

.hover-message {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  text-align: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  font-size: 14px;
}

.image-wrapper:hover .hover-message {
  opacity: 1;
}
.btn-outline {
  background: #f8fafc;
  border: 1px solid #d0d7e2;
  color: #3b4a67;
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}

.btn-outline:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-outline:not(:disabled):hover {
  background: #eef3ff;
}

.btn-primary {
  background: #5560f2;
  color: #ffffff;
  border: none;
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-primary:not(:disabled):hover {
  background: #3e46c9;
}

.budget-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 12000;
}

.budget-modal-dialog {
  background-color: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 24px 48px rgba(15, 30, 84, 0.25);
  display: flex;
  flex-direction: column;
  outline: none;
}

.budget-modal-dialog .modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid rgba(98, 114, 143, 0.15);
}

.budget-modal-dialog .modal-header h3 {
  margin: 0;
  font-size: 20px;
  color: #1f2a3d;
}

.budget-modal-dialog .modal-close {
  border: none;
  background: none;
  cursor: pointer;
  color: #6d7a91;
  display: flex;
  align-items: center;
  padding: 6px;
  border-radius: 8px;
}

.budget-modal-dialog .modal-close:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.budget-modal-dialog .modal-close:not(:disabled):hover {
  background: rgba(98, 114, 143, 0.1);
}

.budget-modal-dialog .modal-body {
  padding: 20px;
  color: #4f5d75;
  line-height: 1.5;
}

.modal-items {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.modal-items-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: #2c3e50;
}

.modal-selection-count {
  font-size: 12px;
  color: #5560f2;
}

.modal-select-all {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #2c3e50;
}

.modal-select-all input {
  width: 16px;
  height: 16px;
}

.modal-items-helper {
  font-size: 13px;
  color: #6d7a91;
}

.modal-selection-total {
  display: inline-block;
  margin-left: 8px;
  font-weight: 600;
  color: #1f2a3d;
}

.modal-items-list {
  border: 1px solid #d0d7e2;
  border-radius: 12px;
  overflow: hidden;
  background: #f7f9ff;
  max-height: 240px;
  overflow-y: auto;
}

.modal-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 16px;
  border-bottom: 1px solid #e3e8f5;
  gap: 12px;
}

.modal-item:last-child {
  border-bottom: none;
}

.modal-item-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.modal-item-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  color: #2c3e50;
}

.modal-item-checkbox input {
  width: 16px;
  height: 16px;
}

.modal-item-name {
  color: #2c3e50;
}

.modal-item-meta {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #7f8c8d;
}

.modal-item-price {
  font-weight: 500;
}

.modal-item-total {
  font-weight: 600;
  color: #1f2a3d;
  font-size: 14px;
  min-width: 100px;
  text-align: right;
}

.modal-items-empty {
  padding: 18px;
  border-radius: 12px;
  border: 1px dashed #d0d7e2;
  background: #fbfcff;
  color: #6d7a91;
  font-size: 14px;
  text-align: center;
}

.modal-error {
  margin-top: 14px;
  color: #c0392b;
  font-size: 14px;
}

.budget-modal-dialog .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px 20px;
  border-top: 1px solid rgba(98, 114, 143, 0.15);
}

.material-icons {
  font-size: 20px;
}

.profesional-clickable{
  font-weight: 700;
  cursor: pointer;
}
  @keyframes pulse{
    0%{box-shadow:0 0 0 0 rgba(16,185,129,.55)}
    70%{box-shadow:0 0 0 12px rgba(16,185,129,0)}
    100%{box-shadow:0 0 0 0 rgba(16,185,129,0)}
  }

  /* Inline badge that lives inside Estado cell */
  .status-badge{
    display:inline-flex;align-items:center;gap:6px;border:1px solid #d1fae5;background:#ecfdf5;color:#065f46;
    border-radius:999px;padding:6px 10px;font-size:12px;font-weight:700;cursor:pointer;user-select:none;
  }
  .status-badge .dot{width:8px;height:8px;border-radius:999px;background:var(--live);
    box-shadow:0 0 0 0 rgba(16,185,129,.6);animation:pulse 1.5s infinite;}
</style>
